import {
  faArrowDown,
  faArrowsUpDown,
  faArrowUp,
  faCheck,
  faCircle,
  faCopy,
  faFire,
  faFlagCheckered,
  faLink,
  faSignInAlt,
  faSpinner,
  faSquare,
  faTrophy,
  faUsd,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import { tokdecn, tokdecn2, useAppContext, useNowContext } from "../App";
import {
  CapsuleSwitch,
  F_OptionBtn_R2_rounded,
  F_OptionInput_Raw,
  InpOptionsWrap_Raw,
  set_state_ob,
} from "../components/input";
import {
  ToolTip,
  Card,
  Dropdown,
  Img,
  InpText,
  Tag,
} from "../components/utilityComps";
import {
  base64_to_json,
  cdelay,
  copy_clip,
  dec,
  disp_dec,
  emp,
  from_time_mini,
  getv,
  iso,
  iso_format,
  jparse,
  json_to_base64,
  jstr,
  nano,
  nils,
  toeth,
  tofeth,
  trim_n,
} from "./utils";
import { BY_Star, get_race_rtstatus, PosTag, RoundsInfo } from "./raceutils.js";
import { TokenIcon } from "../components/utilityComps.js";
import {
  btbk,
  qiserr,
  qissuccess,
  qissuccesss,
  q_arcade_open_hs_in,
  q_arcade_racerun,
  q_arcade_race_hstats,
  q_arcade_race_result,
  q_hstats,
  q_logtxnqueue,
  q_open_enter,
  q_open_hs_in,
  q_open_vault_valid_hs,
  q_race,
  q_racerun,
  q_race_result,
  useStepQuery,
  q_roadmap_entry_tickets,
  q_chain_create_race,
  q_chain_racedoc,
  q_bikes_stamina_map,
} from "../queries/queries";
import { useAccountContext } from "../wrappers/AccountWrapper";
import moment from "moment/moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  cb_cn,
  cb_cn_hex,
  cb_txt,
  class_text,
  elementmap,
  gendermap,
  get_payout_cn,
  get_payout_txt,
  get_cprofile_hex,
} from "./cn_map";
import { Loader01c } from "../components/anims";
import {
  mm_asset_signer,
  que_con_fn_runner,
  t3_asset_signer,
  t3_contract_call,
} from "../contracts/contract_funcs";
import { PopUp, PopupCloseBtn } from "../components/popup";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BikeCircle, RacePage_Run } from "../views/RacePage_Run";
import { useQueries } from "react-query";
import { useAuthContext } from "../wrappers/AuthWrapper";
import { ethers } from "ethers";
import { useRef } from "react";
import { contractAddress_list } from "../contracts/constants";
import {
  BikeImg,
  BikeSCircle,
  CarImg,
  HorseImg,
  RVImg,
} from "../components/BikeImg";
import { gen_filters_from_valob } from "./filt";
import { ErrorBoundary } from "./errbou";
import { fpost } from "../queries/fetch";
import { faction_img } from "./links";

import RaceStake from "../contracts/RaceStake/RaceStakeContract";
import RaceStakeV02 from "../contracts/RaceStakeV02/RaceStakeV02";
import RaceStakeV03_DEZ from "../contracts/RaceStakeV03_DEZ/RaceStakeV03_DEZ";
import RaceStakeV04_BGC from "../contracts/RaceStakeV04_BGC/RaceStakeV04_BGC";
import { QuestCardImg, RacePage_QuestCard } from "../views/QuestCards";
import { tokenaumode_locpath } from "../wrappers/MetaMaskWrapper.js";
import { useThirdWebLoginContext } from "../views/ThirdWebLogin.js";
import { RacePage_TrailsCard, TrailsCardImg } from "../views/TrailsCards.js";
import RacePage from "../views/RacePage.js";
import { def_roadmap_link, get_roadmap_status } from "../views/Roadmap.js";
import { useOverlayContext } from "../wrappers/OverlayWrapper.js";
import { polygon } from "thirdweb/chains";
import { use } from "react";
import { MiniElementTag } from "../components/ShortComps.js";

export const get_race3d_link = (r) => {
  let extq = r.is_arcade ? `&is_arcade=true` : ``;
  let link = nils(r.track)
    ? `https://3d.fbike.dnaracing.run/?race_id=${r.rid}${extq}`
    : r.track == "snow-bridge-horse"
      ? `https://3d.${"snow-bridge-h"}.fbike.dnaracing.run/?race_id=${r.rid}${extq}`
      : `https://3d.${r.track}.fbike.dnaracing.run/?race_id=${r.rid}${extq}`;
  return link;
};

export const RacesMidBreakBanner = () => {
  const c0 = get_cprofile_hex("acc0");
  const c4 = get_cprofile_hex("acc4");
  return (
    <div class="w-full relative">
      <div class="h-[5rem]"></div>
      <div class="absolute w-full top-0 left-0">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 711 161"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M326 57.5052H382.185L397.917 49.6211L662.072 15L692.804 25.6263L710 95.8969V126.747L699.756 148"
            stroke="url(#paint0_radial_2024_30)"
            stroke-width="1.3695"
          />
          <path
            opacity="0.6"
            d="M269.773 72.0944L370.774 69.6978L385.496 61.8231L632.691 27.2433L661.45 37.8569L677.542 108.044V138.857L667.955 160.085"
            stroke="url(#paint1_radial_2024_30)"
            stroke-width="1.3695"
          />
          <path
            d="M379 56.1542H324.481L307.878 46.6212L48.129 12.0001L17.9089 22.6263L0.999996 92.897V123.747L11.0734 145"
            stroke="url(#paint2_radial_2024_30)"
            stroke-width="1.3695"
          />
          <path
            opacity="0.6"
            d="M434.985 69.3651L333.985 66.9685L319.263 59.0938L72.068 24.514L43.3085 35.1276L27.2169 105.314V136.128L36.8034 157.355"
            stroke="url(#paint3_radial_2024_30)"
            stroke-width="1.3695"
          />
          <g filter="url(#filter0_f_2024_30)">
            <path
              d="M572.895 7.00003C572.895 7.00003 443.712 24.1188 359.938 24.1188C276.164 24.1187 146.981 6.99999 146.981 6.99999"
              stroke="url(#paint4_radial_2024_30)"
              stroke-width="1.3695"
            />
          </g>
          <path
            d="M572.895 7.00003C572.895 7.00003 443.712 24.1188 359.938 24.1188C276.164 24.1187 146.981 6.99999 146.981 6.99999"
            stroke="url(#paint5_radial_2024_30)"
            stroke-width="1.3695"
          />
          <defs>
            <filter
              id="filter0_f_2024_30"
              x="141.414"
              y="0.843353"
              width="437.048"
              height="29.4382"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="2.739"
                result="effect1_foregroundBlur_2024_30"
              />
            </filter>
            <radialGradient
              id="paint0_radial_2024_30"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(642.315 32.482) rotate(89.0041) scale(105.25 393.367)"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c0} stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint1_radial_2024_30"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(614.203 44.7044) rotate(92.7263) scale(35.9901 110.475)"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c0} stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint2_radial_2024_30"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(67.5562 29.482) rotate(90.9793) scale(105.25 386.808)"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c0} stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint3_radial_2024_30"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(90.5563 41.9751) rotate(87.2737) scale(35.9901 110.475)"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c0} stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint4_radial_2024_30"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(359.938 15.5596) rotate(-179.895) scale(186.252 4633.96)"
            >
              <stop stop-color={c4} />
              <stop offset="1" stop-color={c4} stop-opacity="0" />
            </radialGradient>
            <radialGradient
              id="paint5_radial_2024_30"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(359.938 15.5596) rotate(-179.895) scale(186.252 4633.96)"
            >
              <stop stop-color={c4} />
              <stop offset="1" stop-color={c4} stop-opacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export const svg_map = {
  result: (
    <svg
      // width="22"
      // height="25"
      width="100%"
      height="auto"
      aspectRatio="22/25"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 22 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3403 14.9563L18.7587 12.3747C18.4145 12.0305 17.8982 12.0305 17.554 12.3747L9.55093 20.3777V24.1641H13.3373L21.3403 16.1611C21.6845 15.8169 21.6845 15.3005 21.3403 14.9563ZM12.6489 22.443H11.272V21.0661L15.5747 16.7634L16.9516 18.1403L12.6489 22.443ZM18.1563 16.9356L16.7795 15.5587L18.1563 14.1818L19.5332 15.5587L18.1563 16.9356ZM4.3877 18.1403H6.10878V19.8614H4.3877V18.1403ZM7.82985 13.8376H11.272V15.5587H7.82985V13.8376ZM4.3877 13.8376H6.10878V15.5587H4.3877V13.8376ZM7.82985 9.53491H14.7142V11.256H7.82985V9.53491ZM4.3877 9.53491H6.10878V11.256H4.3877V9.53491Z"
        fill="white"
      />
      <path
        d="M1.80604 22.4431V4.37173H4.38766V6.95335H14.7141V4.37173H17.2958V9.53497H19.0168V4.37173C19.0168 3.42514 18.2424 2.65065 17.2958 2.65065H14.7141V1.79011C14.7141 0.843517 13.9397 0.0690308 12.9931 0.0690308H6.10874C5.16215 0.0690308 4.38766 0.843517 4.38766 1.79011V2.65065H1.80604C0.859447 2.65065 0.0849609 3.42514 0.0849609 4.37173V22.4431C0.0849609 23.3897 0.859447 24.1641 1.80604 24.1641H6.10874V22.4431H1.80604ZM6.10874 1.79011H12.9931V5.23227H6.10874V1.79011Z"
        fill="white"
      />
    </svg>
  ),
  stats: (
    <svg
      // width="25"
      // height="24"
      width="100%"
      height="auto"
      aspectRatio="25/24"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.57934 20.965H24.4717V23.9496H0.594727V0.0726929H3.57934V20.965ZM7.31011 19.4727C7.00754 19.4733 6.70799 19.4126 6.42955 19.2941C6.15111 19.1757 5.89957 19.0021 5.69013 18.7837C5.48069 18.5653 5.31769 18.3068 5.21099 18.0236C5.10429 17.7405 5.05609 17.4387 5.06932 17.1364C5.08254 16.8341 5.15692 16.5376 5.28794 16.2649C5.41897 15.9922 5.60392 15.7488 5.83164 15.5496C6.05935 15.3504 6.32509 15.1993 6.61281 15.1057C6.90053 15.012 7.20424 14.9777 7.50561 15.0047L9.91121 10.9949C9.69124 10.6571 9.56658 10.2662 9.55038 9.86338C9.53419 9.4606 9.62705 9.06092 9.81918 8.70654C10.0113 8.35217 10.2956 8.05625 10.6419 7.85004C10.9883 7.64382 11.3839 7.53497 11.787 7.53497C12.1901 7.53497 12.5858 7.64382 12.9321 7.85004C13.2785 8.05625 13.5628 8.35217 13.7549 8.70654C13.947 9.06092 14.0399 9.4606 14.0237 9.86338C14.0075 10.2662 13.8828 10.6571 13.6629 10.9949L16.0685 15.0047C16.1826 14.9945 16.2974 14.9935 16.4117 15.0017L20.3842 8.05057C20.0987 7.63241 19.9635 7.12982 20.0005 6.62486C20.0375 6.1199 20.2446 5.6424 20.588 5.27032C20.9314 4.89825 21.3908 4.65358 21.8911 4.57626C22.3915 4.49894 22.9033 4.59354 23.343 4.84462C23.7827 5.0957 24.1242 5.48842 24.3119 5.95866C24.4996 6.4289 24.5224 6.94889 24.3764 7.43371C24.2305 7.91853 23.9245 8.33956 23.5084 8.62804C23.0923 8.91653 22.5907 9.05543 22.0855 9.02206L18.1129 15.9732C18.3412 16.308 18.4743 16.6984 18.4981 17.1029C18.5218 17.5073 18.4354 17.9107 18.248 18.2699C18.0605 18.6291 17.7791 18.9307 17.4337 19.1425C17.0883 19.3543 16.6919 19.4684 16.2868 19.4726C15.8816 19.4768 15.4829 19.371 15.1332 19.1664C14.7835 18.9619 14.4959 18.6662 14.301 18.311C14.1061 17.9558 14.0113 17.5543 14.0266 17.1495C14.042 16.7446 14.1669 16.3515 14.3881 16.012L11.9825 12.0022C11.8525 12.0143 11.7216 12.0143 11.5915 12.0022L9.18594 16.012C9.4061 16.3498 9.53093 16.7409 9.54723 17.1437C9.56353 17.5466 9.4707 17.9465 9.27854 18.301C9.08639 18.6554 8.80206 18.9515 8.45557 19.1577C8.10909 19.364 7.71333 19.4728 7.31011 19.4727Z"
        fill="white"
      />
    </svg>
  ),
  bike: (
    <svg
      // width="56"
      // height="20"
      width="100%"
      height="auto"
      aspectRatio="xMidYMid meet"
      viewBox="0 0 56 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.9642 0.604794C30.9264 0.620996 30.5097 0.645535 29.9905 0.662209C29.3799 0.681715 29.077 0.700907 29.0643 0.72057C29.0539 0.736772 28.9503 0.758323 28.8337 0.768391C28.7173 0.778616 28.5547 0.803785 28.4725 0.824392C28.3902 0.844999 28.0745 0.873 27.7709 0.886843C27.4251 0.902574 27.1793 0.925854 27.1127 0.949136C27.0543 0.969586 26.9293 0.994755 26.835 1.00514C26.7407 1.01552 26.61 1.0399 26.5446 1.05925C26.479 1.0786 26.2826 1.10849 26.1079 1.12548C25.9332 1.14262 25.7784 1.16559 25.7638 1.17644C25.7492 1.18746 25.6974 1.20492 25.6485 1.2153C25.5998 1.22568 25.5104 1.25525 25.45 1.28121C25.3841 1.30952 25.2147 1.33894 25.0257 1.35483C24.8468 1.37009 24.7031 1.39447 24.6924 1.41146C24.6821 1.42797 24.6059 1.44827 24.523 1.45676C24.4192 1.46746 24.3645 1.48618 24.3479 1.51717C24.3309 1.54863 24.2778 1.56625 24.17 1.57584C24.069 1.58497 23.9647 1.61737 23.8651 1.67085C23.7564 1.72906 23.6424 1.76241 23.4601 1.78931C23.3121 1.81117 23.1871 1.84405 23.1598 1.86859C23.1341 1.89156 23.096 1.91043 23.0752 1.91043C23.0542 1.91043 22.9916 1.9345 22.9361 1.96407C22.8806 1.99349 22.759 2.02464 22.6658 2.03329C22.5307 2.04571 22.4887 2.06066 22.4583 2.10691C22.4047 2.18776 22.2723 2.24266 22.0791 2.26421C21.9449 2.279 21.8971 2.29803 21.8218 2.3663C21.7443 2.43662 21.6957 2.45502 21.5249 2.47941C21.3961 2.49781 21.3091 2.52408 21.2897 2.55035C21.2727 2.57332 21.2421 2.59204 21.2214 2.59204C21.2008 2.59204 21.1646 2.61438 21.1409 2.64159C21.1152 2.67148 21.0449 2.69853 20.9644 2.70954C20.8908 2.71946 20.817 2.744 20.8003 2.76397C20.7835 2.78411 20.7305 2.8077 20.6823 2.81667C20.6304 2.82627 20.5898 2.85175 20.5826 2.87897C20.5747 2.90917 20.5339 2.93088 20.4645 2.94189C20.4062 2.95101 20.3436 2.97649 20.3254 2.9982C20.3071 3.01991 20.2789 3.03769 20.2625 3.03784C20.246 3.03784 20.198 3.06726 20.1556 3.10328C20.1126 3.13994 20.0456 3.16888 20.0035 3.16888C19.9621 3.16888 19.9065 3.19043 19.88 3.2167C19.8533 3.24297 19.8117 3.27223 19.7872 3.28151C19.7629 3.29063 19.7429 3.31014 19.7429 3.32461C19.7429 3.33908 19.6745 3.37023 19.5908 3.39399C19.5071 3.41774 19.4198 3.45345 19.3969 3.47342C19.3739 3.4934 19.3417 3.5096 19.3253 3.5096C19.3091 3.5096 19.2863 3.52565 19.2745 3.54531C19.2629 3.56482 19.2083 3.59549 19.1532 3.61311C19.0981 3.63089 19.0147 3.68012 18.9679 3.7226C18.9212 3.76491 18.837 3.81336 18.7808 3.83004C18.7248 3.84671 18.6717 3.8788 18.663 3.9013C18.6346 3.97507 18.5414 4.03107 18.3932 4.06379C18.284 4.08786 18.2247 4.11979 18.155 4.19215C18.1041 4.24501 18.0269 4.29692 17.9832 4.30746C17.9083 4.32555 17.8683 4.35355 17.7647 4.45989C17.7401 4.48506 17.6828 4.51778 17.6372 4.53272C17.5915 4.54767 17.5419 4.58636 17.527 4.61877C17.5122 4.65117 17.4538 4.70104 17.3974 4.72951C17.2888 4.78425 17.0891 4.92551 17.0746 4.95776C17.0699 4.9683 17.0192 4.98938 16.962 5.00464C16.8812 5.02619 16.8499 5.05183 16.821 5.12042C16.7901 5.19388 16.7661 5.21134 16.6756 5.22644C16.6159 5.23651 16.5671 5.25633 16.5671 5.27048C16.5671 5.30525 16.4334 5.43534 16.3753 5.45705C16.3499 5.46649 16.3289 5.49245 16.3289 5.51447C16.3289 5.53649 16.3107 5.55458 16.2885 5.55458C16.2662 5.55458 16.2408 5.57299 16.2321 5.59548C16.2233 5.61797 16.1706 5.65447 16.1149 5.67665C16.059 5.69867 16.0068 5.73643 15.9987 5.76034C15.9907 5.78409 15.9374 5.83789 15.8802 5.87957C15.8232 5.92142 15.7625 5.9889 15.7454 6.0298C15.7227 6.08423 15.6901 6.10845 15.6228 6.12088C15.5598 6.13268 15.5237 6.15738 15.5074 6.20016C15.4942 6.23446 15.4731 6.26246 15.4605 6.26246C15.4097 6.26246 15.3725 6.39994 15.4034 6.47372C15.4359 6.55158 15.5115 6.57707 15.7095 6.57707C15.7727 6.57707 15.8753 6.59406 15.9377 6.61467C16.0001 6.63527 16.0987 6.66028 16.157 6.67035C16.2152 6.68042 16.3105 6.70936 16.3686 6.73485C16.4393 6.76584 16.5827 6.78739 16.7999 6.80013C17.0106 6.8124 17.1373 6.83112 17.1599 6.85345C17.1791 6.87249 17.241 6.89609 17.2977 6.90584C17.3544 6.91575 17.4276 6.94044 17.4605 6.96089C17.4934 6.98134 17.6479 7.00997 17.8041 7.0246C17.9602 7.03923 18.1228 7.06849 18.1652 7.08941C18.2078 7.11049 18.2562 7.12764 18.2727 7.12764C18.2892 7.12764 18.3478 7.15045 18.4031 7.17845C18.4721 7.21321 18.6031 7.2376 18.8215 7.256C18.9965 7.27079 19.1534 7.29297 19.17 7.30524C19.2786 7.38515 19.5678 7.46962 19.8092 7.49196C19.9548 7.50533 20.1096 7.53506 20.1533 7.55787C20.1969 7.58068 20.2565 7.5994 20.2855 7.59956C20.3146 7.59971 20.3741 7.61859 20.4178 7.64156C20.4615 7.66437 20.6104 7.69331 20.7487 7.70574C20.9124 7.72052 21.0366 7.74711 21.1049 7.78203C21.1625 7.81145 21.2284 7.83551 21.2511 7.83551C21.274 7.83551 21.3183 7.85329 21.3496 7.875C21.3809 7.89686 21.5101 7.92502 21.6365 7.93776C21.7631 7.95035 21.8742 7.973 21.8836 7.98795C21.893 8.00289 21.96 8.02947 22.0325 8.04709C22.1051 8.06455 22.1824 8.09381 22.2042 8.11206C22.2261 8.13015 22.3511 8.15359 22.4821 8.16381C22.6201 8.17467 22.7669 8.2033 22.8314 8.23193C22.8924 8.25898 22.957 8.28132 22.9748 8.28132C22.9926 8.28132 23.0285 8.3002 23.0542 8.32332C23.0855 8.35132 23.2054 8.37743 23.4115 8.40119C23.5822 8.42085 23.7287 8.44681 23.7372 8.45892C23.7829 8.5242 24.006 8.60207 24.2062 8.62252C24.4026 8.64249 24.5497 8.68513 24.6654 8.75544C24.7591 8.81223 24.8368 8.83158 25.0373 8.84825C25.2058 8.86209 25.2555 8.87594 25.2763 8.91432C25.2908 8.94106 25.329 8.96293 25.3616 8.96293C25.394 8.96293 25.4634 8.98558 25.5156 9.01342C25.5698 9.04205 25.695 9.07147 25.8064 9.08138C25.9328 9.09271 26.0274 9.11646 26.0738 9.14886C26.1131 9.17639 26.1632 9.19889 26.1849 9.19889C26.2065 9.19889 26.234 9.21588 26.2457 9.23664C26.2595 9.26134 26.3499 9.28462 26.505 9.30349C26.7264 9.33039 26.9268 9.39741 27.0209 9.47606C27.0427 9.49431 27.1477 9.52121 27.2542 9.53568C27.3606 9.55015 27.4738 9.57878 27.5056 9.59923C27.5373 9.61952 27.5991 9.645 27.6428 9.65554C27.6864 9.66624 27.7401 9.69015 27.7619 9.70871C27.7838 9.72728 27.8657 9.74961 27.9442 9.75827C28.0226 9.76692 28.106 9.79098 28.1295 9.81175C28.153 9.83251 28.2257 9.8635 28.2913 9.88065C28.3567 9.8978 28.4224 9.92171 28.4372 9.93366C28.4521 9.94578 28.5474 9.96921 28.649 9.98589C28.7507 10.0026 28.8661 10.0387 28.9055 10.0663C28.9449 10.094 28.9942 10.1164 29.015 10.1164C29.036 10.1164 29.059 10.1319 29.0663 10.1507C29.074 10.1704 29.1654 10.1981 29.2826 10.2162C29.3944 10.2333 29.5036 10.2651 29.5256 10.2868C29.5475 10.3085 29.5808 10.3263 29.5995 10.3263C29.6184 10.3263 29.6623 10.3483 29.6969 10.3754C29.7317 10.4024 29.8255 10.4331 29.9055 10.4435C29.9857 10.4539 30.1032 10.4849 30.1671 10.5124C30.2307 10.5398 30.2944 10.5623 30.3084 10.5623C30.3225 10.5623 30.3657 10.5841 30.4043 10.611C30.443 10.6379 30.5201 10.668 30.5758 10.678C30.6314 10.6881 30.7147 10.7192 30.7609 10.7472C30.8073 10.7751 30.8646 10.7981 30.8886 10.7981C30.9124 10.7981 30.9383 10.8143 30.9459 10.8339C30.9543 10.8556 31.035 10.881 31.1489 10.8976C31.2529 10.9129 31.3532 10.9381 31.3721 10.9536C31.4506 11.018 31.6618 11.1136 31.7602 11.1292C31.8201 11.1388 31.8766 11.1657 31.8904 11.1915C31.9041 11.2165 31.9519 11.2442 31.997 11.2531C32.0419 11.2621 32.0951 11.2855 32.1149 11.3052C32.1348 11.3249 32.219 11.3489 32.3018 11.3585C32.389 11.3688 32.4808 11.398 32.5192 11.4281C32.5558 11.4565 32.598 11.4798 32.6131 11.4798C32.6282 11.4798 32.6602 11.4974 32.6844 11.5191C32.7085 11.5407 32.7987 11.5718 32.8849 11.5882C32.9711 11.6046 33.0537 11.6322 33.0683 11.6499C33.0829 11.6675 33.1201 11.6898 33.1512 11.6996C33.1822 11.7093 33.2325 11.7389 33.2633 11.7653C33.2949 11.7925 33.3834 11.8209 33.4666 11.8306C33.6142 11.8478 33.6481 11.8644 33.7468 11.9683C33.7803 12.0035 33.8486 12.0305 33.9307 12.0414C34.0188 12.0529 34.0719 12.0752 34.0938 12.11C34.1117 12.1383 34.1467 12.1614 34.1714 12.1614C34.1964 12.1614 34.2267 12.179 34.2389 12.2006C34.2512 12.2221 34.332 12.2528 34.4188 12.2686C34.5057 12.2844 34.5862 12.314 34.5978 12.3343C34.6095 12.3546 34.6359 12.3713 34.6564 12.3713C34.677 12.3713 34.7064 12.3944 34.7218 12.4229C34.7412 12.4589 34.7893 12.4797 34.8811 12.4916C34.9757 12.5042 35.0585 12.541 35.1769 12.6236C35.2841 12.6983 35.3694 12.7383 35.4221 12.7383C35.4665 12.7384 35.5685 12.7773 35.6485 12.8246C35.7285 12.8721 35.8387 12.9316 35.8934 12.9569C35.9478 12.9822 35.9926 13.0139 35.9926 13.0274C35.9926 13.0409 36.0215 13.059 36.0568 13.0678C36.0922 13.0766 36.1271 13.0993 36.1344 13.1182C36.1417 13.1372 36.2105 13.166 36.287 13.1822C36.3637 13.1985 36.4449 13.2286 36.4676 13.2492C36.4901 13.2696 36.5342 13.3093 36.5655 13.3374C36.5968 13.3654 36.6618 13.3969 36.71 13.4074C36.7929 13.4255 36.8925 13.4826 37.0114 13.5805C37.0406 13.6044 37.1061 13.6326 37.157 13.6431C37.208 13.6536 37.2675 13.6779 37.2893 13.697C37.3112 13.7164 37.3568 13.7571 37.3906 13.7877C37.4246 13.8185 37.5191 13.8558 37.6023 13.8712C37.726 13.8942 37.7619 13.9135 37.8058 13.9807C37.8425 14.037 37.8921 14.0703 37.9657 14.0884C38.0293 14.1042 38.1118 14.1539 38.1701 14.2118C38.2295 14.2707 38.3046 14.3156 38.3615 14.3263C38.4131 14.3359 38.4672 14.3659 38.482 14.393C38.4966 14.4202 38.5249 14.4424 38.5445 14.4424C38.5644 14.4424 38.5868 14.4586 38.5944 14.4782C38.602 14.4979 38.6641 14.5303 38.7325 14.5503C38.8454 14.5833 38.9831 14.6827 38.9831 14.7313C38.9831 14.742 39.0365 14.7641 39.1016 14.7804C39.1726 14.798 39.2551 14.8448 39.3078 14.897C39.3615 14.95 39.4433 14.9959 39.5173 15.0143C39.5841 15.031 39.6458 15.0626 39.6542 15.0843C39.6626 15.1062 39.6864 15.1241 39.707 15.1241C39.7275 15.1241 39.7507 15.1477 39.7583 15.1765C39.766 15.2053 39.7944 15.2289 39.8215 15.2289C39.8692 15.2289 40.0611 15.3659 40.1008 15.4284C40.1116 15.4452 40.1606 15.4664 40.2098 15.4755C40.2588 15.4847 40.3205 15.5155 40.3465 15.5441C40.3727 15.5726 40.41 15.596 40.4295 15.596C40.4491 15.596 40.4651 15.6126 40.4651 15.6327C40.4651 15.653 40.5005 15.6818 40.5439 15.6967C40.5871 15.7117 40.6647 15.7656 40.7163 15.8169C40.7679 15.868 40.8421 15.9177 40.8808 15.9275C40.9197 15.9371 40.9912 15.9843 41.0396 16.0323C41.0882 16.0804 41.1603 16.1276 41.2002 16.1373C41.2399 16.1469 41.3178 16.201 41.3736 16.2575C41.4369 16.3219 41.5074 16.3654 41.5625 16.3744C41.6108 16.3821 41.6784 16.4167 41.7127 16.4513C41.747 16.4859 41.787 16.526 41.8017 16.5405C41.8472 16.586 42.0113 16.6966 42.0573 16.7128C42.0814 16.7213 42.107 16.7507 42.1143 16.7782C42.1216 16.8057 42.1467 16.8282 42.1702 16.8282C42.2212 16.8282 42.4235 16.9545 42.4689 17.0148C42.4867 17.0381 42.5343 17.0642 42.5748 17.0727C42.6153 17.0812 42.6915 17.1279 42.7441 17.1763C42.7966 17.2248 42.8779 17.2803 42.9248 17.2995C42.9716 17.3187 43.0577 17.3797 43.116 17.4353C43.1742 17.4908 43.2432 17.5361 43.269 17.5361C43.2951 17.5361 43.3465 17.5597 43.3835 17.5885C43.4205 17.6174 43.461 17.641 43.4734 17.641C43.4858 17.641 43.5098 17.6629 43.5266 17.6898C43.5436 17.7165 43.596 17.7461 43.6431 17.7554C43.6903 17.7648 43.7456 17.796 43.7659 17.8248C43.7862 17.8534 43.8186 17.877 43.8381 17.877C43.8575 17.877 43.8801 17.894 43.8882 17.9147C43.8963 17.9357 43.9482 17.9605 44.0034 17.9701C44.0589 17.9797 44.116 18.0011 44.1306 18.0175C44.1451 18.034 44.2018 18.0678 44.2562 18.0928C44.3109 18.1178 44.3555 18.149 44.3555 18.1619C44.3555 18.1749 44.409 18.1935 44.4743 18.2032C44.5394 18.2128 44.6019 18.2348 44.6132 18.252C44.6423 18.297 44.9195 18.4275 44.9857 18.4275C45.0165 18.4275 45.054 18.4502 45.0689 18.4777C45.0839 18.5054 45.135 18.5362 45.1823 18.5463C45.2298 18.5562 45.2865 18.5798 45.3082 18.5987C45.3301 18.6176 45.458 18.6453 45.5925 18.66C45.78 18.6807 45.8829 18.7085 46.0345 18.7799C46.2149 18.8647 46.2597 18.8743 46.5444 18.8894C46.7161 18.8985 46.8922 18.9213 46.9358 18.9404C47.1753 19.0442 48.9302 19.0528 49.0543 18.9509C49.0714 18.9367 49.268 18.91 49.4909 18.8913C49.755 18.8691 49.9003 18.8463 49.9071 18.8258C49.9128 18.8087 49.929 18.7945 49.9432 18.7945C49.9571 18.7945 50.0187 18.77 50.0799 18.7401C50.1464 18.7074 50.2949 18.6737 50.4491 18.6561C50.591 18.6401 50.7071 18.6174 50.7071 18.6061C50.7071 18.5948 50.7514 18.5672 50.8054 18.5447C50.8595 18.5224 50.9108 18.4928 50.9196 18.479C50.9281 18.4651 51.006 18.4409 51.0925 18.4252C51.1789 18.4095 51.2676 18.3818 51.2894 18.3637C51.3111 18.3454 51.3499 18.3233 51.3755 18.3143C51.4009 18.3053 51.4217 18.2816 51.4217 18.2613C51.4217 18.2375 51.4755 18.2141 51.5747 18.1947C51.6591 18.1784 51.748 18.1444 51.7724 18.1192C51.8787 18.0101 51.9177 17.9869 52.0238 17.9695C52.0864 17.9593 52.1362 17.9364 52.1362 17.9182C52.1362 17.9001 52.1661 17.8719 52.2024 17.8554C52.2388 17.8391 52.2687 17.8148 52.2687 17.8016C52.2687 17.7886 52.3014 17.7702 52.3414 17.7609C52.4892 17.7266 52.5559 17.6871 52.5856 17.6162C52.607 17.565 52.6469 17.5342 52.7202 17.5125C52.7774 17.4955 52.8244 17.4672 52.8244 17.4496C52.8244 17.432 52.8616 17.3882 52.9071 17.3524C52.9526 17.3163 53.0421 17.2378 53.106 17.1776C53.1698 17.1175 53.2565 17.0607 53.2986 17.0516C53.3499 17.0404 53.3856 17.0094 53.4073 16.9574C53.4256 16.914 53.4778 16.862 53.5266 16.8391C53.5755 16.8161 53.6276 16.7644 53.646 16.7205C53.6639 16.6777 53.7006 16.631 53.7278 16.6165C53.7549 16.6022 53.7772 16.5781 53.7772 16.5632C53.7772 16.5268 53.924 16.3826 53.961 16.3826C53.9771 16.3826 54.0015 16.353 54.0153 16.317C54.0292 16.281 54.0527 16.2514 54.0676 16.2514C54.0825 16.2514 54.0947 16.2358 54.0947 16.2168C54.0947 16.1977 54.1241 16.1568 54.1602 16.1259C54.1962 16.0949 54.2332 16.0396 54.2424 16.0032C54.2516 15.9667 54.2743 15.9368 54.2929 15.9368C54.3388 15.9368 54.4495 15.7883 54.493 15.6681C54.5127 15.614 54.5382 15.5698 54.5498 15.5698C54.5616 15.5698 54.5711 15.5528 54.5711 15.5319C54.5711 15.5111 54.5935 15.4785 54.621 15.4593C54.6486 15.4403 54.6896 15.3807 54.7123 15.3269C54.735 15.2729 54.7656 15.2289 54.7802 15.2289C54.7949 15.2289 54.8145 15.188 54.8241 15.1381C54.8346 15.0824 54.8604 15.0412 54.8906 15.0316C54.9179 15.0231 54.9511 14.9759 54.9649 14.9262C54.9787 14.8768 55.0089 14.8177 55.0319 14.7949C55.0551 14.7719 55.0738 14.7156 55.0738 14.6697C55.0738 14.6145 55.0919 14.575 55.1269 14.5534C55.1591 14.5334 55.1798 14.4922 55.1798 14.4477C55.1798 14.4076 55.2036 14.3286 55.2326 14.272C55.2619 14.2154 55.2857 14.1543 55.2857 14.1362C55.2857 14.1182 55.3085 14.0913 55.3365 14.0765C55.3755 14.0559 55.3914 14.0087 55.4054 13.8724C55.4152 13.7749 55.4394 13.6701 55.4588 13.6396C55.4783 13.609 55.5139 13.5086 55.5378 13.4167C55.5618 13.3247 55.5928 13.236 55.6064 13.2196C55.6202 13.2031 55.6433 13.0497 55.6576 12.8787C55.672 12.7078 55.7041 12.4911 55.729 12.3974C55.7841 12.1894 55.7981 10.7561 55.7457 10.6908C55.7155 10.6533 55.6711 10.3815 55.641 10.051C55.6318 9.95002 55.6077 9.82764 55.5874 9.77903C55.5669 9.73042 55.5502 9.67064 55.5502 9.64626C55.5502 9.62188 55.5261 9.55251 55.4965 9.49195C55.4672 9.43154 55.4313 9.32096 55.417 9.24639C55.4027 9.17183 55.3733 9.09129 55.3516 9.06753C55.3298 9.04378 55.312 8.99675 55.312 8.96293C55.312 8.92911 55.2958 8.88286 55.276 8.86005C55.256 8.8374 55.2187 8.75088 55.1929 8.66798C55.1672 8.58508 55.1367 8.51728 55.1253 8.51728C55.1139 8.51728 55.0897 8.47292 55.0718 8.41896C55.0538 8.36485 55.0172 8.28808 54.9903 8.24844C54.9635 8.2088 54.9195 8.14368 54.8923 8.10372C54.8654 8.06392 54.8347 8.00493 54.8244 7.97269C54.8141 7.9406 54.7953 7.91417 54.7828 7.91417C54.7701 7.91417 54.7447 7.87296 54.7263 7.82262C54.7078 7.77212 54.6723 7.72446 54.647 7.71644C54.5926 7.69945 54.5025 7.52216 54.4771 7.38263C54.4668 7.326 54.4377 7.2722 54.4091 7.2571C54.3818 7.24263 54.3593 7.2173 54.3593 7.20094C54.3593 7.18458 54.3058 7.12025 54.2402 7.05811C54.1748 6.99598 54.1211 6.92125 54.1211 6.89215C54.1211 6.86305 54.1097 6.8393 54.0955 6.8393C54.06 6.8393 53.9234 6.70354 53.9012 6.64597C53.891 6.61985 53.8589 6.59217 53.8299 6.58462C53.8008 6.57723 53.7772 6.55568 53.7772 6.53696C53.7772 6.51824 53.7235 6.45626 53.6581 6.399C53.5925 6.3419 53.539 6.28416 53.539 6.27064C53.539 6.24578 53.3964 6.13142 53.3654 6.13142C53.3406 6.13142 53.2035 5.98167 53.1855 5.9351C53.1769 5.91339 53.1488 5.89515 53.1229 5.89452C53.0656 5.89358 52.9756 5.822 52.9334 5.74398C52.9162 5.7122 52.8698 5.67854 52.8303 5.66894C52.7906 5.65935 52.7185 5.60618 52.6701 5.55065C52.6216 5.49512 52.5656 5.44982 52.5454 5.44982C52.5253 5.44982 52.4875 5.42748 52.4614 5.40042C52.3908 5.32649 52.2139 5.21386 52.1686 5.21386C52.1469 5.21386 52.0791 5.16824 52.0181 5.11255C51.9361 5.03767 51.8752 5.00668 51.784 4.993C51.7162 4.98293 51.6516 4.96059 51.6405 4.94329C51.599 4.87895 51.4025 4.77387 51.2883 4.75499C51.2233 4.7443 51.1387 4.71331 51.1001 4.68625C51.0614 4.6592 51.0164 4.63701 50.9999 4.63701C50.9836 4.63701 50.9637 4.62018 50.9556 4.59958C50.9477 4.57913 50.8943 4.55443 50.8368 4.54483C50.7795 4.53524 50.7176 4.51243 50.6992 4.49418C50.6807 4.47609 50.6066 4.45249 50.5343 4.44195C50.4619 4.43126 50.384 4.40593 50.3608 4.38548C50.3378 4.36503 50.2245 4.3364 50.1094 4.32193C49.8577 4.29015 49.4347 4.17784 49.4084 4.13584C49.3552 4.05042 46.8471 4.06128 46.6522 4.14764C46.5981 4.17171 46.5349 4.19137 46.5119 4.19137C46.4887 4.19137 46.4199 4.21355 46.3588 4.24092C46.2978 4.26813 46.15 4.29881 46.0304 4.30903C45.8967 4.32051 45.8014 4.34175 45.7824 4.3644C45.7655 4.38454 45.7416 4.40106 45.7293 4.40106C45.7169 4.40106 45.6417 4.43063 45.5621 4.46665C45.4826 4.50268 45.39 4.53225 45.3563 4.53241C45.2144 4.53304 45.0891 4.56796 45.078 4.6098C45.0621 4.66989 44.9254 4.73675 44.7533 4.76852C44.6737 4.78315 44.5987 4.81273 44.5867 4.83412C44.5745 4.85551 44.547 4.87297 44.5254 4.87297C44.5038 4.87297 44.4793 4.89059 44.4709 4.9123C44.4627 4.93385 44.4422 4.95194 44.4255 4.95226C44.3248 4.95414 44.2635 5.05057 44.3064 5.13976C44.3296 5.18774 44.3575 5.26844 44.3688 5.31878C44.3799 5.36912 44.4114 5.4259 44.4385 5.44462C44.4674 5.46476 44.4879 5.51054 44.4879 5.55521C44.4879 5.6046 44.5065 5.64126 44.5408 5.6595C44.5783 5.67932 44.5937 5.7144 44.5937 5.77905C44.5937 5.85252 44.6067 5.87548 44.6599 5.89546C44.7134 5.9156 44.7261 5.93825 44.7261 6.0136C44.7261 6.07007 44.7409 6.11254 44.7637 6.1212C44.7845 6.12906 44.8093 6.18144 44.8188 6.2376C44.8285 6.29376 44.8592 6.36832 44.887 6.40356C44.9149 6.43864 44.9378 6.48442 44.9378 6.50518C44.9378 6.52595 44.9606 6.56905 44.9886 6.60098C45.0176 6.63417 45.0526 6.73673 45.0704 6.84087C45.0907 6.96042 45.1135 7.02287 45.1369 7.02287C45.1564 7.02287 45.1794 7.04505 45.1882 7.07211C45.213 7.14935 45.3575 7.16649 45.4281 7.10074C45.46 7.07117 45.5456 7.03766 45.6196 7.02618C45.6931 7.01469 45.7732 6.98559 45.7973 6.96168C45.8214 6.93761 45.8694 6.91103 45.9037 6.90253C45.938 6.89404 45.9718 6.87202 45.979 6.85377C45.9861 6.83536 46.0529 6.8124 46.1277 6.80264C46.2522 6.78613 46.3504 6.74932 46.5654 6.63779C46.613 6.61309 46.7715 6.58666 46.9623 6.57141C47.137 6.55756 47.319 6.52956 47.3668 6.50927C47.4919 6.45594 48.7543 6.45531 48.808 6.50833C48.8299 6.53003 48.9547 6.55536 49.1208 6.57172C49.3796 6.59736 49.456 6.61954 49.7677 6.76002C49.7968 6.77323 49.8831 6.79163 49.9597 6.80091C50.0361 6.81035 50.1075 6.83238 50.1185 6.84984C50.1293 6.8673 50.1798 6.89797 50.2307 6.91795C50.2817 6.93793 50.3322 6.96829 50.3428 6.98543C50.3535 7.00258 50.4308 7.02523 50.5146 7.03546C50.6484 7.05213 50.6779 7.06692 50.7554 7.15658C50.8038 7.21274 50.8648 7.25883 50.8908 7.25883C50.9583 7.25883 51.0957 7.35731 51.2873 7.54308C51.3789 7.6318 51.4674 7.70448 51.4842 7.70448C51.5212 7.70448 51.6438 7.83142 51.6675 7.8945C51.677 7.91983 51.7078 7.94044 51.7361 7.94044C51.7643 7.94044 51.8186 7.97882 51.8567 8.0257C51.8947 8.07258 51.9662 8.15422 52.0154 8.20707C52.0646 8.25993 52.1127 8.32788 52.1224 8.35777C52.1319 8.38782 52.1565 8.41236 52.177 8.41236C52.1975 8.41236 52.2342 8.45074 52.2583 8.49762C52.2826 8.54449 52.312 8.58885 52.3236 8.5964C52.3557 8.61717 52.4803 8.80452 52.4803 8.83205C52.4803 8.84542 52.5021 8.86776 52.5286 8.88176C52.5551 8.89591 52.5913 8.95522 52.6091 9.0139C52.6267 9.07241 52.6517 9.12023 52.6645 9.12023C52.6774 9.12023 52.6963 9.15862 52.7064 9.20549C52.7168 9.25237 52.7474 9.3219 52.7747 9.36028C52.802 9.39851 52.8244 9.44066 52.8244 9.45372C52.8244 9.46693 52.8601 9.54685 52.9038 9.63148C52.9475 9.71611 52.9832 9.81033 52.9832 9.84101C52.9832 9.87168 53.0007 9.91966 53.022 9.94766C53.0434 9.97566 53.0612 10.0188 53.0617 10.0436C53.0621 10.0683 53.0907 10.1745 53.125 10.2796C53.1595 10.3845 53.196 10.5577 53.2065 10.6645C53.2168 10.7712 53.2435 10.886 53.2659 10.9197C53.3162 10.9958 53.3075 12.1899 53.2559 12.2794C53.2392 12.3083 53.2112 12.4204 53.1936 12.5286C53.1761 12.6366 53.1504 12.7323 53.1364 12.7411C53.1226 12.7499 53.0986 12.8501 53.0834 12.964C53.068 13.0777 53.0402 13.1833 53.0215 13.1984C53.0029 13.2135 52.9791 13.2704 52.9688 13.325C52.9584 13.3794 52.934 13.4303 52.9143 13.4376C52.8948 13.445 52.8709 13.4943 52.8616 13.547C52.852 13.5997 52.8233 13.6664 52.7974 13.6952C52.7717 13.7241 52.7428 13.7848 52.7331 13.8301C52.7234 13.8754 52.6923 13.9333 52.664 13.9588C52.6358 13.9841 52.6126 14.0277 52.6126 14.0557C52.6126 14.0845 52.5897 14.1125 52.5597 14.1202C52.5251 14.1292 52.5068 14.1559 52.5068 14.1976C52.5068 14.2327 52.477 14.2887 52.4406 14.3222C52.4043 14.3555 52.3744 14.4018 52.3744 14.4249C52.3744 14.4479 52.3417 14.5017 52.3017 14.5441C52.2617 14.5866 52.1783 14.6745 52.1164 14.7395C52.0546 14.8045 52.0039 14.8704 52.0039 14.886C52.0039 14.9015 51.986 14.9143 51.9642 14.9143C51.9425 14.9143 51.9246 14.9317 51.9246 14.953C51.9246 14.9744 51.8968 15.0098 51.8628 15.0319C51.8288 15.054 51.7858 15.1001 51.7672 15.1345C51.7486 15.1688 51.7021 15.213 51.6637 15.2325C51.6252 15.252 51.5519 15.3123 51.5006 15.3665C51.4493 15.4206 51.3886 15.4648 51.3659 15.4648C51.3431 15.4648 51.2737 15.5185 51.2117 15.5841C51.1476 15.6519 51.066 15.7098 51.0221 15.7184C50.9799 15.7268 50.9453 15.7499 50.9453 15.7697C50.9453 15.7895 50.9339 15.8057 50.9199 15.8057C50.9059 15.8057 50.8732 15.8282 50.8472 15.8556C50.8211 15.8831 50.7466 15.9196 50.6817 15.9368C50.6166 15.9541 50.5347 15.9906 50.4994 16.0179C50.4642 16.0455 50.4203 16.068 50.4021 16.068C50.3838 16.068 50.3625 16.0842 50.3548 16.104C50.3467 16.1251 50.2798 16.1476 50.1931 16.1583C50.0907 16.171 50.0375 16.1911 50.0197 16.224C50.0056 16.2501 49.9532 16.2791 49.9033 16.2883C49.8533 16.2976 49.8063 16.3211 49.7988 16.3403C49.7904 16.3621 49.7169 16.3819 49.603 16.3931C49.5028 16.4029 49.3895 16.4269 49.3512 16.4466C49.3129 16.4664 49.2423 16.491 49.1941 16.5015C49.1462 16.5119 49.0773 16.5396 49.0414 16.563C48.9423 16.6272 47.0592 16.6272 46.9849 16.5628C46.9579 16.5394 46.8914 16.5061 46.8371 16.4888C46.7826 16.4714 46.7319 16.4474 46.7243 16.4351C46.7165 16.4228 46.6302 16.4044 46.532 16.3942C46.3415 16.3744 46.2932 16.3588 46.1684 16.2776C46.0566 16.205 45.9761 16.1727 45.9059 16.1727C45.8149 16.1727 45.6849 16.1216 45.6685 16.0791C45.6606 16.0585 45.6376 16.0417 45.6176 16.0417C45.5975 16.0417 45.5609 16.0195 45.5361 15.9925C45.5113 15.9652 45.447 15.9361 45.393 15.9275C45.3341 15.918 45.2438 15.8698 45.1664 15.8064C45.0958 15.7483 45.0243 15.7007 45.0076 15.7005C44.9911 15.7003 44.9244 15.6527 44.8595 15.5948C44.7947 15.5367 44.714 15.4825 44.6802 15.4741C44.6464 15.4658 44.6068 15.4367 44.5921 15.4095C44.5775 15.3823 44.5479 15.3601 44.5267 15.3601C44.5054 15.3601 44.4876 15.3453 44.4874 15.3272C44.4871 15.3093 44.4395 15.2482 44.3815 15.1916C44.3236 15.135 44.2761 15.0783 44.2761 15.0656C44.2761 15.053 44.2404 15.0304 44.1967 15.0153C44.153 15.0002 44.1173 14.9759 44.1173 14.9615C44.1173 14.9294 43.9604 14.7261 43.9129 14.6967C43.8944 14.6852 43.8791 14.6536 43.8791 14.6264C43.8791 14.5992 43.8561 14.5698 43.8278 14.561C43.7997 14.552 43.763 14.5042 43.7465 14.4545C43.73 14.4048 43.7014 14.3552 43.6832 14.3444C43.6651 14.3334 43.6273 14.2832 43.5995 14.2327C43.5718 14.1822 43.529 14.1174 43.5045 14.0884C43.4801 14.0596 43.4389 13.9829 43.4134 13.9181C43.3878 13.8533 43.3511 13.7906 43.3319 13.7792C43.3127 13.7675 43.297 13.7357 43.297 13.7084C43.297 13.6808 43.2779 13.648 43.2546 13.6351C43.229 13.6208 43.1965 13.5352 43.172 13.4177C43.1457 13.2907 43.1145 13.2119 43.082 13.1893C43.0547 13.1704 43.0323 13.1285 43.0323 13.0966C43.0323 13.0645 43.0159 13.0151 42.9959 12.9867C42.9757 12.9582 42.9511 12.8465 42.9411 12.7383C42.9311 12.6302 42.8991 12.4683 42.8698 12.3787C42.8054 12.1803 42.8028 10.7528 42.8668 10.6894C42.96 10.5972 42.7895 10.3263 42.6383 10.3263C42.6212 10.3263 42.5805 10.3095 42.5483 10.289C42.516 10.2684 42.4322 10.2434 42.3619 10.2332C42.2917 10.2231 42.2282 10.1994 42.2207 10.1803C42.2134 10.1614 42.1697 10.138 42.1237 10.1281C42.0775 10.1183 42.0201 10.0899 41.9962 10.0649C41.9704 10.0383 41.8915 10.0123 41.8045 10.0022C41.7007 9.99013 41.6127 9.95726 41.51 9.89213C41.4133 9.83078 41.3178 9.79382 41.2298 9.78359C41.1563 9.77494 41.0807 9.7526 41.0618 9.73372C41.0428 9.71501 40.9931 9.69125 40.9513 9.68118C40.9096 9.67112 40.8351 9.6417 40.7859 9.61575C40.7366 9.58995 40.6295 9.56085 40.5477 9.55109C40.4659 9.54134 40.3811 9.51806 40.3594 9.49934C40.3374 9.48046 40.2839 9.45671 40.2403 9.44633C40.1966 9.43595 40.1394 9.40559 40.1135 9.37869C40.0862 9.35069 40.0294 9.32992 39.9798 9.32992C39.8506 9.32992 39.4606 9.21037 39.4228 9.15924C39.3996 9.12778 39.3282 9.10812 39.1799 9.09239C38.9868 9.0721 38.7378 8.9807 38.6933 8.91416C38.6854 8.90205 38.5607 8.87924 38.4164 8.86319C38.2721 8.84715 38.1471 8.8234 38.1385 8.8105C38.1063 8.76142 37.8522 8.66641 37.7009 8.6469C37.6074 8.63479 37.5308 8.60962 37.5127 8.58508C37.4959 8.56211 37.4184 8.53159 37.3407 8.51696C37.2631 8.50233 37.1929 8.48047 37.1848 8.46836C37.1769 8.4564 37.0664 8.43328 36.9393 8.41739C36.8125 8.40134 36.6754 8.37161 36.6351 8.35132C36.5946 8.33103 36.5139 8.30586 36.4558 8.29548C36.3975 8.28494 36.3423 8.26402 36.3327 8.24892C36.3121 8.21588 36.1095 8.18033 35.9264 8.1775C35.8537 8.17656 35.7643 8.15847 35.7279 8.13754C35.5385 8.02869 35.4022 7.98496 35.1582 7.95475C35.0121 7.93666 34.8692 7.90977 34.8406 7.89482C34.6277 7.78486 34.2462 7.70448 33.9363 7.70448C33.8469 7.70448 33.8151 7.69158 33.7824 7.64203C33.7267 7.55787 33.586 7.52421 33.1768 7.49699C32.9067 7.47906 32.8305 7.46553 32.8116 7.43218C32.7973 7.40701 32.7533 7.38987 32.703 7.38971C32.6564 7.38971 32.5826 7.36816 32.5389 7.34173C32.4824 7.3076 32.3792 7.28856 32.1816 7.27582C31.9566 7.26135 31.8961 7.24861 31.8641 7.20912C31.8369 7.17577 31.7756 7.1558 31.6703 7.14573C31.5855 7.13771 31.5017 7.11915 31.4839 7.10452C31.4661 7.08989 31.2915 7.0644 31.0958 7.04804C30.9002 7.03152 30.7198 7.0073 30.695 6.99424C30.6703 6.98119 30.5639 6.9524 30.4584 6.93038C30.353 6.90851 30.2534 6.87957 30.2371 6.86604C30.2207 6.85267 30.0175 6.82876 29.7852 6.81287C29.4001 6.78644 29.0813 6.72667 28.9495 6.65619C28.9256 6.64345 28.7351 6.61907 28.526 6.60192C28.3168 6.58478 28.1099 6.55536 28.0663 6.53664C28.0226 6.51792 27.8875 6.48914 27.766 6.47262C27.6445 6.45626 27.518 6.43266 27.4846 6.42008C27.4316 6.4001 27.1011 6.37021 26.4819 6.32947C26.3697 6.32208 26.2827 6.30194 26.2548 6.27693C26.2299 6.25459 26.1628 6.23619 26.1058 6.23603C26.0487 6.23587 25.9366 6.21825 25.8564 6.19686C25.7763 6.17547 25.4986 6.14636 25.2392 6.13205C24.9799 6.11789 24.7237 6.09493 24.6702 6.08124C24.6167 6.0674 24.4836 6.0427 24.3744 6.02634C24.2653 6.00982 24.1283 5.98387 24.07 5.96861C24.0119 5.95335 23.7319 5.93054 23.4482 5.91811C23.1642 5.90553 22.8189 5.88335 22.6806 5.86888C22.5423 5.85425 22.3101 5.83097 22.1645 5.81697C22.019 5.80297 21.8225 5.77434 21.7278 5.75341C21.6332 5.73234 21.4963 5.7078 21.4236 5.69867C21.2467 5.67665 21.1751 5.62663 21.2351 5.56716C21.2586 5.54388 21.278 5.50912 21.278 5.49009C21.278 5.47105 21.307 5.44824 21.3424 5.43943C21.3778 5.43062 21.4144 5.39979 21.4236 5.371C21.4328 5.34222 21.4501 5.31862 21.4618 5.31862C21.4738 5.31862 21.4898 5.29503 21.4974 5.26624C21.5054 5.23572 21.5335 5.21386 21.5646 5.21386C21.5941 5.21386 21.6587 5.16651 21.7096 5.10768C21.7656 5.04287 21.8387 4.99127 21.8969 4.97538C21.9495 4.96091 21.9925 4.93841 21.9925 4.92536C21.9925 4.88335 22.1153 4.77843 22.2074 4.74147C22.2566 4.7218 22.3065 4.69018 22.318 4.67131C22.3296 4.65243 22.3568 4.63701 22.3782 4.63701C22.3997 4.63701 22.4286 4.6076 22.4424 4.57142C22.4578 4.5313 22.4884 4.50598 22.5211 4.50598C22.5507 4.50598 22.5748 4.49119 22.5748 4.4731C22.575 4.44054 22.8012 4.31218 22.9099 4.28324C22.9413 4.27474 22.9862 4.23887 23.0097 4.20348C23.0331 4.16793 23.0648 4.13883 23.0801 4.13883C23.0953 4.13883 23.1257 4.12121 23.1476 4.0995C23.1693 4.07795 23.2276 4.06017 23.277 4.06017C23.3397 4.06017 23.3754 4.04444 23.3951 4.00779C23.4107 3.979 23.4405 3.95541 23.4613 3.95541C23.4821 3.95541 23.5114 3.93276 23.5263 3.90507C23.5414 3.87738 23.5887 3.84703 23.6317 3.83774C23.6748 3.82831 23.7541 3.78064 23.8081 3.73172C23.8751 3.67084 23.9501 3.63372 24.0455 3.61405C24.1222 3.59832 24.1994 3.56844 24.2169 3.54752C24.2343 3.52675 24.2623 3.5096 24.2791 3.5096C24.2959 3.5096 24.3293 3.48695 24.3534 3.45911C24.3798 3.42843 24.4474 3.40216 24.5246 3.39225C24.5948 3.38329 24.6701 3.36473 24.692 3.35088C24.7137 3.33704 24.7733 3.30526 24.8242 3.28009C24.8752 3.25492 24.9289 3.21937 24.9433 3.20113C24.9579 3.18288 25.0353 3.16054 25.1155 3.15158C25.2022 3.14182 25.2792 3.1165 25.3062 3.08881C25.3309 3.06333 25.3865 3.0347 25.4295 3.02542C25.4727 3.01598 25.5139 2.99301 25.5212 2.97429C25.5288 2.95447 25.6026 2.93245 25.6968 2.92191C25.8006 2.91027 25.8645 2.89013 25.8738 2.86591C25.8819 2.84499 25.9021 2.82784 25.9188 2.82768C25.9355 2.82768 26.0087 2.79842 26.0814 2.76303C26.1541 2.72764 26.2481 2.69822 26.2902 2.69775C26.3632 2.69696 26.4942 2.64662 26.7091 2.53682C26.7632 2.50914 26.8823 2.47925 26.9738 2.47028C27.0652 2.46132 27.158 2.43851 27.1801 2.41963C27.2021 2.40076 27.2777 2.37244 27.3481 2.35687C27.4184 2.34129 27.4918 2.31282 27.511 2.29379C27.5318 2.27318 27.6464 2.25147 27.7928 2.24062C27.9648 2.22772 28.0555 2.20868 28.0926 2.17769C28.2046 2.08378 28.2827 2.06255 28.6843 2.01567C28.912 1.98908 29.146 1.95023 29.2043 1.92931C29.4887 1.82722 29.6072 1.80504 30.0121 1.77845C30.2511 1.76272 30.4613 1.73787 30.4792 1.72308C30.5526 1.66267 31.9249 1.57631 32.4462 1.59912C33.293 1.63641 34.2729 1.69838 34.4204 1.72418C34.5063 1.73913 34.7791 1.76288 35.0265 1.77704C35.2741 1.79119 35.5242 1.81935 35.5823 1.83949C35.6406 1.85978 35.7752 1.884 35.8815 1.8936C35.9878 1.9032 36.1009 1.92758 36.133 1.94771C36.1649 1.96785 36.2724 1.99664 36.372 2.01158C36.4714 2.02652 36.5671 2.05043 36.5846 2.06491C36.6022 2.07938 36.6994 2.10423 36.8007 2.12012C36.9022 2.13617 37.0111 2.16605 37.043 2.18666C37.0749 2.20727 37.1702 2.23181 37.2547 2.24109C37.3393 2.25053 37.4584 2.2801 37.5195 2.30716C37.5805 2.33406 37.6582 2.35608 37.6918 2.35608C37.7257 2.35608 37.7977 2.37967 37.8521 2.40846C37.9064 2.43741 37.9816 2.461 38.0194 2.461C38.0572 2.461 38.1172 2.4835 38.1526 2.51118C38.1882 2.53887 38.2638 2.56923 38.3208 2.57882C38.3777 2.58826 38.4374 2.6117 38.4532 2.63058C38.4691 2.64961 38.5582 2.67934 38.6514 2.6968C38.7475 2.71474 38.8269 2.74431 38.835 2.76508C38.8427 2.78521 38.8763 2.80189 38.9094 2.80204C38.9428 2.8022 39.0336 2.83162 39.1114 2.86764C39.1894 2.9035 39.2802 2.93292 39.3132 2.93292C39.3464 2.93292 39.3882 2.95022 39.406 2.97146C39.4238 2.9927 39.4792 3.01771 39.529 3.02699C39.5789 3.03627 39.6311 3.06506 39.6451 3.09086C39.6596 3.1176 39.7153 3.14544 39.7747 3.15535C39.8319 3.16495 39.8852 3.18933 39.8931 3.20962C39.9009 3.22991 39.9565 3.2543 40.0165 3.26389C40.0765 3.27333 40.1317 3.29645 40.1388 3.31517C40.1461 3.33389 40.188 3.35702 40.232 3.36661C40.276 3.37621 40.3541 3.41223 40.4056 3.44684C40.457 3.48145 40.5212 3.5096 40.5483 3.5096C40.5753 3.5096 40.5975 3.52596 40.5975 3.5461C40.5975 3.56686 40.6369 3.58983 40.6898 3.59958C40.7412 3.60918 40.7944 3.63954 40.8098 3.66817C40.8251 3.69633 40.8583 3.71945 40.8837 3.71945C40.9091 3.71945 40.9504 3.74336 40.9758 3.77262C41.001 3.80188 41.0572 3.83271 41.1008 3.84136C41.1441 3.85001 41.1797 3.86684 41.1797 3.8788C41.1797 3.89075 41.2333 3.92395 41.2988 3.95258C41.3643 3.98136 41.4179 4.01723 41.4179 4.03249C41.4179 4.04775 41.4402 4.06017 41.4676 4.06017C41.4949 4.06017 41.5311 4.07669 41.5479 4.09667C41.5647 4.1168 41.6168 4.14842 41.6637 4.16683C41.7103 4.18539 41.7666 4.21654 41.7885 4.23588C41.8629 4.30227 42.0289 4.40106 42.0659 4.40106C42.0862 4.40106 42.1111 4.41411 42.1211 4.43032C42.1311 4.44636 42.1913 4.48223 42.255 4.51007C42.3187 4.53807 42.3706 4.57126 42.3706 4.584C42.3706 4.59674 42.3974 4.61531 42.4301 4.62522C42.463 4.63497 42.5135 4.66391 42.5427 4.6894C42.5718 4.71504 42.6224 4.74398 42.6552 4.75374C42.6879 4.76365 42.7147 4.7885 42.7147 4.80927C42.7147 4.82987 42.7344 4.8467 42.7585 4.8467C42.7827 4.8467 42.8414 4.87628 42.889 4.9123C42.9368 4.94832 42.9896 4.9779 43.0066 4.9779C43.0234 4.9779 43.0674 5.00149 43.1045 5.03028C43.1415 5.05907 43.1995 5.08266 43.2335 5.08266C43.2682 5.08266 43.3076 5.10579 43.3238 5.13583C43.3594 5.20174 43.4112 5.17626 43.388 5.10421C43.3788 5.07527 43.2174 4.89924 43.0297 4.71315C42.8419 4.52706 42.6882 4.36299 42.6882 4.34852C42.6882 4.3342 42.6721 4.3224 42.6525 4.3224C42.6186 4.3224 42.5572 4.27584 42.3922 4.12514C42.3531 4.08943 42.3088 4.06017 42.2939 4.06017C42.279 4.06017 42.2539 4.03658 42.2383 4.00779C42.2228 3.979 42.1929 3.95541 42.1721 3.95541C42.1513 3.95541 42.1216 3.93181 42.1061 3.90287C42.0905 3.87408 42.0668 3.85049 42.0537 3.85049C42.0405 3.85049 41.9766 3.80031 41.9117 3.73911C41.7456 3.58212 41.6132 3.47846 41.5058 3.42073C41.4549 3.39336 41.4072 3.35513 41.3996 3.33547C41.392 3.31596 41.371 3.29991 41.3531 3.29991C41.335 3.29991 41.2991 3.27679 41.2732 3.24848C41.2475 3.22016 41.1871 3.18414 41.1392 3.16856C41.0912 3.15283 41.046 3.12452 41.0387 3.10533C41.0312 3.08629 40.9948 3.06317 40.9575 3.05389C40.8927 3.03769 40.7062 2.92458 40.6774 2.884C40.6698 2.87314 40.6258 2.84923 40.5796 2.83067C40.5332 2.81211 40.4889 2.78033 40.4811 2.76004C40.4732 2.73975 40.4516 2.72307 40.4329 2.72307C40.4143 2.72292 40.3276 2.68768 40.2403 2.64442C40.1529 2.60132 40.0678 2.56593 40.0511 2.56593C40.0345 2.56593 40.0146 2.54957 40.007 2.52975C39.9992 2.50993 39.9516 2.48601 39.9009 2.47673C39.8503 2.46729 39.7942 2.44213 39.7764 2.42089C39.7587 2.39965 39.7294 2.38235 39.7113 2.38235C39.6934 2.38235 39.6348 2.35278 39.5811 2.31675C39.5274 2.28073 39.4679 2.25116 39.4487 2.25116C39.4295 2.25116 39.3834 2.22756 39.3464 2.19877C39.3094 2.16999 39.2616 2.14639 39.2402 2.14639C39.2188 2.14639 39.1873 2.12972 39.1703 2.10927C39.1532 2.08897 39.0773 2.05798 39.0017 2.04037C38.926 2.02291 38.8461 1.99333 38.8243 1.97461C38.8024 1.95589 38.7489 1.9323 38.7052 1.92207C38.6616 1.91169 38.6079 1.88809 38.5861 1.86953C38.5642 1.85081 38.4869 1.82124 38.4142 1.80378C38.3413 1.78632 38.264 1.75722 38.242 1.73913C38.2203 1.72119 38.1607 1.69791 38.1098 1.68753C38.0588 1.67715 37.9993 1.65324 37.9775 1.63468C37.9556 1.61596 37.8897 1.58795 37.8311 1.57254C37.7723 1.55712 37.7009 1.52692 37.6723 1.50537C37.6436 1.48398 37.5845 1.46541 37.5408 1.46431C37.4972 1.46321 37.4138 1.44434 37.3555 1.42216C37.2972 1.39998 37.1901 1.37009 37.1173 1.35561C37.0446 1.34098 36.9658 1.3122 36.9423 1.29128C36.9188 1.27035 36.8355 1.24613 36.757 1.23732C36.6786 1.22851 36.5817 1.20507 36.5416 1.18494C36.5014 1.16496 36.3705 1.13633 36.2508 1.12154C36.1309 1.1066 36.0147 1.07813 35.9923 1.05815C35.9675 1.03597 35.8543 1.01473 35.7009 1.00372C35.5629 0.993811 35.4203 0.970843 35.3838 0.952753C35.3474 0.93482 35.1947 0.90682 35.0445 0.890775C34.8943 0.874572 34.7482 0.849246 34.7199 0.834145C34.6916 0.819201 34.5287 0.795291 34.3579 0.780976C34.1872 0.766661 34.0093 0.737403 33.9628 0.716009C33.904 0.688953 33.7179 0.669761 33.3542 0.653244C33.0658 0.64003 32.7884 0.616749 32.7376 0.601333C32.6123 0.563265 31.0542 0.566411 30.9642 0.604794ZM7.3622 4.0855C6.99856 4.09651 6.8185 4.11161 6.80563 4.13238C6.79515 4.14905 6.72148 4.18036 6.64192 4.20159C6.56237 4.22299 6.45566 4.25303 6.40485 4.26829C6.35403 4.28355 6.21954 4.30762 6.10584 4.32177C5.99215 4.33593 5.88211 4.36425 5.86147 4.38485C5.84066 4.4053 5.76159 4.43063 5.68568 4.44101C5.60962 4.45139 5.53213 4.47499 5.5134 4.49355C5.49466 4.51211 5.43146 4.5354 5.37303 4.54515C5.30745 4.55616 5.26664 4.57724 5.26664 4.60005C5.26664 4.62034 5.24758 4.63701 5.2244 4.63701C5.20121 4.63701 5.15374 4.65919 5.11896 4.68641C5.08403 4.71362 5.00003 4.74414 4.93222 4.75421C4.81504 4.77151 4.61464 4.87628 4.57193 4.9425C4.56097 4.95949 4.50174 4.98167 4.44029 4.9919C4.36788 5.00401 4.2861 5.04617 4.20703 5.11224C4.14018 5.16808 4.07539 5.21386 4.063 5.21386C4.03633 5.21386 3.78623 5.36896 3.73637 5.41647C3.71716 5.43471 3.68762 5.44982 3.67079 5.44982C3.65396 5.44982 3.59727 5.49622 3.54487 5.55301C3.49247 5.60979 3.41688 5.66438 3.37671 5.67429C3.33669 5.68436 3.297 5.71157 3.28874 5.73501C3.26699 5.79557 3.14456 5.89342 3.08898 5.89452C3.0631 5.89499 3.03499 5.91339 3.02642 5.9351C3.00847 5.98167 2.87128 6.13142 2.84651 6.13142C2.80173 6.13142 2.67295 6.25176 2.67295 6.2936C2.67295 6.31972 2.65739 6.34111 2.63833 6.34111C2.5953 6.34111 2.46128 6.47655 2.46128 6.52012C2.46128 6.53774 2.43143 6.56543 2.39507 6.58194C2.3587 6.5983 2.32901 6.62631 2.32901 6.64408C2.32901 6.68058 2.15593 6.8393 2.11639 6.8393C2.10226 6.8393 2.09082 6.86195 2.09082 6.88948C2.09082 6.91716 2.03715 6.99676 1.97173 7.06645C1.90615 7.13613 1.85264 7.20645 1.85264 7.22297C1.85264 7.23933 1.83009 7.25852 1.80246 7.2656C1.76784 7.27456 1.74672 7.31247 1.7337 7.38845C1.72338 7.44901 1.69829 7.5047 1.67797 7.51241C1.65748 7.52028 1.64065 7.55189 1.64049 7.58272C1.63986 7.65729 1.61207 7.6963 1.55109 7.70794C1.52347 7.71329 1.48774 7.74113 1.4717 7.77008C1.4555 7.79886 1.43597 7.82828 1.42803 7.83551C1.42009 7.84275 1.39739 7.89875 1.37754 7.9601C1.35753 8.02145 1.33133 8.07147 1.3191 8.07147C1.30687 8.07147 1.29687 8.08752 1.29687 8.10718C1.29687 8.12685 1.26892 8.18363 1.23478 8.2335C1.20064 8.28337 1.16492 8.35494 1.15523 8.39269C1.1457 8.43029 1.1222 8.47669 1.10315 8.49573C1.05964 8.53899 1.00565 8.68937 1.00565 8.7674C1.00565 8.7998 0.988023 8.83299 0.966428 8.84117C0.944832 8.84935 0.919426 8.90472 0.909739 8.96418C0.900212 9.02365 0.877029 9.07807 0.85845 9.08515C0.839713 9.09223 0.816212 9.14729 0.806208 9.20754C0.796204 9.26763 0.759524 9.38671 0.724907 9.47213C0.690132 9.55754 0.661708 9.65413 0.661708 9.68685C0.661708 9.71957 0.651069 9.75276 0.638207 9.76078C0.605973 9.78045 0.588665 9.88962 0.555319 10.2832C0.53547 10.5179 0.513081 10.6409 0.481799 10.6884C0.408596 10.7992 0.420029 12.1215 0.496725 12.3974C0.530865 12.5209 0.557542 12.721 0.56834 12.9346C0.579931 13.1646 0.597239 13.2881 0.621534 13.3148C0.641383 13.3365 0.672665 13.4134 0.690926 13.4855C0.709187 13.5575 0.738245 13.6305 0.755554 13.6477C0.772703 13.6648 0.79541 13.7645 0.805731 13.8695C0.820181 14.0137 0.837172 14.0689 0.875599 14.0955C0.903388 14.1149 0.926254 14.1597 0.926254 14.1951C0.926254 14.2305 0.950072 14.2796 0.97929 14.3042C1.00835 14.3289 1.03217 14.381 1.03217 14.4199C1.03217 14.5149 1.0571 14.5736 1.09775 14.5736C1.11617 14.5736 1.13856 14.6192 1.14761 14.675C1.15666 14.7307 1.18175 14.791 1.20318 14.8087C1.22478 14.8265 1.25003 14.8806 1.25924 14.9292C1.26892 14.9805 1.2956 15.0236 1.32291 15.0323C1.34895 15.0404 1.37738 15.0837 1.38643 15.129C1.39564 15.1741 1.42676 15.2276 1.45582 15.2478C1.48488 15.2679 1.50854 15.3074 1.50854 15.3355C1.50854 15.3635 1.53839 15.4123 1.57475 15.4436C1.61112 15.4749 1.64081 15.5149 1.64081 15.5323C1.64081 15.5498 1.65875 15.571 1.68051 15.5792C1.70242 15.5875 1.72021 15.6126 1.72021 15.6349C1.72021 15.6745 1.77086 15.7798 1.8023 15.8057C1.81103 15.813 1.83231 15.8454 1.84962 15.8778C1.86677 15.9103 1.8971 15.9368 1.91679 15.9368C1.93648 15.9368 1.9603 15.9667 1.96951 16.0032C1.97872 16.0396 2.01572 16.0949 2.05176 16.1259C2.08781 16.1568 2.11718 16.1977 2.11718 16.2168C2.11718 16.2358 2.12941 16.2514 2.14434 16.2514C2.15926 16.2514 2.18276 16.281 2.19658 16.317C2.21198 16.3571 2.24263 16.3826 2.27534 16.3826C2.30487 16.3826 2.32901 16.3999 2.32901 16.421C2.32901 16.442 2.35283 16.4719 2.38189 16.4873C2.41095 16.5028 2.43476 16.5323 2.43476 16.5529C2.43476 16.5735 2.45842 16.603 2.48748 16.6184C2.51638 16.6336 2.54751 16.6758 2.55672 16.712C2.56735 16.7538 2.61213 16.7974 2.6793 16.8314C2.74457 16.8644 2.79617 16.9138 2.81396 16.9605C2.83381 17.0129 2.86715 17.0415 2.92193 17.0535C3.00292 17.0711 3.14932 17.1949 3.14932 17.2457C3.14932 17.2613 3.166 17.2739 3.18632 17.2739C3.23459 17.2739 3.38751 17.4073 3.38751 17.4491C3.38751 17.467 3.43578 17.4944 3.49453 17.5101C3.56726 17.5295 3.60918 17.5586 3.62522 17.6003C3.65459 17.677 3.75098 17.7458 3.82879 17.7458C3.88135 17.7458 3.94693 17.7905 4.07761 17.9152C4.10048 17.9371 4.16002 17.9629 4.20988 17.9723C4.29627 17.9887 4.33914 18.016 4.4395 18.1192C4.46395 18.1444 4.55255 18.1782 4.6364 18.1946C4.74564 18.2158 4.79312 18.2382 4.80456 18.2734C4.81313 18.3004 4.83346 18.3226 4.84949 18.3226C4.86553 18.3226 4.89888 18.3407 4.92349 18.3627C4.9481 18.3848 5.03036 18.4102 5.10626 18.4191C5.18216 18.428 5.26076 18.4516 5.28093 18.4716C5.30109 18.4917 5.35969 18.5255 5.41114 18.5468C5.46274 18.568 5.50482 18.5948 5.50482 18.6061C5.50482 18.6174 5.62439 18.6399 5.77064 18.656C5.91688 18.672 6.05074 18.6961 6.06837 18.7093C6.08584 18.7225 6.14189 18.7491 6.19286 18.7683C6.24383 18.7875 6.30338 18.8172 6.32513 18.8342C6.34705 18.8513 6.53601 18.8785 6.74513 18.8947C6.95426 18.9109 7.14005 18.9364 7.15815 18.9514C7.27677 19.0488 9.15367 19.0357 9.26482 18.9366C9.29293 18.9117 9.37137 18.8993 9.50301 18.8988C9.76517 18.8982 10.0257 18.859 10.0794 18.8122C10.1034 18.7912 10.1647 18.7654 10.2155 18.7549C10.2665 18.7442 10.3152 18.7247 10.3236 18.7115C10.3322 18.6983 10.4572 18.6745 10.6015 18.6588C10.7459 18.6431 10.8818 18.6155 10.9037 18.5978C10.9255 18.5798 10.9868 18.5575 11.0396 18.5482C11.1046 18.5367 11.1405 18.5142 11.1497 18.4793C11.1595 18.442 11.1859 18.4275 11.2435 18.4275C11.3721 18.4275 11.4568 18.3881 11.5863 18.2677C11.6111 18.2446 11.7051 18.2108 11.7953 18.1924C11.8853 18.1738 11.9654 18.1425 11.9732 18.1227C11.9808 18.1029 12.0048 18.0867 12.0262 18.0867C12.0478 18.0867 12.0756 18.0687 12.088 18.047C12.1008 18.0242 12.1804 17.995 12.2745 17.9786C12.3647 17.9629 12.439 17.9364 12.4395 17.9201C12.4411 17.8712 12.6547 17.7532 12.7779 17.733C12.8408 17.7228 12.8986 17.6978 12.9064 17.6777C12.9143 17.6575 12.9369 17.641 12.9565 17.641C12.9764 17.641 13.0053 17.6174 13.0207 17.5886C13.0386 17.5556 13.0883 17.5303 13.1563 17.5194C13.2154 17.5101 13.2698 17.4864 13.2773 17.4669C13.2849 17.4472 13.3056 17.4312 13.3232 17.4312C13.341 17.4312 13.3799 17.4033 13.4099 17.3692C13.4453 17.3288 13.5071 17.3008 13.5866 17.2888C13.6676 17.2769 13.7181 17.2536 13.7362 17.2199C13.7515 17.1919 13.7816 17.1691 13.8034 17.1691C13.8251 17.1691 13.8493 17.1526 13.8572 17.1323C13.865 17.1122 13.9147 17.0875 13.9676 17.0777C14.0204 17.0678 14.133 17.0077 14.2175 16.944C14.302 16.8803 14.386 16.8281 14.4039 16.8281C14.422 16.8279 14.4786 16.7886 14.5297 16.7406C14.6451 16.6321 14.7186 16.5923 14.8036 16.5923C14.84 16.5923 14.8866 16.5754 14.9074 16.5548C14.9282 16.5342 14.9889 16.5092 15.0424 16.4993C15.0964 16.4892 15.1514 16.4593 15.1661 16.432C15.1814 16.4038 15.2214 16.3826 15.259 16.3826C15.3565 16.3826 15.5766 16.2761 15.6214 16.2073C15.6325 16.1903 15.7079 16.1627 15.7891 16.146C15.8704 16.1293 15.9582 16.0961 15.9842 16.0721C16.0922 15.9729 16.153 15.9424 16.274 15.9265C16.3904 15.9111 16.4552 15.8764 16.5684 15.7683C16.5908 15.7467 16.698 15.7161 16.8066 15.6999C16.915 15.6837 17.0157 15.6555 17.0303 15.6373C17.0449 15.619 17.1015 15.588 17.1561 15.5685C17.2105 15.549 17.2553 15.5248 17.2553 15.5147C17.2553 15.5046 17.3357 15.4826 17.434 15.4656C17.609 15.4356 17.6906 15.4077 17.9037 15.3063C17.9619 15.2786 18.0979 15.2437 18.206 15.2287C18.314 15.2138 18.4153 15.1915 18.4309 15.179C18.4466 15.1666 18.501 15.1479 18.552 15.1377C18.603 15.1273 18.6625 15.0982 18.6844 15.0727C18.7152 15.0367 18.7943 15.0205 19.0417 14.9995C19.2337 14.9832 19.3906 14.9558 19.4387 14.9305C19.4824 14.9074 19.5511 14.8883 19.5916 14.8883C19.6321 14.8882 19.7334 14.866 19.8166 14.8388C19.9041 14.8103 20.0916 14.7821 20.2608 14.7721C20.4219 14.7626 20.6177 14.7381 20.696 14.7176C20.7743 14.6972 20.9818 14.6668 21.1573 14.6503C21.3329 14.6338 21.4931 14.6067 21.5136 14.5904C21.5808 14.5363 26.1889 14.5489 26.2324 14.6031C26.2603 14.6382 26.3432 14.6487 26.6876 14.6618C26.9928 14.6734 27.1203 14.6879 27.1508 14.7147C27.1813 14.7412 27.3133 14.7563 27.6296 14.7692C27.8851 14.7796 28.1103 14.8021 28.1722 14.8234C28.2303 14.8433 28.3951 14.8713 28.5384 14.8857C28.6816 14.9 28.8134 14.9237 28.8313 14.9385C28.8669 14.9678 29.4606 15.019 29.7656 15.0192C29.9295 15.0192 29.9606 15.0266 29.9849 15.0716C30.0005 15.1005 30.0342 15.1241 30.0596 15.1241C30.085 15.1241 30.1709 15.1414 30.2504 15.1627C30.3301 15.1839 30.544 15.2146 30.726 15.2309C30.908 15.2471 31.0819 15.2761 31.1127 15.2953C31.1433 15.3145 31.2446 15.3439 31.3375 15.3606C31.4306 15.3772 31.5187 15.3999 31.5331 15.4109C31.5477 15.4219 31.6846 15.4452 31.8375 15.4626C31.9905 15.4801 32.1742 15.5114 32.246 15.532C32.6218 15.6407 32.7479 15.546 32.6812 15.2053C32.6625 15.1101 32.638 15.026 32.6267 15.0181C32.6156 15.0102 32.5926 14.9099 32.5759 14.7952C32.5591 14.6805 32.5291 14.568 32.5091 14.5452C32.4891 14.5224 32.4727 14.474 32.4727 14.4373C32.4727 14.4008 32.45 14.3423 32.4224 14.3074C32.3947 14.2726 32.3679 14.2151 32.3628 14.1797C32.3571 14.1399 32.3333 14.1117 32.3007 14.1062C32.2715 14.1012 32.2356 14.082 32.2209 14.0634C32.2061 14.045 32.1526 14.0211 32.1018 14.0104C32.0511 13.9997 31.9892 13.9731 31.9643 13.9513C31.9393 13.9295 31.8618 13.9012 31.7921 13.8885C31.7226 13.8757 31.6119 13.8399 31.5465 13.8087C31.4809 13.7777 31.3975 13.7379 31.3612 13.7206C31.3248 13.7032 31.2151 13.6744 31.1173 13.6565C31.0195 13.6387 30.9264 13.6083 30.9104 13.5893C30.8943 13.5701 30.8434 13.5462 30.7973 13.5361C30.7513 13.5261 30.7014 13.502 30.6866 13.4826C30.6714 13.4623 30.5688 13.4369 30.4481 13.423C30.2301 13.3983 30.0011 13.3159 29.977 13.2536C29.9679 13.23 29.8912 13.2129 29.7467 13.2018C29.5986 13.1905 29.5028 13.1685 29.4435 13.1322C29.3958 13.1029 29.3414 13.0792 29.3223 13.0792C29.3034 13.0792 29.2666 13.06 29.2404 13.0367C29.21 13.0093 29.1105 12.9859 28.9625 12.9709C28.8315 12.9579 28.7138 12.9318 28.6902 12.9107C28.6673 12.8902 28.6128 12.8651 28.5692 12.8548C28.5255 12.8444 28.4718 12.8215 28.4501 12.8035C28.4282 12.7858 28.3173 12.7578 28.2038 12.7416C28.0902 12.7252 27.9651 12.6956 27.9259 12.6758C27.8867 12.656 27.8157 12.6315 27.7682 12.6212C27.7207 12.6112 27.6493 12.5876 27.6094 12.5687C27.5696 12.5498 27.4538 12.5267 27.3523 12.5171C27.2507 12.5075 27.1496 12.4836 27.1273 12.4641C27.1051 12.4446 27.0335 12.4145 26.9679 12.3974C26.9025 12.3801 26.8345 12.3544 26.8169 12.3401C26.7993 12.3258 26.67 12.3044 26.5298 12.2925C26.3231 12.2748 26.2651 12.2605 26.2233 12.2162C26.1951 12.1861 26.1406 12.1614 26.1023 12.1614C26.0639 12.1614 26.0139 12.1452 25.9909 12.1252C25.9669 12.1045 25.8319 12.0773 25.6739 12.0612C25.5226 12.0458 25.3864 12.0208 25.371 12.0057C25.3556 11.9904 25.3062 11.978 25.2612 11.978C25.2163 11.978 25.1323 11.9533 25.0747 11.9233C25.0034 11.8861 24.8743 11.8589 24.6702 11.838C24.4435 11.8147 24.3647 11.7969 24.3464 11.7645C24.3323 11.7397 24.2694 11.714 24.1962 11.7032C24.1268 11.6928 24.0498 11.6736 24.0249 11.6604C24.0001 11.6474 23.8513 11.6233 23.6941 11.6071C23.5144 11.5885 23.4008 11.5649 23.3881 11.5434C23.377 11.5245 23.3114 11.5011 23.2425 11.491C23.1736 11.4811 23.085 11.4567 23.0455 11.4369C23.0058 11.4171 22.8629 11.3933 22.7279 11.3842C22.5928 11.3751 22.4506 11.3519 22.412 11.3326C22.3735 11.3134 22.2544 11.284 22.1473 11.2673C22.0403 11.2506 21.9273 11.2214 21.896 11.2023C21.8647 11.1831 21.7278 11.1602 21.5916 11.1511C21.4555 11.1421 21.2965 11.1168 21.2383 11.0947C21.18 11.0729 21.062 11.045 20.9761 11.0329C20.89 11.0206 20.8111 10.9969 20.8006 10.9801C20.7887 10.961 20.6087 10.9363 20.3246 10.9146C20.0732 10.8954 19.855 10.8673 19.8398 10.852C19.8244 10.8368 19.778 10.8243 19.7369 10.8243C19.6956 10.8243 19.5908 10.8006 19.5038 10.7716C19.4003 10.737 19.2181 10.7103 18.976 10.6942C18.7727 10.6807 18.5852 10.6588 18.5593 10.6458C18.5334 10.6326 18.4601 10.6139 18.3961 10.6043C18.3321 10.5945 18.2249 10.564 18.1579 10.5365C18.0545 10.494 17.3211 10.4311 16.9285 10.4311C16.9088 10.4311 16.8653 10.4075 16.8318 10.3787C16.7983 10.3499 16.7348 10.3263 16.6908 10.3263C16.647 10.3263 16.5147 10.3091 16.3972 10.2881C16.2797 10.2671 15.9453 10.2382 15.6541 10.2237C15.3062 10.2066 15.0851 10.1836 15.0089 10.157C14.9452 10.1347 14.7845 10.1053 14.6516 10.0918C14.5189 10.0782 14.3225 10.0538 14.2153 10.0375C14.0103 10.0065 13.2239 10.0112 13.1914 10.0436C13.1809 10.054 13.1966 10.1188 13.2262 10.1879C13.2557 10.2568 13.2884 10.3898 13.2987 10.4836C13.3092 10.5772 13.3361 10.6746 13.3584 10.6997C13.4272 10.7767 13.4148 12.196 13.3435 12.4106C13.3148 12.4971 13.2837 12.6445 13.2743 12.7383C13.2649 12.832 13.2405 12.944 13.2198 12.9873C13.1992 13.0305 13.1755 13.0985 13.1673 13.1381C13.159 13.1778 13.1358 13.2102 13.116 13.2102C13.0922 13.2102 13.069 13.2704 13.0479 13.3872C13.0302 13.4845 12.9953 13.5937 12.9702 13.6297C12.9451 13.6657 12.9168 13.7159 12.9075 13.7411C12.898 13.7663 12.8794 13.787 12.866 13.787C12.8527 13.787 12.8289 13.8385 12.8128 13.9012C12.7968 13.9642 12.7657 14.0304 12.7438 14.0486C12.7217 14.0667 12.6669 14.1451 12.6221 14.2226C12.5774 14.3003 12.5307 14.3637 12.5186 14.3637C12.5065 14.3637 12.4837 14.401 12.4676 14.4466C12.4516 14.4921 12.4148 14.5459 12.3855 14.566C12.3565 14.5861 12.3328 14.6157 12.3328 14.6318C12.3328 14.6478 12.3152 14.6796 12.2938 14.7024C12.2029 14.7991 12.1023 14.9306 12.0867 14.9733C12.0773 14.9986 12.053 15.0192 12.0327 15.0192C12.0122 15.0192 11.9006 15.1188 11.7845 15.2405C11.6643 15.3667 11.5428 15.4694 11.5025 15.4795C11.4634 15.4892 11.4196 15.5194 11.4048 15.5466C11.3902 15.5737 11.3613 15.596 11.3407 15.596C11.3201 15.596 11.2927 15.6146 11.2799 15.6373C11.2672 15.6599 11.2324 15.6923 11.2027 15.7093C11.1729 15.7263 11.0847 15.7845 11.0066 15.8385C10.9285 15.8926 10.8394 15.9368 10.8086 15.9368C10.7778 15.9368 10.6978 15.9781 10.6311 16.0286C10.4915 16.1342 10.4021 16.1727 10.2965 16.1727C10.2555 16.1727 10.2079 16.1897 10.1906 16.2105C10.1731 16.2311 10.1242 16.2556 10.0815 16.2649C10.0389 16.2742 9.99415 16.2995 9.98176 16.3214C9.96684 16.3477 9.88538 16.37 9.73691 16.3882C9.61448 16.4032 9.49634 16.4301 9.47459 16.4479C9.45267 16.4658 9.3998 16.4886 9.35708 16.4987C9.31437 16.5089 9.26467 16.5369 9.24672 16.5613C9.19813 16.6272 7.272 16.6288 7.17053 16.563C7.13465 16.5396 7.06383 16.5116 7.01333 16.5006C6.96284 16.4895 6.89742 16.4652 6.86804 16.4463C6.83882 16.4276 6.73735 16.4038 6.64272 16.3936C6.54014 16.3824 6.44534 16.3554 6.4077 16.3263C6.37293 16.2995 6.3299 16.2776 6.31195 16.2776C6.29401 16.2776 6.25034 16.255 6.21493 16.2273C6.17936 16.1998 6.1033 16.1685 6.04582 16.1578C5.92625 16.1358 5.73951 16.0474 5.70918 15.9983C5.69791 15.98 5.64424 15.9571 5.59009 15.9472C5.5018 15.9311 5.42082 15.8836 5.2895 15.7703C5.26568 15.7499 5.20312 15.7191 5.15056 15.7019C5.098 15.6846 5.05481 15.6612 5.05481 15.6495C5.05481 15.6187 4.89094 15.4648 4.85791 15.4648C4.82218 15.4647 4.65783 15.3131 4.65783 15.28C4.65783 15.2663 4.641 15.2552 4.6202 15.2552C4.59956 15.2552 4.5489 15.2201 4.50778 15.1773C4.37725 15.0417 4.36899 15.033 4.33438 14.9983C4.3158 14.9794 4.27975 14.9445 4.25435 14.9203C4.22878 14.8962 4.20798 14.8611 4.20798 14.8424C4.20798 14.8235 4.17829 14.7969 4.14176 14.7832C4.1054 14.7696 4.07571 14.743 4.07571 14.7241C4.07571 14.7054 4.05475 14.6714 4.02934 14.6486C3.93041 14.56 3.83752 14.435 3.83752 14.3903C3.83752 14.3647 3.81275 14.3373 3.78258 14.3294C3.75241 14.3216 3.72129 14.2907 3.71335 14.2608C3.70541 14.2309 3.69096 14.2064 3.68127 14.2064C3.67158 14.2064 3.64094 14.1682 3.61331 14.1213C3.58552 14.0744 3.54868 14.0242 3.53105 14.0098C3.51359 13.9955 3.4912 13.9377 3.48119 13.8817C3.47135 13.8257 3.44134 13.749 3.41466 13.7114C3.38783 13.6736 3.35861 13.5997 3.34956 13.547C3.34051 13.4943 3.31558 13.4446 3.29414 13.4364C3.27016 13.4273 3.25524 13.3865 3.25524 13.3305C3.25524 13.2711 3.23793 13.2273 3.20569 13.205C3.16838 13.179 3.15123 13.1216 3.13646 12.9741C3.12582 12.866 3.10613 12.7642 3.09279 12.7479C3.07945 12.7315 3.05087 12.6263 3.02928 12.5141C3.00752 12.4019 2.97513 12.2926 2.95719 12.2711C2.90939 12.2141 2.9105 10.9539 2.95846 10.8967C2.97719 10.8744 3.00975 10.7517 3.03086 10.6239C3.08454 10.2991 3.1571 9.99989 3.19267 9.95647C3.20919 9.93633 3.23126 9.87986 3.2419 9.8311C3.25238 9.78233 3.28953 9.68622 3.32431 9.61763C3.35908 9.54889 3.38751 9.47543 3.38751 9.45419C3.38751 9.43311 3.41133 9.38577 3.44054 9.34911C3.4696 9.3123 3.49342 9.26511 3.49342 9.24419C3.49342 9.22311 3.5174 9.17576 3.54662 9.13895C3.57583 9.10214 3.60727 9.03482 3.61648 8.9892C3.62569 8.94358 3.65539 8.89261 3.68238 8.87594C3.70954 8.85911 3.73161 8.83598 3.73161 8.8245C3.73161 8.79728 3.83403 8.65712 3.91025 8.57989C3.94296 8.5467 3.96979 8.50108 3.96979 8.47842C3.96979 8.45577 3.99965 8.42604 4.03601 8.41236C4.07237 8.39867 4.10207 8.37335 4.10207 8.3562C4.10207 8.33905 4.11937 8.30633 4.14065 8.28352C4.16177 8.26056 4.20639 8.21274 4.2399 8.17687C4.27324 8.14116 4.31262 8.08799 4.32723 8.05889C4.342 8.02979 4.39853 7.98433 4.45299 7.9579C4.50746 7.93147 4.55208 7.89797 4.55208 7.88349C4.55208 7.83898 4.69467 7.70448 4.74199 7.70448C4.7666 7.70448 4.79423 7.68089 4.80344 7.6521C4.81265 7.62315 4.83584 7.59956 4.85505 7.59956C4.87426 7.59956 4.89618 7.57596 4.9038 7.54717C4.91142 7.51839 4.93842 7.49479 4.96382 7.49479C4.98923 7.49479 5.05052 7.44791 5.09991 7.39081C5.15977 7.32144 5.21995 7.28133 5.28093 7.27C5.33904 7.25915 5.40272 7.21856 5.45655 7.15753C5.53007 7.07463 5.56516 7.05811 5.72411 7.03137C5.84622 7.01092 5.92435 6.9826 5.95849 6.94626C5.98659 6.91622 6.02581 6.89168 6.0455 6.89168C6.06519 6.89168 6.0879 6.87501 6.09584 6.85456C6.10473 6.83159 6.1692 6.81035 6.264 6.79903C6.35086 6.7888 6.50346 6.74114 6.61429 6.68954C6.77594 6.61451 6.86058 6.59358 7.09066 6.57172C7.26089 6.55567 7.38728 6.53066 7.41333 6.50785C7.46843 6.45972 8.75161 6.46758 8.87912 6.51698C8.92279 6.53381 9.09587 6.55929 9.26387 6.57361C9.44092 6.58855 9.60226 6.61671 9.64767 6.64046C9.81091 6.72572 9.96858 6.78251 10.092 6.80076C10.1623 6.81114 10.2257 6.83474 10.2328 6.8533C10.24 6.87186 10.2777 6.89483 10.3167 6.90442C10.3557 6.91402 10.4115 6.94312 10.4405 6.96892C10.4696 6.99487 10.5452 7.02256 10.6085 7.03042C10.6747 7.0386 10.75 7.06928 10.7857 7.10247C10.9124 7.22045 11.1092 7.08422 11.1462 6.85298C11.166 6.72855 11.305 6.41032 11.3518 6.38154C11.364 6.37414 11.3823 6.32365 11.3925 6.26938C11.4026 6.21511 11.4263 6.15297 11.445 6.13142C11.4638 6.10971 11.4869 6.04915 11.4965 5.99661C11.5074 5.93558 11.5311 5.89672 11.562 5.8887C11.5946 5.88036 11.6159 5.84166 11.6273 5.77072C11.6367 5.71267 11.6622 5.6584 11.6842 5.65007C11.7073 5.64126 11.724 5.60225 11.724 5.55694C11.724 5.51054 11.744 5.46507 11.7734 5.44462C11.8006 5.4259 11.8318 5.36912 11.8428 5.31862C11.8537 5.26813 11.8792 5.19498 11.8993 5.15613C11.9578 5.04271 11.9547 5.03878 11.6891 4.88194C11.6607 4.86511 11.6295 4.83868 11.6197 4.82295C11.6098 4.80722 11.5314 4.78142 11.4453 4.76569C11.2831 4.73596 11.1419 4.65857 11.1419 4.59926C11.1419 4.56513 11.0104 4.53304 10.8689 4.53241C10.8022 4.53225 10.609 4.458 10.4273 4.36283C10.391 4.3438 10.2719 4.31973 10.1626 4.30935C10.0535 4.29897 9.91412 4.26813 9.85314 4.24092C9.79201 4.21355 9.72055 4.19121 9.69435 4.19121C9.66799 4.19105 9.61162 4.17296 9.56907 4.15094C9.43949 4.08409 8.41371 4.05357 7.3622 4.0855Z"
        fill="#F5F5F5"
      />
    </svg>
  ),
  market: (
    <svg
      // width="30"
      // height="25"
      width="100%"
      height="auto"
      aspectRatio="30/25"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 30 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.53218 22.6091L9.64922 14.4094L14.0357 18.6092L19.3969 13.9227L22.3834 16.8346M28.1232 3.92308C28.1232 3.39267 27.9125 2.88398 27.5374 2.50892C27.1624 2.13386 26.6537 1.92316 26.1233 1.92316H3.45745C2.92703 1.92316 2.41834 2.13386 2.04328 2.50892C1.66823 2.88398 1.45752 3.39267 1.45752 3.92308V9.92286H28.1232V3.92308Z"
        stroke="white"
        stroke-width="1.90469"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.1232 8.5896V21.2558C28.1232 21.7862 27.9125 22.2949 27.5374 22.67C27.1624 23.045 26.6537 23.2557 26.1233 23.2557H6.79066M11.5318 5.92303H23.5314M6.19734 5.92303H7.53063M1.45752 8.5896V14.5894"
        stroke="white"
        stroke-width="1.90469"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  trophies: (
    <svg
      // width="20"
      // height="19"
      width="100%"
      height="auto"
      aspectRatio="20/19"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8556 2.2977H16.2958V1.54568C16.2954 1.1469 16.1309 0.764571 15.8385 0.482592C15.5461 0.200614 15.1496 0.0420242 14.7361 0.041626H5.37751C4.96397 0.0420242 4.56748 0.200614 4.27506 0.482592C3.98263 0.764571 3.81817 1.1469 3.81776 1.54568V2.2977H2.258C1.84445 2.2981 1.44796 2.45669 1.15554 2.73867C0.863119 3.02065 0.698655 3.40298 0.698242 3.80176V6.05783C0.699274 6.85533 1.02827 7.61987 1.61307 8.18378C2.19787 8.7477 2.99073 9.06494 3.81776 9.06594H4.06888C4.39386 10.2171 5.0594 11.2521 5.98425 12.0445C6.90909 12.837 8.05321 13.3526 9.27691 13.5285V16.5862H5.37751V18.0902H14.7361V16.5862H10.8367V13.5262C12.0763 13.3784 13.2409 12.8738 14.1785 12.0781C15.1162 11.2825 15.7834 10.2328 16.093 9.06594H16.2958C17.1228 9.06494 17.9157 8.7477 18.5005 8.18378C19.0853 7.61987 19.4143 6.85533 19.4153 6.05783V3.80176C19.4149 3.40298 19.2505 3.02065 18.958 2.73867C18.6656 2.45669 18.2691 2.2981 17.8556 2.2977ZM3.81776 7.56188C3.40421 7.56149 3.00772 7.4029 2.7153 7.12092C2.42288 6.83894 2.25841 6.45661 2.258 6.05783V3.80176H3.81776V7.56188ZM14.7361 7.56188C14.736 8.16613 14.6102 8.76422 14.3659 9.32066C14.1216 9.87711 13.764 10.3806 13.3141 10.8012C12.8642 11.2218 12.3313 11.551 11.747 11.7693C11.1627 11.9875 10.5388 12.0904 9.91251 12.0718C8.67064 11.9974 7.50629 11.4643 6.66164 10.5833C5.81699 9.70229 5.35706 8.5412 5.37751 7.34154V1.54568H14.7361V7.56188ZM17.8556 6.05783C17.8552 6.45661 17.6907 6.83894 17.3983 7.12092C17.1059 7.4029 16.7094 7.56149 16.2958 7.56188V3.80176H17.8556V6.05783Z"
        fill="white"
      />
    </svg>
  ),
  c50: (
    <>
      <svg
        // width="32"
        // height="38"
        widht="100%"
        height="auto"
        aspectRatio="32/38"
        viewBox="0 0 32 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.9663 0.985718C14.4886 2.01286 1.10569 14.6305 0.401062 15.8701V22.7007C1.37761 22.7246 14.3579 9.12351 15.9663 8.47753C17.5747 9.12351 30.555 22.7246 31.5316 22.7007V15.8701C30.8269 14.6305 17.444 2.01277 15.9663 0.985718ZM15.9663 15.5895C14.4886 16.6166 1.10569 29.2342 0.401062 30.474V37.3046C1.37761 37.3286 14.3579 23.7275 15.9663 23.0813C17.5747 23.7274 30.555 37.3285 31.5316 37.3046V30.4739C30.8269 29.2342 17.444 16.6166 15.9663 15.5895Z"
          fill="white"
          fill-opacity="0.8"
        />
      </svg>
    </>
  ),
  c60: (
    <>
      <svg
        width="100%"
        height="auto"
        aspectRatio="42/42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.2425 41.2054C25.9684 41.2054 25.7379 41.1145 25.5509 40.9328C25.364 40.7511 25.2705 40.5221 25.2705 40.2457C25.2705 39.9693 25.362 39.7409 25.5452 39.5604C25.7283 39.38 25.9569 39.2885 26.231 39.286C29.9526 39.286 33.1178 37.982 35.7266 35.3742C38.3353 32.7664 39.6404 29.6038 39.6416 25.8866C39.6416 25.614 39.7332 25.3856 39.9164 25.2013C40.0995 25.0171 40.3281 24.9256 40.6022 24.9269C40.8762 24.9281 41.1042 25.0196 41.286 25.2013C41.4679 25.383 41.5601 25.6114 41.5627 25.8866C41.5627 28.0081 41.1618 29.9999 40.3601 31.8617C39.5584 33.7222 38.4673 35.3441 37.0867 36.7274C35.7061 38.1106 34.0841 39.2028 32.2207 40.0038C30.3573 40.8049 28.3646 41.2054 26.2425 41.2054ZM26.2425 34.7101C25.9684 34.7101 25.7379 34.6186 25.5509 34.4356C25.364 34.2526 25.2705 34.0242 25.2705 33.7504C25.2705 33.4765 25.362 33.2481 25.5452 33.0651C25.7283 32.8822 25.9569 32.7907 26.231 32.7907C28.152 32.7907 29.7836 32.1202 31.1257 30.7791C32.4679 29.4381 33.139 27.8079 33.139 25.8885C33.139 25.6159 33.2305 25.3875 33.4137 25.2032C33.5968 25.019 33.8254 24.9275 34.0995 24.9288C34.3736 24.93 34.6022 25.0215 34.7853 25.2032C34.9684 25.3875 35.06 25.6159 35.06 25.8885C35.0523 28.3466 34.1962 30.4298 32.4916 32.1381C30.787 33.8463 28.704 34.7037 26.2425 34.7101ZM10.1443 38.9731C9.76396 38.9731 9.39512 38.9078 9.03781 38.7773C8.6805 38.6468 8.35905 38.4427 8.07345 38.165L1.25382 31.3511C0.975911 31.0658 0.771002 30.7446 0.639092 30.3876C0.509743 30.0306 0.445068 29.6614 0.445068 29.2801C0.445068 28.8911 0.510383 28.5264 0.641013 28.186C0.771642 27.8456 0.976552 27.536 1.25574 27.257L6.6154 21.9019C7.1789 21.3388 7.86342 21.0554 8.66897 21.0516C9.47452 21.0477 10.159 21.3273 10.7225 21.8903L13.5292 24.6965L16.2416 21.9863L13.4331 19.1821C12.8696 18.619 12.5879 17.9383 12.5879 17.1398C12.5879 16.3413 12.8696 15.6612 13.4331 15.0995L15.431 13.1033C15.9958 12.5403 16.6732 12.2587 17.4634 12.2587C18.2536 12.2587 18.9298 12.5403 19.492 13.1033L22.3006 15.9075L25.0111 13.1973L22.2045 10.3931C21.641 9.83005 21.3593 9.14802 21.3593 8.34699C21.3593 7.54596 21.641 6.86329 22.2045 6.29898L27.5642 0.943825C27.8498 0.658473 28.1654 0.444139 28.5112 0.300823C28.8557 0.158787 29.2188 0.0877686 29.6004 0.0877686C29.9821 0.0877686 30.3496 0.153028 30.7031 0.283548C31.0566 0.414068 31.3761 0.622004 31.6617 0.907356L38.4813 7.72126C38.7669 7.99894 38.9731 8.31436 39.0999 8.66753C39.2267 9.0207 39.2907 9.39179 39.292 9.78079C39.292 10.1621 39.228 10.5313 39.0999 10.8883C38.9731 11.244 38.7669 11.5652 38.4813 11.8518L33.1217 17.207C32.5582 17.77 31.8749 18.0515 31.072 18.0515C30.269 18.0515 29.5864 17.77 29.0241 17.207L26.2156 14.4008L23.505 17.111L26.3117 19.9153C26.8752 20.4783 27.1556 21.161 27.1531 21.9633C27.1492 22.7643 26.8656 23.4463 26.3021 24.0094L24.3503 25.9595C23.7868 26.5225 23.1042 26.8104 22.3025 26.8232C21.5008 26.836 20.8175 26.5603 20.2527 25.996L17.4461 23.1898L14.7336 25.9L17.5422 28.7042C18.1057 29.2673 18.3855 29.9519 18.3817 30.758C18.3791 31.5616 18.0954 32.2456 17.5307 32.8099L12.171 38.165C11.8918 38.4427 11.5819 38.6474 11.2412 38.7792C10.9006 38.911 10.5336 38.9757 10.1443 38.9731ZM9.51806 36.8809C9.69096 37.0537 9.90035 37.1401 10.1462 37.1401C10.3921 37.1401 10.6015 37.0537 10.7744 36.8809L12.9029 34.7542L4.7155 26.5756L2.58701 28.7004C2.4154 28.8732 2.32959 29.0824 2.32959 29.3281C2.32959 29.5737 2.4154 29.783 2.58701 29.9557L9.51806 36.8809ZM14.117 33.5028L16.2455 31.378C16.4184 31.2052 16.5048 30.996 16.5048 30.7503C16.5048 30.5047 16.4184 30.2954 16.2455 30.1227L9.31444 23.1975C9.14282 23.0247 8.93343 22.9383 8.68626 22.9383C8.43909 22.9383 8.2297 23.0247 8.05809 23.1975L5.93151 25.3242L14.117 33.5028ZM21.6609 24.6735C21.8337 24.8462 22.0431 24.9326 22.289 24.9326C22.5349 24.9326 22.7443 24.8462 22.9172 24.6735L25.015 22.5775C25.1879 22.4047 25.2743 22.1955 25.2743 21.9498C25.2743 21.7042 25.1879 21.4949 25.015 21.3222L18.0858 14.397C17.9129 14.2255 17.7035 14.1398 17.4577 14.1398C17.2118 14.1398 17.0024 14.2255 16.8295 14.397L14.7298 16.4949C14.5582 16.6663 14.4724 16.8756 14.4724 17.1225C14.4724 17.3695 14.5582 17.5787 14.7298 17.7502L21.6609 24.6735ZM30.4323 15.8749C30.6039 16.0464 30.8126 16.1321 31.0585 16.1321C31.3044 16.1321 31.5138 16.0464 31.6867 15.8749L33.8152 13.7482L25.6297 5.56768L23.5012 7.69439C23.3283 7.86714 23.2419 8.07635 23.2419 8.32204C23.2419 8.56772 23.3283 8.77694 23.5012 8.94968L30.4323 15.8749ZM35.0677 12.5351L37.1962 10.4084C37.3678 10.2357 37.4536 10.0265 37.4536 9.78079C37.4536 9.5351 37.3678 9.32589 37.1962 9.15314L30.2651 2.22791C30.0922 2.05516 29.8828 1.96879 29.637 1.96879C29.3911 1.96879 29.1817 2.05516 29.0088 2.22791L26.8803 4.35462L35.0677 12.5351Z"
          fill="white"
          fill-opacity="0.8"
        />
      </svg>
    </>
  ),
  c70: (
    <>
      <svg
        // width="38"
        // height="38"
        width="100%"
        height="auto"
        aspectRatio="38/38"
        viewBox="0 0 38 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.8"
          width="38"
          height="38"
          fill="url(#pattern0_79_919)"
        />
        <defs>
          <pattern
            id="pattern0_79_919"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use href="#image0_79_919" transform="scale(0.00195312)" />
          </pattern>
          <image
            id="image0_79_919"
            width="512"
            height="512"
            href="data:image/png;base64,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"
          />
        </defs>
      </svg>
    </>
  ),
  c80: (
    <>
      <svg
        // width="37"
        // height="38"
        width="100%"
        height="auto"
        aspectRatio="37/38"
        viewBox="0 0 37 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0625 31.8568H20.2404V29.5868C21.7536 29.3144 23.0551 28.7243 24.1446 27.8163C25.2342 26.9083 25.779 25.5615 25.779 23.7758C25.779 22.5047 25.4158 21.3394 24.6894 20.2801C23.963 19.2208 22.5103 18.2977 20.3311 17.5108C18.5152 16.9055 17.2592 16.3758 16.5631 15.9219C15.867 15.4679 15.5189 14.8474 15.5189 14.0605C15.5189 13.2736 15.7992 12.6532 16.3597 12.1992C16.9202 11.7452 17.7295 11.5182 18.7876 11.5182C19.7561 11.5182 20.5127 11.7525 21.0575 12.221C21.6023 12.6895 21.9958 13.2724 22.2379 13.9697L25.1434 12.7894C24.8105 11.7301 24.1979 10.8069 23.3057 10.02C22.4134 9.23313 21.4219 8.79428 20.3311 8.70348V6.43355H17.1532V8.70348C15.64 9.0364 14.4596 9.70225 13.6122 10.701C12.7647 11.6998 12.341 12.8196 12.341 14.0605C12.341 15.483 12.7575 16.6331 13.5904 17.5108C14.4233 18.3885 15.732 19.1452 17.5164 19.7807C19.4232 20.4769 20.7476 21.0973 21.4897 21.6421C22.2318 22.1869 22.6023 22.8981 22.6011 23.7758C22.6011 24.7746 22.2458 25.5088 21.5351 25.9786C20.8245 26.4483 19.9692 26.6825 18.9692 26.6813C17.9692 26.6801 17.0836 26.3702 16.3125 25.7516C15.5413 25.1329 14.9741 24.202 14.6109 22.9586L11.6146 24.139C12.0383 25.5918 12.6969 26.7649 13.5904 27.6583C14.4838 28.5518 15.6412 29.1643 17.0625 29.496V31.8568ZM18.6968 37.3046C16.1847 37.3046 13.824 36.8276 11.6146 35.8736C9.40522 34.9197 7.48334 33.6261 5.84899 31.993C4.21464 30.3598 2.92109 28.438 1.96832 26.2273C1.01555 24.0167 0.538566 21.656 0.537356 19.1452C0.536145 16.6343 1.01313 14.2736 1.96832 12.063C2.92351 9.85237 4.21706 7.93049 5.84899 6.29736C7.48092 4.66422 9.4028 3.37066 11.6146 2.41668C13.8264 1.46271 16.1872 0.985718 18.6968 0.985718C21.2064 0.985718 23.5672 1.46271 25.779 2.41668C27.9908 3.37066 29.9127 4.66422 31.5446 6.29736C33.1765 7.93049 34.4707 9.85237 35.4271 12.063C36.3835 14.2736 36.8599 16.6343 36.8562 19.1452C36.8526 21.656 36.3756 24.0167 35.4253 26.2273C34.4749 28.438 33.1814 30.3598 31.5446 31.993C29.9078 33.6261 27.986 34.9203 25.779 35.8755C23.572 36.8306 21.2113 37.307 18.6968 37.3046ZM18.6968 33.6727C22.7524 33.6727 26.1876 32.2654 29.0023 29.4506C31.817 26.6359 33.2244 23.2008 33.2244 19.1452C33.2244 15.0896 31.817 11.6544 29.0023 8.83968C26.1876 6.02496 22.7524 4.61761 18.6968 4.61761C14.6412 4.61761 11.206 6.02496 8.39132 8.83968C5.5766 11.6544 4.16924 15.0896 4.16924 19.1452C4.16924 23.2008 5.5766 26.6359 8.39132 29.4506C11.206 32.2654 14.6412 33.6727 18.6968 33.6727Z"
          fill="white"
          fill-opacity="0.8"
        />
      </svg>
    </>
  ),
  c90: (
    <>
      <svg
        // width="37"
        // height="38"
        width="100%"
        height="auto"
        aspectRatio="37/38"
        viewBox="0 0 37 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0625 31.8568H20.2404V29.5868C21.7536 29.3144 23.0551 28.7243 24.1446 27.8163C25.2342 26.9083 25.779 25.5615 25.779 23.7758C25.779 22.5047 25.4158 21.3394 24.6894 20.2801C23.963 19.2208 22.5103 18.2977 20.3311 17.5108C18.5152 16.9055 17.2592 16.3758 16.5631 15.9219C15.867 15.4679 15.5189 14.8474 15.5189 14.0605C15.5189 13.2736 15.7992 12.6532 16.3597 12.1992C16.9202 11.7452 17.7295 11.5182 18.7876 11.5182C19.7561 11.5182 20.5127 11.7525 21.0575 12.221C21.6023 12.6895 21.9958 13.2724 22.2379 13.9697L25.1434 12.7894C24.8105 11.7301 24.1979 10.8069 23.3057 10.02C22.4134 9.23313 21.4219 8.79428 20.3311 8.70348V6.43355H17.1532V8.70348C15.64 9.0364 14.4596 9.70225 13.6122 10.701C12.7647 11.6998 12.341 12.8196 12.341 14.0605C12.341 15.483 12.7575 16.6331 13.5904 17.5108C14.4233 18.3885 15.732 19.1452 17.5164 19.7807C19.4232 20.4769 20.7476 21.0973 21.4897 21.6421C22.2318 22.1869 22.6023 22.8981 22.6011 23.7758C22.6011 24.7746 22.2458 25.5088 21.5351 25.9786C20.8245 26.4483 19.9692 26.6825 18.9692 26.6813C17.9692 26.6801 17.0836 26.3702 16.3125 25.7516C15.5413 25.1329 14.9741 24.202 14.6109 22.9586L11.6146 24.139C12.0383 25.5918 12.6969 26.7649 13.5904 27.6583C14.4838 28.5518 15.6412 29.1643 17.0625 29.496V31.8568ZM18.6968 37.3046C16.1847 37.3046 13.824 36.8276 11.6146 35.8736C9.40522 34.9197 7.48334 33.6261 5.84899 31.993C4.21464 30.3598 2.92109 28.438 1.96832 26.2273C1.01555 24.0167 0.538566 21.656 0.537356 19.1452C0.536145 16.6343 1.01313 14.2736 1.96832 12.063C2.92351 9.85237 4.21706 7.93049 5.84899 6.29736C7.48092 4.66422 9.4028 3.37066 11.6146 2.41668C13.8264 1.46271 16.1872 0.985718 18.6968 0.985718C21.2064 0.985718 23.5672 1.46271 25.779 2.41668C27.9908 3.37066 29.9127 4.66422 31.5446 6.29736C33.1765 7.93049 34.4707 9.85237 35.4271 12.063C36.3835 14.2736 36.8599 16.6343 36.8562 19.1452C36.8526 21.656 36.3756 24.0167 35.4253 26.2273C34.4749 28.438 33.1814 30.3598 31.5446 31.993C29.9078 33.6261 27.986 34.9203 25.779 35.8755C23.572 36.8306 21.2113 37.307 18.6968 37.3046ZM18.6968 33.6727C22.7524 33.6727 26.1876 32.2654 29.0023 29.4506C31.817 26.6359 33.2244 23.2008 33.2244 19.1452C33.2244 15.0896 31.817 11.6544 29.0023 8.83968C26.1876 6.02496 22.7524 4.61761 18.6968 4.61761C14.6412 4.61761 11.206 6.02496 8.39132 8.83968C5.5766 11.6544 4.16924 15.0896 4.16924 19.1452C4.16924 23.2008 5.5766 26.6359 8.39132 29.4506C11.206 32.2654 14.6412 33.6727 18.6968 33.6727Z"
          fill="white"
          fill-opacity="0.8"
        />
        <path
          d="M7.02283 28.2249L27.8507 7.54539"
          stroke="white"
          stroke-opacity="0.8"
          stroke-width="3.45894"
        />
      </svg>
    </>
  ),
};

const GlowBoxInactive = () => {
  let r2dark = get_cprofile_hex("r2dark");
  let r2reg = get_cprofile_hex("r2reg");
  let r2lig = get_cprofile_hex("r2lig");
  let acc0 = get_cprofile_hex("acc0");
  let acc4 = get_cprofile_hex("acc4");

  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 145 133"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_35_715)">
          <rect
            x="5.48285"
            y="5.98767"
            width="121.713"
            height="121.713"
            fill={r2reg}
            fill-opacity="0.15"
          />
          <rect
            x="5.48285"
            y="5.98767"
            width="121.713"
            height="121.713"
            stroke="url(#paint0_linear_35_715)"
            stroke-width="1.52142"
          />
          <rect
            x="5.48285"
            y="5.98767"
            width="121.713"
            height="121.713"
            stroke="url(#paint1_linear_35_715)"
            stroke-width="1.52142"
          />
        </g>
        <rect
          x="5.48285"
          y="5.98767"
          width="121.713"
          height="121.713"
          stroke="url(#paint2_linear_35_715)"
          stroke-width="1.52142"
        />
        <rect
          x="5.48285"
          y="5.98767"
          width="121.713"
          height="121.713"
          stroke="url(#paint3_linear_35_715)"
          stroke-width="1.52142"
        />
        <rect
          x="5.48285"
          y="5.98767"
          width="121.713"
          height="121.713"
          stroke="url(#paint4_linear_35_715)"
          stroke-width="1.52142"
        />
        <g filter="url(#filter1_f_35_715)">
          <rect
            x="10.0471"
            y="101.837"
            width="113.092"
            height="21.2998"
            fill="url(#paint5_linear_35_715)"
          />
        </g>
        <g filter="url(#filter2_f_35_715)">
          <rect
            x="123.139"
            y="112.994"
            width="113.092"
            height="13.6927"
            transform="rotate(-180 123.139 112.994)"
            fill="url(#paint6_linear_35_715)"
          />
        </g>
        <g opacity="0.6" filter="url(#filter3_f_35_715)">
          <rect
            x="10.0471"
            y="99.301"
            width="112.585"
            height="23.8355"
            stroke={r2lig}
            stroke-width="0.507138"
          />
        </g>
        <g opacity="0.1" filter="url(#filter4_f_35_715)">
          <rect
            x="15.6256"
            y="15.9363"
            width="87.2278"
            height="74.2364"
            fill={r2lig}
          />
          <rect
            x="15.6256"
            y="15.9363"
            width="87.2278"
            height="74.2364"
            stroke="url(#paint7_linear_35_715)"
            stroke-width="0.927954"
          />
        </g>
        <g filter="url(#filter5_f_35_715)">
          <rect
            x="15.6256"
            y="17.0154"
            width="87.2278"
            height="74.2364"
            stroke="url(#paint8_linear_35_715)"
            stroke-width="0.927955"
          />
        </g>
        <line
          x1="14.6113"
          y1="102.344"
          x2="78.0036"
          y2="102.344"
          stroke={acc0}
          stroke-width="1.01428"
        />
        <g filter="url(#filter6_f_35_715)">
          <line
            x1="13.5971"
            y1="120.601"
            x2="76.9894"
            y2="120.601"
            stroke={acc4}
            stroke-width="1.01428"
          />
        </g>
        <g filter="url(#filter7_f_35_715)">
          <line
            x1="11.0614"
            y1="122.629"
            x2="122.125"
            y2="122.629"
            stroke={acc0}
            stroke-width="1.01428"
          />
        </g>
        <g filter="url(#filter8_f_35_715)">
          <line
            x1="28.8112"
            y1="122.629"
            x2="143.932"
            y2="122.629"
            stroke="url(#paint9_radial_35_715)"
            stroke-width="1.01428"
          />
        </g>
        <line
          x1="127.196"
          y1="90.4262"
          x2="28.8112"
          y2="90.4262"
          stroke="url(#paint10_linear_35_715)"
          stroke-width="0.507138"
        />
        <defs>
          <filter
            id="filter0_f_35_715"
            x="0.1806"
            y="0.685391"
            width="132.318"
            height="132.318"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.27077"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter1_f_35_715"
            x="6.14737"
            y="97.9371"
            width="120.891"
            height="29.0992"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.94986"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter2_f_35_715"
            x="6.1474"
            y="95.4013"
            width="120.891"
            height="21.4922"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.94986"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter3_f_35_715"
            x="9.28638"
            y="98.5403"
            width="114.106"
            height="25.3569"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.253569"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter4_f_35_715"
            x="12.3778"
            y="12.6884"
            width="93.7235"
            height="80.7322"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.39193"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter5_f_35_715"
            x="12.3778"
            y="13.7675"
            width="93.7235"
            height="80.7322"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.39193"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter6_f_35_715"
            x="13.0899"
            y="119.587"
            width="64.4066"
            height="2.02856"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.253569"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter7_f_35_715"
            x="10.5542"
            y="121.615"
            width="112.078"
            height="2.02856"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.253569"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <filter
            id="filter8_f_35_715"
            x="28.3041"
            y="121.615"
            width="116.135"
            height="2.02856"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.253569"
              result="effect1_foregroundBlur_35_715"
            />
          </filter>
          <linearGradient
            id="paint0_linear_35_715"
            x1="103.126"
            y1="127.701"
            x2="71.7893"
            y2="73.6566"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2dark} />
            <stop offset="0.44145" stop-color={acc0} stop-opacity="0.761754" />
            <stop offset="1" stop-color={acc4} stop-opacity="0.13" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_35_715"
            x1="5.48285"
            y1="5.98767"
            x2="62.025"
            y2="77.2898"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc0} />
            <stop offset="0.202101" stop-color={acc4} />
            <stop
              offset="0.399258"
              stop-color={r2dark}
              stop-opacity="0.716253"
            />
            <stop offset="1" stop-color={r2reg} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_35_715"
            x1="103.126"
            y1="127.701"
            x2="71.7893"
            y2="73.6566"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc0} />
            <stop offset="0.44145" stop-color={acc4} stop-opacity="0.761754" />
            <stop offset="1" stop-color={acc0} stop-opacity="0.13" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_35_715"
            x1="5.48285"
            y1="5.98767"
            x2="68.6102"
            y2="47.9969"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc0} />
            <stop offset="0.202101" stop-color={acc4} />
            <stop offset="0.399258" stop-color={acc0} stop-opacity="0.716253" />
            <stop offset="0.499475" stop-color={acc4} stop-opacity="0.82" />
            <stop offset="1" stop-color={acc4} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_35_715"
            x1="-6.32515"
            y1="79.3335"
            x2="12.5222"
            y2="81.3772"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc4} />
            <stop offset="0.44145" stop-color={acc0} stop-opacity="0.761754" />
            <stop offset="1" stop-color={acc0} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_35_715"
            x1="86.625"
            y1="122.271"
            x2="86.625"
            y2="103.199"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2reg} />
            <stop offset="1" stop-color={r2lig} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_35_715"
            x1="199.717"
            y1="126.13"
            x2="199.717"
            y2="113.87"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2reg} />
            <stop offset="1" stop-color={r2lig} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_35_715"
            x1="93.3419"
            y1="27.6578"
            x2="24.6958"
            y2="82.3088"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2reg} />
            <stop offset="1" stop-color={r2lig} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_35_715"
            x1="93.3419"
            y1="28.7369"
            x2="24.6958"
            y2="83.3879"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2reg} />
            <stop offset="1" stop-color={r2lig} stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint9_radial_35_715"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(86.3714 123.637) rotate(-179.263) scale(38.8564 540.696)"
          >
            <stop stop-color={r2dark} />
            <stop offset="1" stop-color={acc0} stop-opacity="0" />
          </radialGradient>
          <linearGradient
            id="paint10_linear_35_715"
            x1="122.885"
            y1="90.1726"
            x2="34.3897"
            y2="90.1725"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc4} stop-opacity="0.06" />
            <stop
              offset="0.124587"
              stop-color={r2reg}
              stop-opacity="0.869206"
            />
            <stop offset="1" stop-color={r2lig} stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
const GlowBoxActive = () => {
  const r2dark = get_cprofile_hex("r2dark");
  const r2reg = get_cprofile_hex("r2reg");
  const r2lig = get_cprofile_hex("r2lig");
  const acc0 = get_cprofile_hex("acc0");
  const acc4 = get_cprofile_hex("acc4");
  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 163 149"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_35_732)">
          <rect
            x="6.16193"
            y="5.94617"
            width="136.537"
            height="136.537"
            fill="#1D3354"
          />
          <rect
            x="6.16193"
            y="5.94617"
            width="136.537"
            height="136.537"
            stroke="white"
            stroke-width="1.70672"
          />
        </g>
        <rect
          x="6.16193"
          y="5.94617"
          width="136.537"
          height="136.537"
          fill="#1D3354"
          stroke="white"
          stroke-width="1.70672"
        />
        <rect
          x="6.16193"
          y="5.94617"
          width="136.537"
          height="136.537"
          fill={r2dark}
          stroke={acc4}
          stroke-width="1.70672"
        />
        <g filter="url(#filter1_f_35_732)">
          <rect
            x="11.2821"
            y="113.469"
            width="126.866"
            height="23.894"
            fill="url(#paint0_linear_35_732)"
          />
        </g>
        <g filter="url(#filter2_f_35_732)">
          <rect
            x="138.148"
            y="125.985"
            width="126.866"
            height="15.3604"
            transform="rotate(-180 138.148 125.985)"
            fill="url(#paint1_linear_35_732)"
          />
        </g>
        <g opacity="0.6" filter="url(#filter3_f_35_732)">
          <rect
            x="11.2821"
            y="110.625"
            width="126.297"
            height="26.7385"
            stroke="#107DB8"
            stroke-width="0.568905"
          />
        </g>
        <g opacity="0.1" filter="url(#filter4_f_35_732)">
          <rect
            x="17.54"
            y="17.1064"
            width="97.8517"
            height="83.278"
            fill={r2lig}
          />
          <rect
            x="17.54"
            y="17.1064"
            width="97.8517"
            height="83.278"
            stroke="url(#paint2_linear_35_732)"
            stroke-width="1.04097"
          />
        </g>
        <g filter="url(#filter5_f_35_732)">
          <rect
            x="17.54"
            y="18.3171"
            width="97.8517"
            height="83.278"
            stroke="url(#paint3_linear_35_732)"
            stroke-width="1.04098"
          />
        </g>
        <line
          x1="16.4022"
          y1="114.038"
          x2="87.5154"
          y2="114.038"
          stroke={r2lig}
          stroke-width="1.13781"
        />
        <g filter="url(#filter6_f_35_732)">
          <line
            x1="15.2644"
            y1="134.519"
            x2="86.3776"
            y2="134.519"
            stroke={r2lig}
            stroke-width="1.13781"
          />
        </g>
        <g filter="url(#filter7_f_35_732)">
          <line
            x1="12.4199"
            y1="136.794"
            x2="137.01"
            y2="136.794"
            stroke="white"
            stroke-width="1.13781"
          />
        </g>
        <g filter="url(#filter8_f_35_732)">
          <line
            x1="32.3316"
            y1="136.794"
            x2="161.473"
            y2="136.794"
            stroke="url(#paint4_radial_35_732)"
            stroke-width="1.13781"
          />
        </g>
        <line
          x1="142.699"
          y1="100.669"
          x2="32.3315"
          y2="100.669"
          stroke="white"
          stroke-width="0.568905"
        />
        <defs>
          <filter
            id="filter0_f_35_732"
            x="0.213894"
            y="-0.00183964"
            width="148.433"
            height="148.433"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.54734"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter1_f_35_732"
            x="6.90738"
            y="109.095"
            width="135.615"
            height="32.6434"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.18734"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter2_f_35_732"
            x="6.90738"
            y="106.25"
            width="135.615"
            height="24.1098"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="2.18734"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter3_f_35_732"
            x="10.4287"
            y="109.771"
            width="128.004"
            height="28.4452"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.284453"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter4_f_35_732"
            x="13.8966"
            y="13.463"
            width="105.139"
            height="90.5649"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.56146"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter5_f_35_732"
            x="13.8966"
            y="14.6737"
            width="105.139"
            height="90.5649"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="1.56146"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter6_f_35_732"
            x="14.6955"
            y="133.381"
            width="72.251"
            height="2.27563"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.284453"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter7_f_35_732"
            x="11.851"
            y="135.657"
            width="125.728"
            height="2.27563"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.284453"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <filter
            id="filter8_f_35_732"
            x="31.7626"
            y="135.657"
            width="130.279"
            height="2.27563"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="0.284453"
              result="effect1_foregroundBlur_35_732"
            />
          </filter>
          <linearGradient
            id="paint0_linear_35_732"
            x1="97.1868"
            y1="136.392"
            x2="97.1868"
            y2="114.998"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2reg} />
            <stop offset="1" stop-color={r2reg} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_35_732"
            x1="224.053"
            y1="140.721"
            x2="224.053"
            y2="126.968"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={r2reg} />
            <stop offset="1" stop-color={r2reg} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_35_732"
            x1="104.722"
            y1="30.2556"
            x2="27.7149"
            y2="91.5628"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc0} />
            <stop offset="1" stop-color={acc4} stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_35_732"
            x1="104.722"
            y1="31.4663"
            x2="27.7149"
            y2="92.7735"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color={acc0} />
            <stop offset="1" stop-color={acc4} stop-opacity="0" />
          </linearGradient>
          <radialGradient
            id="paint4_radial_35_732"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(96.9023 137.863) rotate(-179.343) scale(43.5881 540.705)"
          >
            <stop stop-color={acc4} />
            <stop offset="1" stop-color={acc0} stop-opacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </>
  );
};

export const GlowBox = ({
  onClick = () => {},
  active = false,
  svg = null,
  text = null,
}) => {
  return (
    <div onClick={onClick} className="relative">
      <div class="absolute top-[25%] left-[25%] ">
        <div class="xs:w-[1.5rem] lg:w-[3rem] aspect-[1/1]">{svg}</div>
      </div>
      {active ? <GlowBoxActive /> : <GlowBoxInactive />}
      <p className="absolute text-white w-[70%] text-center mx-[10%] bottom-[8%] font-digi resp-text--1">
        {text}
      </p>
    </div>
  );
};

export const SkewBtn_old = (props) => {
  return (
    <div
      {...props}
      class={twMerge(
        "fc-cs relative w-[10rem] aspect-[146/34]",
        "xs:min-h-[0.8rem] lg:min-h-[1rem]",
        props.cont_cn,
        "transition duration-200 cursor-pointer",
        // props.active ? "scale-x-[1.1]" : "scale-x-[0]",
      )}
    >
      <div
        class={twMerge(
          "absolute z-1 top-0 left-0 w-full h-full",
          "transition duration-500",
          props.active ? "scale-x-[1.2] translate-x-[10%]" : "scale-x-[1]",
        )}
      >
        <img
          className="w-full h-full object-stretch"
          src="/r2_design/btn-skewed.png"
          alt=""
        />
      </div>
      <div class="absolute left-[20%] z-2 w-full">
        <span className={twMerge(props.tag_cn, props.active ? "italic" : "")}>
          {props.text}
        </span>
      </div>
    </div>
  );
};

export const SkewBtn = (props) => {
  let c0 = get_cprofile_hex("acc0");
  let c4 = get_cprofile_hex("acc4");
  return (
    <div
      {...props}
      class={twMerge(
        "fc-cs relative w-[10rem] aspect-[146/34]",
        "xs:min-h-[0.8rem] lg:min-h-[1rem]",
        props.cont_cn,
        "transition duration-200 cursor-pointer",
        // props.active ? "scale-x-[1.1]" : "scale-x-[0]",
      )}
    >
      <div
        class={twMerge(
          "absolute z-1 top-0 left-0 w-full h-full",
          "transition duration-500",
          props.active ? "scale-x-[1.2] translate-x-[10%]" : "scale-x-[1]",
        )}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 175 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.613898 28C0.613898 30.4224 2.57765 32.3862 5.00006 32.3862L149.212 32.3862C150.486 32.3862 151.698 31.8316 152.531 30.8669L172.395 7.86687C174.849 5.02498 172.83 0.613838 169.075 0.613838L5.00006 0.613838C2.57765 0.613838 0.613898 2.57759 0.613898 5L0.613898 28Z"
            fill={c4}
            fill-opacity="0.2"
            stroke="url(#paint0_linear_55_910)"
            stroke-width="1.22767"
          />
          <defs>
            <linearGradient
              id="paint0_linear_55_910"
              x1="-6.42851"
              y1="5.86667"
              x2="191.183"
              y2="38.3036"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c4} />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="absolute left-[20%] z-2 w-full">
        <span className={twMerge(props.tag_cn, props.active ? "italic" : "")}>
          {props.text}
        </span>
      </div>
    </div>
  );
};

export const SkewWrap2 = (props) => {
  const c0 = get_cprofile_hex("acc0");
  const c4 = get_cprofile_hex("acc4");
  return (
    <div
      {...props}
      class={twMerge(
        "fc-cs relative w-[100%] ",
        props.cont_cn,
        "transition duration-200 cursor-pointer",
        "aspect-[396/90]",
      )}
    >
      {props.active ? (
        <></>
      ) : (
        <div
          class={twMerge(
            "absolute z-1 top-0 left-0 w-full h-full",
            "transition duration-500",
          )}
        >
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 198 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M197.386 40C197.386 42.4224 195.422 44.3862 193 44.3862L30.5639 44.3862C29.1437 44.3862 27.8114 43.6986 26.9887 42.541L2.1128 7.54101C0.0487401 4.63692 2.12506 0.61384 5.68795 0.61384L193 0.613857C195.422 0.613857 197.386 2.57761 197.386 5.00002L197.386 40Z"
              fill={c4}
              fill-opacity="0.2618"
              stroke="url(#paint0_linear_35_800)"
              stroke-width="1.22767"
            />
            <defs>
              <linearGradient
                id="paint0_linear_35_800"
                x1="205.214"
                y1="8.00002"
                x2="-18.4436"
                y2="38.2129"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color={c0} />
                <stop offset="1" stop-color={c4} />
              </linearGradient>
            </defs>
          </svg>
        </div>
      )}
      <div class="absolute w-[80%] right-0 z-2">{props.children}</div>
    </div>
  );
};

export const FiltCard = ({
  nf,
  set_nf,
  nfkey,
  filtmap,
  top_jsx = null,
  bottom_jsx = null,
}) => {
  const inpargs = {
    nf,
    set_nf,
    nfkey,
  };

  const [selkey, set_selkey] = useState(getv(filtmap, "order.0"));

  const all_sels = useMemo(() => {
    let ar = [];
    for (let idd of filtmap.order) {
      let path = getv(filtmap, `filt.${idd}.path`);
      let type = getv(filtmap, `filt.${idd}.type`);
      let vals = type == "option" ? [getv(nf, path)] : getv(nf, path);
      if (!_.isEmpty(vals)) for (let v of vals) ar.push([idd, v]);
    }
    return ar;
  }, [jstr(nf)]);

  const clear_filts = () => {
    set_nf({});
  };

  const c0 = get_cprofile_hex("acc0");
  const c4 = get_cprofile_hex("acc4");

  return (
    <div class={twMerge("w-full bg-r2lig/20 relative min-h-[30rem] ")}>
      <div class="absolute pointer-events-none z-[1] top-0 left-0 w-full h-full">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 708 415"
          preserveAspectRatio="none"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="1"
            y="1"
            width="706"
            height="413"
            rx="9"
            stroke="url(#paint0_linear_2021_46)"
            stroke-width="2"
          />
          <defs>
            <linearGradient
              id="paint0_linear_2021_46"
              x1="0"
              y1="208"
              x2="708"
              y2="208"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c4} />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="resp-p-2 overflow-hidden">
        <div class="xs:hidden lg:block relative">
          <div class="absolute z-[1] top-[-12px] left-[-12px] xs:w-[4rem] lg:w-[8rem] h-auto">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 106 130"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.7"
                x="93.6943"
                y="-12.0656"
                width="16.3205"
                height="183.415"
                transform="rotate(45 93.6943 -12.0656)"
                fill="url(#paint0_linear_0_1)"
              />
              <rect
                opacity="0.7"
                x="33.8083"
                y="-17"
                width="16.3205"
                height="71.8538"
                transform="rotate(45 33.8083 -17)"
                fill="url(#paint1_linear_0_1)"
              />
              <rect
                opacity="0.7"
                x="61.1858"
                y="-11.3774"
                width="16.3205"
                height="118.176"
                transform="rotate(45 61.1858 -11.3774)"
                fill="url(#paint2_linear_0_1)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_0_1"
                  x1="93.6943"
                  y1="79.6422"
                  x2="110.015"
                  y2="79.6422"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color={c0} />
                  <stop offset="1" stop-color={c4} />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_0_1"
                  x1="33.8083"
                  y1="18.9269"
                  x2="50.1288"
                  y2="18.9269"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color={c0} />
                  <stop offset="1" stop-color={c4} />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_0_1"
                  x1="61.1858"
                  y1="47.7107"
                  x2="77.5063"
                  y2="47.7107"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color={c0} />
                  <stop offset="1" stop-color={c4} />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
        <div
          class={twMerge(
            "z-[3]",
            "xs:pl-[0rem] xs:pt-[0.5rem] ",
            "lg:pl-[3.5rem] lg:pt-[3.5rem] ",
          )}
        >
          {top_jsx}
          <div class="fr-ss my-2 w-full">
            <div class="flex-1">
              <div className="fr-sc w-full flex-wrap">
                {all_sels.map(([idd, op]) => {
                  return (
                    <F_OptionBtn_R2_rounded
                      {...{
                        active: true,
                        op: op,
                        txt_fn: getv(filtmap, `filt.${idd}.txt_fn`),
                        onClick: () => {
                          let path = getv(filtmap, `filt.${idd}.path`);
                          let type = getv(filtmap, `filt.${idd}.type`);
                          let vals = getv(nf, path);
                          if (type == "option") {
                            set_state_ob(nf, set_nf, path, null);
                          } else if (
                            type == "options" ||
                            type == "options-and"
                          ) {
                            set_state_ob(
                              nf,
                              set_nf,
                              path,
                              (vals ?? []).filter((e) => e != op),
                            );
                          } else if (type == "option-ar") {
                            set_state_ob(nf, set_nf, path, []);
                          }
                        },
                      }}
                    />
                  );
                })}
              </div>
            </div>

            <div
              onClick={clear_filts}
              className={twMerge(
                "resp-text--2 fc-cc cursor-pointer rounded-full bg-r2lig",
                "xs:w-[5rem] lg:w-[7rem] aspect-[88/33] font-bold  m-[0.5rem]",
              )}
            >
              Clear Filters
            </div>
          </div>

          <div className="fr-sc">
            <div className="xs:w-[8rem] lg:w-[15rem] fc-ss resp-gap-2">
              {filtmap.order.map((idd) => {
                let txt = getv(filtmap, `filt.${idd}.label`);
                return (
                  <SkewBtn
                    cont_cn="xs:w-[6rem] lg:w-[10rem]"
                    tag_cn="resp-text-1"
                    onClick={() => set_selkey(idd)}
                    text={txt}
                    active={idd == selkey}
                  />
                );
              })}
            </div>
            <div className="flex-1">
              <div className="h-[18rem] w-full rounded-md overflow-auto relative">
                <div class="absolute h-full w-full z-[1] top-0 left-0">
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 408 283"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M5 282.386L403 282.386C405.422 282.386 407.386 280.422 407.386 278L407.386 4.99997C407.386 2.57758 405.422 0.613831 403 0.613831L5 0.613831C2.57759 0.613831 0.613836 2.57758 0.613836 5L0.613836 278C0.613836 280.422 2.57759 282.386 5 282.386Z"
                      fill={c4}
                      fill-opacity="0.1"
                      stroke="url(#paint0_linear_2021_51)"
                      stroke-width="1.22767"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_2021_51"
                        x1="-14.5714"
                        y1="50.3111"
                        x2="444.553"
                        y2="70.2304"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color={c0} />
                        <stop offset="1" stop-color={c4} />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div class="absolute h-full w-full z-[2] top-0 left-0 resp-p-2">
                  {!nils(selkey) && (
                    <F_OptionInput_Raw
                      {...{
                        ...inpargs,
                        path: getv(filtmap, `filt.${selkey}.path`),
                        type: getv(filtmap, `filt.${selkey}.type`),
                        options: getv(filtmap, `filt.${selkey}.options`) || [],
                        txt_fn: getv(filtmap, `filt.${selkey}.txt_fn`),
                        TagComp: F_OptionBtn_R2_rounded,
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {bottom_jsx}
      </div>
    </div>
  );
};

export const FiltCard_forLegacy = ({
  fkey,
  filters: f,
  set_filters: setf,
  order = [],
  custom_jsx = {},
  top_jsx = null,
  bottom_jsx = null,
}) => {
  const inpargs = {
    filters: f,
    set_filters: setf,
    fkey,
  };

  const [selkey, set_selkey] = useState(order[0]);

  const all_sels = useMemo(() => {
    let ar = [];
    for (let idd of order) {
      let path = `${idd}.vals`;
      let type = getv(f, `${idd}.type`);
      // console.log("notype", idd);
      if (nils(type)) {
      } else if (type.includes("option")) {
        let vals = getv(f, path);
        if (_.isArray(vals));
        else if (!nils(vals)) vals = [vals];
        if (!_.isEmpty(vals)) for (let v of vals) ar.push([idd, v]);
      } else if (type == "inptext") {
        let txt = getv(f, `${idd}.vals`);
        if (txt) ar.push([idd, txt]);
      }
    }
    return ar;
  }, [jstr(f)]);

  const clear_filt = () => {
    let nv = gen_filters_from_valob(f, {});
    setf(nv);
  };

  const c0 = get_cprofile_hex("acc0");
  const c4 = get_cprofile_hex("acc4");

  return (
    <div
      class={twMerge(
        "w-full bg-r2reg/40 border border-acc4 relative min-h-[30rem] overflow-hidden rounded-md p-2",
      )}
    >
      <div class="absolute z-[1] top-[-12px] left-[-12px] xs:w-[4rem] lg:w-[8rem] h-auto">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 106 130"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            opacity="0.7"
            x="93.6943"
            y="-12.0656"
            width="16.3205"
            height="183.415"
            transform="rotate(45 93.6943 -12.0656)"
            fill="url(#paint0_linear_0_1)"
          />
          <rect
            opacity="0.7"
            x="33.8083"
            y="-17"
            width="16.3205"
            height="71.8538"
            transform="rotate(45 33.8083 -17)"
            fill="url(#paint1_linear_0_1)"
          />
          <rect
            opacity="0.7"
            x="61.1858"
            y="-11.3774"
            width="16.3205"
            height="118.176"
            transform="rotate(45 61.1858 -11.3774)"
            fill="url(#paint2_linear_0_1)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_0_1"
              x1="93.6943"
              y1="79.6422"
              x2="110.015"
              y2="79.6422"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c4} />
            </linearGradient>
            <linearGradient
              id="paint1_linear_0_1"
              x1="33.8083"
              y1="18.9269"
              x2="50.1288"
              y2="18.9269"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c4} />
            </linearGradient>
            <linearGradient
              id="paint2_linear_0_1"
              x1="61.1858"
              y1="47.7107"
              x2="77.5063"
              y2="47.7107"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color={c0} />
              <stop offset="1" stop-color={c4} />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="pl-[3.5rem] pt-[3.5rem] z-2">
        {top_jsx}
        <div class="fr-ss my-2 w-full">
          <div class="flex-1">
            <div className="fr-sc w-full flex-wrap">
              {all_sels.map(([idd, op]) => {
                return (
                  <F_OptionBtn_R2_rounded
                    {...{
                      active: true,
                      op: op,
                      txt_fn: getv(f, `${idd}.txt_fn`),
                      onClick: () => {
                        let path = `${idd}.vals`;
                        let type = getv(f, `${idd}.type`);
                        let vals = getv(f, `${idd}.vals`);
                        console.log(path, type, vals);
                        if (type == "option") {
                          set_state_ob(f, setf, path, null);
                        } else if (type == "options") {
                          set_state_ob(
                            f,
                            setf,
                            path,
                            (vals ?? []).filter((e) => e != op),
                          );
                        } else if (type == "option-ar") {
                          set_state_ob(f, setf, path, []);
                        } else if (type == "options-only") {
                          set_state_ob(f, setf, path, null);
                        } else if (type == "options-only-ar") {
                          set_state_ob(f, setf, path, []);
                        } else if (type == "inptext") {
                          set_state_ob(f, setf, path, null);
                        }
                      },
                    }}
                  />
                );
              })}
            </div>
          </div>

          <div
            onClick={clear_filt}
            className={twMerge(
              "resp-text--2 fc-cc cursor-pointer rounded-full bg-r2lig",
              "w-[9rem] aspect-[88/33]  m-[0.5rem]",
            )}
          >
            Clear Filters
          </div>
        </div>

        <div className="fr-sc">
          <div className="w-[15rem] fc-ss resp-gap-2">
            {order.map((idd) => {
              // console.log(idd);
              let txt = getv(f, `${idd}.label`);
              // console.log(idd, txt);
              return (
                <SkewBtn
                  key={idd}
                  onClick={() => set_selkey(idd)}
                  text={txt}
                  active={idd == selkey}
                />
              );
            })}
          </div>
          <div className="flex-1">
            <div className="h-[18rem] w-full border border-acc4 bg-r2reg/60 rounded-md overflow-auto">
              {nils(selkey) ? null : !nils(custom_jsx[selkey]) ? (
                custom_jsx[selkey]?.options_jsx
              ) : (
                <>
                  <InpOptionsWrap_Raw {...{ ...inpargs, idd: selkey }} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {bottom_jsx}
    </div>
  );
};

export const GlowBtnGroup = ({
  options = [],
  selected,
  opmap = {},
  setter,
}) => {
  return (
    <div className="fr-cc xs:mb-[0.4rem] lg:mb-[1rem]">
      {options.map((_c) => {
        let active = _c == selected;
        let svg = getv(opmap, `${_c}.svg`);
        let text = getv(opmap, `${_c}.text`);
        let extcn = getv(opmap, `${_c}.extcn`);
        return (
          <div
            className={twMerge(
              "trasition duration-500 cursor-pointer",
              active ? "w-[12rem]" : "w-[10rem]",
              extcn ?? "",
            )}
          >
            <GlowBox
              {...{
                onClick: () => setter(_c),
                key: _c,
                active,
                svg,
                text,
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export const ColorCircle = ({ className, color }) => {
  return (
    <span
      className={twMerge(
        "w-[2rem] h-[2rem] rounded-full",
        className,
        `bg-${color}`,
      )}
    ></span>
  );
};

export const PrizePoolInfo = ({ r }) => {
  const appcon = useAppContext();
  const { psearch, tok_to_usd_val } = appcon;
  const { rtstatus, paytoken } = r;

  const infocn = "ov-prizebreakdown";
  const pcardcn = `${infocn} bg-r2dark/60 backdrop-blur-md`;

  const [force_hover, set_force_hover] = useState(null);
  useEffect(() => {
    // console.log("psearch.showprizepool", psearch.showprizepool);
    let a = psearch.showprizepool;
    if (nils(a)) {
      return set_force_hover(null);
    }
    if (a == "true") set_force_hover(true);
  }, [psearch.showprizepool]);
  // useEffect(() => { console.log("force_hover", force_hover); }, [force_hover]);

  return (
    <div className="ov-prize">
      {r.version == 4 && r.toburn == true && r.prize == "burn_credits" ? (
        <>
          <div className="fr-cc resp-gap-2 resp-text--2">
            <Dropdown
              force_hover={force_hover}
              wrapcn=""
              trigger={
                <div className=" text-slate-200 resp-text--2 font-digi fr-cc resp-gap-2">
                  <span>Prize Pool (Burn Credits)</span>
                </div>
              }
              dropcn={"w-max top-[2rem] right-0"}
            >
              <Card className={twMerge(pcardcn, " w-full")}>
                <p className="text-yellow-300 resp-text--1">
                  Prizepool is sum total all burn credits of losing bikes
                </p>
                <p className="text-yellow-300 resp-text--1">
                  to be calculated in the end of the race
                </p>
              </Card>
            </Dropdown>
          </div>
        </>
      ) : (
        <>
          {(r.format == "spin_n_go" ||
            ["spin_n_go", "pityspin", "lowspin"].includes(r.payout)) && (
            <>
              <Dropdown
                force_hover={force_hover}
                wrapcn=""
                trigger={
                  <div className=" text-slate-200 resp-text--2 font-digi fr-cc resp-gap-2">
                    <span>Prize Pool</span>
                  </div>
                }
                dropcn={"w-max top-[2rem] right-0"}
              >
                <Card className={twMerge(pcardcn, " w-full")}>
                  {(rtstatus == "open" && (
                    <>
                      <p className="text-yellow-300 resp-text--1">
                        Prize Pool is revealed when the race is scheduled
                      </p>
                    </>
                  )) || (
                    <div className="grid grid-cols-3 resp-gap-2 resp-text--2">
                      {_.entries(r.prize_map).map((e) => {
                        return (
                          <>
                            <PosTag pos={e[0]} className="m-0 resp-py-1" />
                            <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                              <TokenIcon token={r.paytoken} size="xs" />
                              <span className="">
                                {dec(e[1], tokdecn(paytoken))}
                              </span>
                            </div>
                            <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                              <FontAwesomeIcon className="" icon={faUsd} />
                              <span className="">
                                {dec(
                                  tok_to_usd_val(e[1], paytoken),
                                  tokdecn("USD"),
                                )}
                              </span>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  )}
                </Card>
              </Dropdown>
            </>
          )}

          {r.format == "sit_n_go" && (
            <>
              <Dropdown
                force_hover={force_hover}
                wrapcn=""
                trigger={
                  <div className=" text-slate-200 resp-text--2 font-digi fr-cc resp-gap-2">
                    <span>Prize Pool</span>
                    <span>
                      <FontAwesomeIcon icon={faUsd} />
                    </span>
                    <span>
                      {dec(tok_to_usd_val(r.prize, r.paytoken), tokdecn("USD"))}
                    </span>
                    <span>**</span>
                  </div>
                }
                dropcn={"w-max top-[2rem] right-0"}
              >
                <Card className={twMerge(pcardcn, " w-full max-w-[20rem]")}>
                  <p className="text-center text-yellow-500 resp-my-2">
                    {getv(r, "format_inf.prizepool_msg")}
                  </p>
                  <div className="grid grid-cols-3 resp-gap-2">
                    {_.entries(r.prize_map).map((e) => {
                      return (
                        <>
                          <PosTag
                            pos={e[0]}
                            className="resp-text--2 m-0 resp-py-1"
                          />
                          <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                            <TokenIcon token={r.paytoken} size="xs" />
                            <span className="">
                              {dec(e[1], tokdecn(paytoken))}
                            </span>
                          </div>
                          <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                            <FontAwesomeIcon icon={faUsd} />
                            <span className="">
                              {dec(tok_to_usd_val(e[1]), tokdecn("USD"))}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </Card>
              </Dropdown>
            </>
          )}

          {(r.format == "quest" || r.format == "sub_quest") && (
            <div className="fr-sc text-acc4 resp-text-0 resp-gap-1">
              <span>{"Quest Prize"}</span>
              <span>
                <FontAwesomeIcon className="resp-text-1" icon={faUsd} />
              </span>
              <span className="resp-text-1 font-digi">
                {dec(tok_to_usd_val(r.prize, r.paytoken), tokdecn("USD"))}
              </span>
            </div>
          )}

          {r.format == "bounty" && r.prize > 0 && (
            <>
              <div className="fr-sc text-acc4 resp-text-0 resp-gap-1">
                <span>{"Bounty Prize Pool "}</span>
                <span>
                  <FontAwesomeIcon className="resp-text-1" icon={faUsd} />
                </span>
                <span className="resp-text-1 font-digi">
                  {dec(tok_to_usd_val(r.prize, r.paytoken), tokdecn("USD"))}
                </span>
              </div>
            </>
          )}

          {["rounds", "roundsp"].includes(r.format) && r.prize > 0 && (
            <>
              <Dropdown
                force_hover={force_hover}
                wrapcn=""
                trigger={
                  <div className="fc-ss">
                    <div className=" text-slate-200 resp-text--2 font-digi fr-cc resp-gap-2">
                      <span>Prize Pool</span>
                      <span>
                        <FontAwesomeIcon icon={faUsd} />
                      </span>
                      <span>
                        {dec(
                          tok_to_usd_val(r.prize, r.paytoken),
                          tokdecn("USD"),
                        )}
                      </span>
                      <span>**</span>
                    </div>
                  </div>
                }
                dropcn={"w-max top-[2rem] right-0"}
              >
                <Card className={twMerge(pcardcn, " w-full max-w-[20rem]")}>
                  <p className="text-center text-yellow-500 resp-my-2">
                    {getv(r, "format_inf.prizepool_msg")}
                  </p>

                  {r.class !== 72 && (
                    <div className=" text-green-300 resp-text--2 font-digi fr-cc resp-gap-2">
                      <span>Guranteed[30%]</span>
                      <span>
                        <FontAwesomeIcon icon={faUsd} />
                      </span>
                      <span>
                        {dec(
                          tok_to_usd_val(
                            getv(r, "r_form.thresh_prize"),
                            r.paytoken,
                          ),
                          tokdecn("USD"),
                        )}
                      </span>
                      <span>**</span>
                    </div>
                  )}
                  <div className="grid grid-cols-3 resp-gap-2">
                    {_.entries(r.prize_map).map((e) => {
                      return (
                        <>
                          <PosTag
                            pos={e[0]}
                            className="resp-text--text-slate-200 m-0 resp-py-1"
                          />
                          <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                            <TokenIcon token={r.paytoken} size="xs" />
                            <span>{dec(e[1], tokdecn(paytoken))}</span>
                          </div>
                          <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                            <FontAwesomeIcon icon={faUsd} />
                            <span>
                              {dec(
                                tok_to_usd_val(e[1], r.paytoken),
                                tokdecn("USD"),
                              )}
                            </span>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </Card>
              </Dropdown>
            </>
          )}

          {(r.format == "normal" ||
            r.format == "reduced" ||
            r.format == "sub_bounty" ||
            r.format == "sub_roundsp" ||
            (r.format == "teams" &&
              !["spin_n_go", "pityspin", "lowspin"].includes(r.payout))) && (
            <>
              {nils(r.prize) || r.prize === 0 ? (
                <></>
              ) : (
                <Dropdown
                  force_hover={force_hover}
                  wrapcn=""
                  trigger={
                    <div className=" text-slate-200 resp-text--2 font-digi fr-cc resp-gap-2">
                      <span>Prize Pool</span>
                      <span>
                        <FontAwesomeIcon icon={faUsd} />
                      </span>
                      <span>
                        {dec(
                          tok_to_usd_val(r.prize, r.paytoken),
                          tokdecn("USD"),
                        )}
                      </span>
                    </div>
                  }
                  dropcn={"w-max top-[2rem] right-0"}
                >
                  <Card className={twMerge(pcardcn, " w-full")}>
                    <div className="grid grid-cols-3 resp-gap-2 resp-text--2">
                      {_.entries(r.prize_map).map((e) => {
                        return (
                          <>
                            <PosTag
                              pos={e[0]}
                              className="resp-text--2 m-0 resp-py-1"
                            />
                            <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                              <TokenIcon token={r.paytoken} size="xs" />
                              <span>{dec(e[1], tokdecn(paytoken))}</span>
                            </div>
                            <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                              <FontAwesomeIcon icon={faUsd} />
                              <span>
                                {dec(
                                  tok_to_usd_val(e[1], r.paytoken),
                                  tokdecn("USD"),
                                )}
                              </span>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </Card>
                </Dropdown>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export const RaceCardR2_mini = ({ race: r, set_selrace, post_enterrace }) => {
  const appcon = useAppContext();
  const { now } = useNowContext();
  const { tok_to_usd_val } = appcon;
  const { paytoken } = r;

  const [rtstatus] = useMemo(() => {
    return get_race_rtstatus(r, now);
  }, [jstr(r)]);

  const feeusd = tok_to_usd_val(r.fee, r.paytoken);

  const location = useLocation();
  const custcbtxtfn =
    location.pathname == "/trainer-leaderboard" ? (cb) => `${cb}00M` : cb_txt;

  const rupddiff = useMemo(() => {
    if (nils(r.fetch_time)) return true;
    let diff = nano(r.fetch_time) - nano(now);
    return parseInt(diff / 1e3);
  }, [jstr(r), now]);

  const [qo_rginf] = useQueries([
    r.is_arcade
      ? q_arcade_open_hs_in({ rid: r.rid })
      : q_open_hs_in(
          { rid: r.rid },
          { enabled: r.status == "open" && rupddiff > 60 },
        ),
  ]);

  const hsin = getv(qo_rginf, "data.result.hs_in") ?? r.hs_in;
  const hids = getv(qo_rginf, "data.result.hids") ?? r.hids;

  const isburn = r.toburn == true || (r.eventtags || []).includes("burn");
  // console.log("isburn", r, isburn);

  const r_feesection = (
    <>
      <div class="fr-sc resp-gap-4">
        {feeusd == 0 && !isburn ? (
          <Tag className="bg-yellow-500/60 w-max -skew-x-12 text-white">
            <span class="resp-text--1">FREE</span>
          </Tag>
        ) : (
          <div class="fr-sc resp-gap-1">
            <TokenIcon token={r.paytoken} size="xs" />
            <span>Fee: </span>

            {feeusd > 0 && (
              <div class="fr-sc resp-text-1 resp-gap-1">
                <FontAwesomeIcon icon={faUsd} />
                <span className="font-digi">{dec(feeusd, 2)}</span>
              </div>
            )}

            {isburn && (
              <>
                {feeusd > 0 && <span>+</span>}
                <div class="fr-sc resp-text-1 resp-gap-1 text-orange-500">
                  <FontAwesomeIcon icon={faFire} />
                  <span className="font-digi">CORE</span>
                </div>
              </>
            )}
          </div>
        )}
        <div class="w-max"></div>
      </div>
      <PrizePoolInfo r={r} />
    </>
  );

  const r_leftsidebar = (
    <>
      <div
        class={twMerge("font-digi", `bg-r2dark/60`, "fc-ss resp-p-4 w-[10rem]")}
      >
        <div class="fr-sc w-full">
          <SheetRowChainIndicator {...{ r }} />
          <div class="flex-1"></div>
          <RVImg
            {...{
              rvmode: r.rvmode,
              hex_code: cb_cn_hex(r.cb),
            }}
          />
        </div>

        <span className={twMerge("resp-text-1", cb_cn(r.cb))}>
          {custcbtxtfn(r.cb, r.rvmode)}
        </span>
        <span className={twMerge(`text-acc4 resp-text-1`)}>
          {class_text(r.class)}
        </span>

        {rtstatus == "open" ? (
          <div
            onClick={(e) => {
              e.preventDefault();
            }}
            class="fr-sc w-full"
          >
            <RaceR2_EnterPopup
              {...{
                race: r,
                trigger_jsx: (
                  <Tag
                    className={twMerge(
                      `resp-text-2 bg-acc0 fr-sc resp-gap-1`,
                      "quick-enter-btn",
                    )}
                  >
                    <span>Enter</span>
                    <FontAwesomeIcon icon={faSignInAlt} />
                  </Tag>
                ),
                qo_rginf: qo_rginf,
                post_enterrace,
              }}
            />
            <div class="flex-1"></div>
          </div>
        ) : rtstatus == "scheduled" ? (
          <div class="fc-ss">
            <span>Starts in </span>
            <span>{from_time_mini(r.start_time)}</span>
          </div>
        ) : rtstatus == "live" ? (
          <div class="fc-ss">
            <Tag className="bg-yellow-400 text-black">LIVE</Tag>
          </div>
        ) : rtstatus == "finished" ? (
          <div class="fc-ss">
            <span>Starts </span>
            <span>{iso_format(r.start_time, "DD,MMM hh:mm")}</span>
          </div>
        ) : null}
      </div>
    </>
  );

  const is_bulk_valid = useMemo(() => {
    if (!r) return false;
    if (!_.isEmpty(r.eventtags) && r.eventtags.includes("Trail Points"))
      return false;

    return [50, 60, 70, 80].includes(r.class) && [2, 3].includes(r.version);
  }, [jstr(r)]);

  const r_sm_bottomrow = (
    <div
      onClick={(e) => {
        e.preventDefault();
      }}
      class="mb-[0.5rem] fr-cc resp-gap-2 flex-nowrap w-full "
    >
      <RaceR2_EnterPopup
        {...{
          race: r,
          trigger_jsx: (
            <div class="quick-enter-btn">
              <RectBtn_SMLong text="Enter Race" />
            </div>
          ),
          qo_rginf: qo_rginf,
          post_enterrace,
        }}
      />
      {is_bulk_valid && (
        <Link
          target="_self"
          to={`/races-auto-filler?tab=enter&bulkid=${r.bulkid}`}
        >
          <RectBtn_SMLong text="Enter Bulk Race" />
        </Link>
      )}
    </div>
  );

  const r_sm_topbar = (
    <>
      <div class="fr-sc w-max resp-gap-1 font-digi resp-text-2 text-acc4">
        <span className={twMerge(`text-white`)}>{class_text(r.class)}</span>
        <span>-</span>
        <span className={cb_cn(r.cb)}>CB{r.cb}</span>
      </div>
    </>
  );
  const r_format = (
    <div class="relative fr-sc resp-p-2 resp-gap-2 dark-round-btn-basic-bg rounded-full m-1">
      {r.format == "normal" ? (
        <Tag className={twMerge("text-acc0 uppercase")}>{r.format}</Tag>
      ) : r.format == "spin_n_go" ? null : [
          "rounds",
          "roundsp",
          "bounty",
        ].includes(r.format) ? (
        <RoundsInfo race={r} />
      ) : null}
      {["rounds", "bounty", "roundsp"].includes(r.payout) ? null : r.payout ==
        "spin_n_go" ? (
        <Tag className={twMerge("text-red-400")}>
          {get_payout_txt(r.payout)}
        </Tag>
      ) : (
        <Tag className={twMerge("text-white")}>{get_payout_txt(r.payout)}</Tag>
      )}
    </div>
  );
  const r_events = (
    <>
      {!_.isEmpty(r.eventtags) && (
        <div class="fr-sc resp-p-2 dark-round-btn-basic-bg rounded-full m-1">
          {r.eventtags.map((e) => {
            return (
              <EventTag tag={e} efil={getv(r, "r_form.entry_filt")} race={r} />
            );
          })}
        </div>
      )}

      {!nils(r.giveeacards) && (
        <div class="fr-sc resp-gap-2">
          {r.giveeacardstype == "questcard" ? (
            <QuestCardImg
              {...{
                k: "brightback",
                cn: "xs:w-[2rem] lg:w-[4rem]",
                auto_flip: true,
              }}
            />
          ) : r.giveeacardstype == "trailscard" ? (
            <TrailsCardImg img="back.png" className="xs:h-[2rem] lg:h-[4rem]" />
          ) : null}
          <span className="resp-text-0 font-digi">x{r.giveeacards}</span>
        </div>
      )}
    </>
  );

  const r_gates =
    rtstatus == "open" ? (
      <div class="flex flex-col jusitfy-center items-end">
        <div class="fr-sc resp-gap-1 resp-text-1 ov-gates">
          <span>{hsin}</span>
          <span>/</span>
          <span className="font-bold resp-text-2">{r.rgate}</span>
          <div class="xs:w-[2rem] lg:w-[4rem] ov-rvmode">
            <RVImg rvmode={r.rvmode} hex_code={`FFFFFF`} />
          </div>
        </div>
        <div class="fr-sc resp-gap-2 text-white">
          <div class="relative">
            <div class="xs:w-[4rem] lg:w-[8rem] bg-dark rounded-full xs:h-[0.4rem] lg:h-[0.8rem]"></div>

            <div
              style={{
                width: `${(hsin / r.rgate) * 100}%`,
              }}
              class={twMerge(
                "absolute  bg-white rounded-full ",
                "xs:h-[0.2rem] lg:h-[0.4rem]",
                "xs:top-[0.1rem] xs:left-[0.1rem]",
                "lg:top-[0.2rem] lg:left-[0.2rem]",
              )}
            ></div>
          </div>
        </div>
      </div>
    ) : (
      <div class="fc-se">
        <div class="flex flex-col justify-center items-end resp-gap-2 text-white">
          <div class="fr-sc resp-text--1 font-digi resp-gap-1">
            <div class="xs:w-[3rem] lg:w-[5rem]">
              <RVImg rvmode={r.rvmode} hex_code={`FFFFFF`} />
            </div>
            <span>{r.rgate} Gates</span>
          </div>

          {rtstatus == "scheduled" ? (
            <p class="text-yellow-300">
              Starting in {from_time_mini(r.start_time)}
            </p>
          ) : rtstatus == "finished" ? (
            <p class="text-green-300">
              Started at {iso_format(r.start_time, "DD,MMM hh:mm")}
            </p>
          ) : rtstatus == "live" ? (
            <Tag className="bg-yellow-400 text-black">LIVE</Tag>
          ) : rtstatus == "cancelled" ? (
            <p class="text-red-300"> Cancelled</p>
          ) : null}
        </div>
      </div>
    );

  const { hids: vhids = [], bikesob = {} } = useAccountContext();
  const inr_vhids = useMemo(() => {
    let hids = getv(r, "hids") || [];
    return _.intersection(hids, vhids);
  }, [jstr(vhids), jstr(r)]);
  const r_inr_vhids_list = _.isEmpty(inr_vhids) ? null : (
    <>
      <div class="resp-p-2 my-2 grid xs:grid-cols-3 lg:grid-cols-5 resp-gap-1">
        {inr_vhids.map((hid) => {
          let h = getv(bikesob, hid);
          if (!h) return null;
          return (
            <div class="fr-sc resp-gap-2 resp-text--1">
              <BikeSCircle color={h.color} />
              <span>{h.name}</span>
            </div>
          );
        })}
      </div>
    </>
  );

  return (
    <div className="RaceCardR2_mini">
      <div className="large-screen xs:hidden lg:block">
        <div
          className={twMerge(
            "w-full resp-m-1 resp-my-2",
            "resp-text--1",
            "border border-acc4 bg-r2lig/20 rounded-md",
          )}
        >
          <div class=" flex flex-row justify-start items-stretch resp-gap-2">
            {r_leftsidebar}
            <div
              onClick={() => {
                set_selrace(r.rid);
              }}
              class="fc-ss p-4 resp-gap-1 flex-1"
            >
              <div class="fr-sc w-full">
                <span className="resp-text-1 flex-1">{r.race_name}</span>
                {r_gates}
              </div>
              <div class="fr-sc flex-nowrap w-full ">
                <div class="fr-sc flex-wrap">
                  {r_format}
                  {r_events}
                </div>
                <div class="flex-1"></div>
                {r_feesection}
              </div>
              {r_inr_vhids_list}
            </div>
          </div>
        </div>
      </div>

      <div className="small-screen xs:block lg:hidden">
        <div
          className={twMerge(
            "bg-r2lig/20 backdrop-blur-md border border-acc4 rounded-sm w-full resp-m-1 resp-my-2",
            "resp-text--2",
            "resp-p-1",
          )}
        >
          <div>
            <div
              onClick={() => {
                set_selrace(r.rid);
              }}
              class="fc-ss p-4 resp-gap-1 flex-1"
            >
              <div class="fr-sc resp-gap-2 w-full ">
                {r_sm_topbar}
                <div class="flex-1">
                  <SplitRaceNameView
                    {...{ format: r.format, race_name: r.race_name }}
                  />
                </div>
                {r_gates}
              </div>
              <div class="fr-sc flex-nowrap w-full ">
                <div class="fr-sc flex-wrap">
                  {r_format}
                  {r_events}
                </div>
                <div class="flex-1"></div>
                {r_feesection}
              </div>
            </div>

            {r_inr_vhids_list}
            {r_sm_bottomrow}
          </div>
        </div>
      </div>
    </div>
  );
};

export const RaceR2_HRow = ({
  r,
  hid,
  top_inf_jsx = null,
  h = {},
  st_type,
  st_paid,
  show_entry_confirmation = true,
  right_flex_jsx = <></>,
  arrow_link = false,
  cont_props = {},
}) => {
  // useEffect(() => {
  //   console.log("racer2_hrow", cont_props);
  // }, [cont_props]);
  // useEffect(() => {
  //   console.log("racer2_hrow", st_type, st_paid, h);
  // }, [jstr(h)]);

  let { bluestars = [], yellowstars = [] } = r;
  let star =
    (bluestars.includes(hid) ? 2 : 0) + (yellowstars.includes(hid) ? 3 : 0);
  // console.log(h);
  //

  const r_vau = getv(r, `vaults_names.${getv(r, `racing_vaults.${hid}`)}`);
  const c_vau = getv(h, "vault_name");
  // console.log("h vaults", r_vau, c_vau);

  return (
    <div
      style={{
        borderLeft: `2px solid #${h.hex_code}`,
        borderRight: `2px solid #${h.hex_code}`,
        ...(cont_props.style || {}),
      }}
      className={twMerge(
        "w-full p-2 bg-r2dark/30 my-1 rounded-md",
        cont_props.className,
      )}
      onClick={cont_props.onClick}
    >
      <div class="fr-sc resp-gap-1">
        <div class="relative xs:w-[3rem] lg:w-[6rem] aspect-[3/2]">
          <RVImg
            rvmode={r.rvmode}
            className={"w-full h-full"}
            hex_code={h.hex_code}
          />

          <div class="absolute top-0 right-0 font-digi">
            <FontAwesomeIcon
              icon={elementmap[h.element]?.icon}
              className={twMerge("resp-text-1", elementmap[h.element]?.text)}
            />
          </div>
          <div class="absolute top-0 left-0 font-digi">
            <FontAwesomeIcon
              icon={gendermap[h.gender]?.icon}
              className={twMerge("resp-text-1", gendermap[h.gender]?.text)}
            />
          </div>
          <div class="absolute bottom-0 right-0 font-digi">{`F${h.fno ?? "-"}`}</div>
          <div class="absolute bottom-0 left-0 font-digi">
            {h.type && h.type.slice(0, 3).toUpperCase()}
          </div>
        </div>
        <div class="fc-ss flex-1">
          {top_inf_jsx}
          <div class="fr-sc resp-gap-2">
            {nils(cont_props.onClick) ? (
              <Link to={`/bike/${h.hid}`}>
                <span className="font-digi resp-text-1">{h?.name}</span>
              </Link>
            ) : (
              <span className="font-digi resp-text-1">{h?.name}</span>
            )}
            {arrow_link == true ? (
              <div class="relative">
                <Link
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  target="_blank"
                  to={`/bike/${h.hid}`}
                >
                  <div class="xs:w-[1rem] lg:w-[2rem]  rotate-[45deg] aspect-[1/1] rounded-full bg-white/10 resp-p-1 fc-cc">
                    <FontAwesomeIcon icon={faArrowUp} className="resp-text-1" />
                  </div>
                </Link>
              </div>
            ) : null}
          </div>
          {nils(r_vau) || r_vau === h.vault_name ? (
            <span className="text-acc0 resp-text--1">{h?.vault_name}</span>
          ) : (
            <>
              <span className="text-acc0 resp-text--1">Racing: {r_vau}</span>
              <span className="text-slate-400 resp-text--1 ">
                LiveOwner: {h?.vault_name}
              </span>
            </>
          )}
        </div>

        {!nils(h.agid) && !nils(h.faction) && (
          <ToolTip
            message={
              <p class="min-w-[10rem] resp-text--2">{`#${h.agid}-${h.agent_name}`}</p>
            }
          >
            <div class="aspect-[2/1] xs:w-[1rem] lg:w-[2rem]">
              <Img img={faction_img(h.faction)} />
            </div>
          </ToolTip>
        )}

        {!nils(h.listing) && (
          <Link
            target="_blank"
            to={`https://market.dnaracing.run/asset/core/${h.hid}`}
          >
            <div
              className={twMerge(
                "rounded-full resp-px-2 resp-py-1 resp-text--1 bg-acc4/20 text-white fr-sc",
              )}
            >
              <span>{(getv(h, "listing.price") ?? "").toString()}</span>
              <TokenIcon token={getv(h, "listing.token")} />
            </div>
          </Link>
        )}

        <BY_Star star={star} />

        <div class="fr-ss resp-gap-1 resp-px-4 resp-py-2 rounded-full bg-r2reg">
          <div class="fc-ss">
            <div className="fr-sc resp-gap-2 font-mon resp-text--2 text-white">
              <div className="fr-cc xs:w-[2rem] lg:w-[4rem] resp-gap-1">
                <FontAwesomeIcon icon={faTrophy} />
                <span>
                  {disp_dec(
                    getv(
                      h,
                      `hstat.${st_type}.${
                        st_paid == "paid" ? "paid_" : ""
                      }win_p`,
                    ) * 100,
                    1,
                  )}
                  %
                </span>
              </div>
              <span>/</span>
              <div className="fr-cc xs:w-[1.5rem] lg:w-[3rem] resp-gap-1">
                <FontAwesomeIcon icon={faFlagCheckered} />
                <span>
                  {disp_dec(
                    getv(
                      h,
                      `hstat.${st_type}.${
                        st_paid == "paid" ? "paid_" : ""
                      }races_n`,
                    ),
                    0,
                  )}
                </span>
              </div>
            </div>
          </div>

          {show_entry_confirmation && r.status == "open" && r.is_chain && (
            <>
              {h.entry_confirmed ? (
                <div className="resp-text-1">
                  <FontAwesomeIcon className="text-green-300" icon={faCheck} />
                </div>
              ) : (
                <div className="resp-text-1 spin-anim">
                  <FontAwesomeIcon
                    className="text-orange-300"
                    icon={faSpinner}
                  />
                </div>
              )}
            </>
          )}
        </div>
        {right_flex_jsx}
      </div>
    </div>
  );
};

export const RaceR2_HS_Section = ({ r, hids, hconfirmed }) => {
  const accon = useAccountContext();
  const { hids: vhids = [] } = accon;
  const { rid, cb, class: c, payout } = r;
  const active = true;

  const rvmode = r.rvmode;
  const qshs = useStepQuery({
    q_: r.is_arcade ? q_arcade_race_hstats : q_hstats,
    par_ar: (hids || []).map((hid) => [{ rid, hid, cb, class: c, rvmode }]),
    lim: 3,
    options: { enabled: active },
  });
  const hs_loading = _.some(qshs.qs, "isLoading");

  const aucon = useAuthContext();
  const { auth } = aucon;
  const { vault, balance, dezbalance } = useAccountContext();

  const [st_type, set_st_type] = useState("cb");
  const [st_paid, set_st_paid] = useState("paid");

  const hs = useMemo(() => {
    // console.log("hsstats:memo", hids, qshs);
    let hs = [];
    let brep = r?.botinfo_replacement;
    for (let q of qshs.qs) {
      if (!qissuccesss(q)) continue;
      let h = getv(q, "data.result");
      let hid = h?.hid;
      let hrep = getv(brep, hid);
      if (!_.isEmpty(hrep)) {
        h = {
          ...h,
          ...hrep,
          replaced: true,
          type: "AG",
          vault_name: getv(r, `vaults_names.${hrep.vault}`),
        };
        // console.log("hrep", h);
      }
      hs.push(h);
    }
    // console.log(r.rid, "hstats", hs);
    return hs;
  }, [jstr(_.map(qshs.qs, "dataUpdatedAt")), jstr(r?.botinfo_replacement)]);
  const vault_bike_bgcn = "bg-r2lig/30 shadow-md shadow-acc4 border-r2lig";
  const bike_over_cmap = useMemo(() => {
    let o = {};
    let hteam_info_cnmap = {};
    if (r.payout == "tag" && !_.isEmpty(r.teams_ar)) {
      for (let [teamk, [h1, h2]] of r.teams_ar) {
        let cn = `bg-${teamk}-500/40`;
        let inf = {
          cn,
          top_inf_jsx: (
            <span className={`italic resp-text--1`}>
              {`Team ${_.capitalize(teamk)}`}
            </span>
          ),
        };
        hteam_info_cnmap[h1] = inf;
        hteam_info_cnmap[h2] = inf;
      }
    }

    if (r.is_team == true) {
      let team_ob = _.keyBy(r.teamsmap, "k");
      for (let [k, v] of Object.entries(team_ob)) {
        let inf = {
          cn: `bg-${v.color}-500/40`,
          top_inf_jsx: (
            <span className={`italic resp-text--1`}>
              {`Team ${_.capitalize(v.k)}`}
            </span>
          ),
        };
        team_ob[k].inf = inf;
      }
      for (let hid of r.hids) {
        let k = getv(r, `hteammap.${hid}`);
        hteam_info_cnmap[hid] = team_ob[k]?.inf;
      }
    }

    for (let hid of r.hids) {
      let is_vhid = vhids.includes(hid);
      if (hteam_info_cnmap[hid]) {
        o[hid] = hteam_info_cnmap[hid];
      } else if (is_vhid) {
        o[hid] = { cn: vault_bike_bgcn };
      } else {
        o[hid] = { cn: "" };
      }
    }
    console.log("entry:bikeover_cmap", o);
    return o;
  }, [jstr(r), jstr(vhids)]);

  if (_.isEmpty(hs)) return null;
  return (
    <div class="p-4 my-1 bg-r2dark/10 backdrop-blur-md rounded-md">
      <div class="fr-sc resp-gap-2 resp-text-1">
        {hs_loading && <Loader01c size="s" />}
        <div class="flex-1"></div>
        <Tag
          className={
            "fr-sc resp-gap-1 text-acc0  underline-acc0 underline-offset-2"
          }
          onClick={() => set_st_type((a) => (a !== "cb" ? "cb" : "ov"))}
        >
          <FontAwesomeIcon icon={faArrowsUpDown} />
          <span>
            {st_type == "ov" ? "Overall" : st_type == "cb" ? `CB${cb}00` : ""}
          </span>
        </Tag>

        <Tag
          className={
            "fr-sc resp-gap-1 text-acc0 underline-acc0 underline-offset-2"
          }
          onClick={() => set_st_paid((a) => (a !== "paid" ? "paid" : "all"))}
        >
          <FontAwesomeIcon icon={faArrowsUpDown} />
          <span>{st_paid == "paid" ? "Paid" : "All"}</span>
        </Tag>
      </div>
      {hs.map((h) => {
        h.entry_confirmed = getv(hconfirmed, h.hid) === true;
        let hid = h.hid;
        let ch = bike_over_cmap[hid] || {};
        return (
          <RaceR2_HRow
            {...{
              r,
              h,
              hid: h?.hid,
              st_type,
              st_paid,
              top_inf_jsx: ch.top_inf_jsx,
              cont_props: {
                className: twMerge(ch.cn),
              },
            }}
          />
        );
      })}
    </div>
  );
};

export const RaceCardR2_full = ({ race: r, post_enterrace }) => {
  const appcon = useAppContext();
  const { now } = useNowContext();
  const { tok_to_usd_val } = appcon;
  const { paytoken } = r;
  const { auth } = useAuthContext();
  const { vault, balance, dezbalance } = useAccountContext();

  const feeusd = tok_to_usd_val(r.fee, r.paytoken);

  const [rtstatus, rem_st, rem_ed] = useMemo(() => {
    let e = get_race_rtstatus(r, now);
    return e;
  }, [now, jstr(r)]);

  const isburn = r.toburn == true || (r.eventtags || []).includes("burn");

  const r_feesection = (
    <ErrorBoundary>
      <div class="ov-fee">
        {feeusd == 0 && !isburn ? (
          <Tag className="bg-yellow-500/60 w-max -skew-x-12 text-white">
            <span class="resp-text--1">FREE</span>
          </Tag>
        ) : (
          <div class="fr-sc resp-gap-1">
            <TokenIcon token={r.paytoken} size="xs" />
            <span>Fee: </span>

            {feeusd > 0 && (
              <div class="fr-sc resp-text-1 resp-gap-1">
                <FontAwesomeIcon icon={faUsd} />
                <span className="font-digi">{dec(feeusd, 2)}</span>
              </div>
            )}

            {isburn && (
              <>
                {feeusd > 0 && <span>+</span>}
                <div class="fr-sc resp-text-1 resp-gap-1 text-orange-500">
                  <FontAwesomeIcon icon={faFire} />
                  <span className="font-digi">CORE</span>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <PrizePoolInfo r={r} />
    </ErrorBoundary>
  );

  const r_leftsidebar = (
    <ErrorBoundary>
      <div
        class={twMerge(
          "font-digi",
          `bg-c${r.class} bg-opacity-10`,
          "fc-ss resp-p-4 w-[8rem]",
        )}
      >
        <span className={cb_cn(r.cb)}>{cb_txt(r.cb, r.rvmode)}</span>
        <span className={twMerge(`text-c${r.class}`)}>
          {class_text(r.class)}
        </span>
      </div>
    </ErrorBoundary>
  );

  const r_format = (
    <div class=" relative fr-sc resp-p-2 resp-gap-2 dark-round-btn-basic-bg rounded-full m-1">
      {r.format == "normal" ? (
        <Tag className={twMerge("ov-format text-acc0 uppercase")}>
          {r.format}
        </Tag>
      ) : r.format == "spin_n_go" ? null : [
          "rounds",
          "roundsp",
          "bounty",
        ].includes(r.format) ? (
        <RoundsInfo race={r} />
      ) : null}
      {["rounds", "bounty", "roundsp"].includes(r.payout) ? null : r.payout ==
        "spin_n_go" ? (
        <Tag className={twMerge("ov-payout text-red-400")}>
          {get_payout_txt(r.payout)}
        </Tag>
      ) : (
        <Tag className={twMerge("ov-payout text-white")}>
          {get_payout_txt(r.payout)}
        </Tag>
      )}
    </div>
  );
  const r_events = (
    <div class="ov-events">
      <ErrorBoundary>
        {!_.isEmpty(r.eventtags) && (
          <div class="fr-sc resp-p-2 dark-round-btn-basic-bg rounded-full m-1">
            {r.eventtags.map((e) => {
              return (
                <EventTag
                  tag={e}
                  efil={getv(r, "r_form.entry_filt")}
                  race={r}
                />
              );
            })}
          </div>
        )}
        {!nils(r.giveeacards) && (
          <div class="fr-sc resp-gap-2">
            {r.giveeacardstype == "questcard" ? (
              <QuestCardImg
                {...{
                  k: "brightback",
                  cn: "xs:w-[2rem] lg:w-[4rem]",
                  auto_flip: true,
                }}
              />
            ) : r.giveeacardstype == "trailscard" ? (
              <TrailsCardImg
                img="back.png"
                className="xs:h-[2rem] lg:h-[4rem]"
              />
            ) : null}
            <span className="resp-text-0 font-digi">x{r.giveeacards}</span>
          </div>
        )}
      </ErrorBoundary>
    </div>
  );

  const rupddiff = useMemo(() => {
    if (nils(r.fetch_time)) return 20;
    let diff = nano(now) - nano(r.fetch_time);
    return parseInt(diff / 1e3);
  }, [jstr(r), now]);

  const [qo_rginf] = useQueries([
    r.is_arcade
      ? q_arcade_open_hs_in({ rid: r.rid })
      : q_open_hs_in(
          { rid: r.rid },
          {
            enabled: r.status == "open" && rupddiff > 20,
            staleTime: 10 * 1e3,
            refetchInterval: 10 * 1e3,
          },
        ),
  ]);
  // useEffect(() => {
  //   console.log("qo_rginf", qo_rginf.data, { rupddiff });
  // }, [qo_rginf.dataUpdatedAt, rupddiff]);

  const hsin = getv(qo_rginf, "data.result.hs_in") ?? r.hs_in;
  const hids = getv(qo_rginf, "data.result.hids") ?? r.hids;
  const hconfirmed =
    r.is_chain !== true
      ? {}
      : _.isEmpty(qo_rginf.data)
        ? getv(r, "entry_txns_confirmed")
        : _.chain(getv(qo_rginf, "data.result.hs"))
            .keyBy("hid")
            .mapValues("confirmed")
            .value();

  const r_gates = (
    <ErrorBoundary>
      {r.status == "open" ? (
        <>
          <div className="flex flex-col jusitfy-center items-end ov-gates">
            <div class="fr-sc resp-gap-1 resp-text-1">
              <span>{hsin}</span>
              <span>/</span>
              <span className="font-bold resp-text-2">{r.rgate}</span>
              <div class="xs:w-[2rem] lg:w-[4rem] ov-rvmode">
                <RVImg rvmode={r.rvmode} hex_code={`FFFFFF`} />
              </div>
            </div>
            <div class="fr-sc resp-gap-2 text-white">
              <div class="relative">
                <div class="xs:w-[4rem] lg:w-[8rem] bg-dark rounded-full xs:h-[0.4rem] lg:h-[0.8rem]"></div>

                <div
                  style={{
                    width: `${(hsin / r.rgate) * 100}%`,
                  }}
                  class={twMerge(
                    "absolute  bg-white rounded-full ",
                    "xs:h-[0.2rem] lg:h-[0.4rem]",
                    "xs:top-[0.1rem] xs:left-[0.1rem]",
                    "lg:top-[0.2rem] lg:left-[0.2rem]",
                  )}
                ></div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div class="fc-se resp-gap-2 text-white ">
          <div class="fr-sc resp-text-1 font-digi resp-gap-1 ov-gates">
            <div class="xs:w-[3rem] lg:w-[5rem] ov-rvmode">
              <RVImg rvmode={r.rvmode} hex_code={`FFFFFF`} />
            </div>
            <span>{r.rgate} Gates</span>
          </div>
          <div class="ov-status">
            {rtstatus == "scheduled" ? (
              <p class="text-yellow-300 ov-starttime">
                Starting in {from_time_mini(r.start_time)}
              </p>
            ) : rtstatus == "finished" ? (
              <p class="text-green-300 ov-starttime">
                Started at {iso_format(r.start_time, "DD,MMM hh:mm")}
              </p>
            ) : rtstatus == "live" ? (
              <Tag className="bg-yellow-400 text-black">LIVE</Tag>
            ) : rtstatus == "cancelled" ? (
              <p class="text-red-300"> Cancelled</p>
            ) : null}
          </div>
        </div>
      )}
    </ErrorBoundary>
  );

  const show_enter_race = useMemo(() => {
    if (r.admin_entry === true) return false;
    if (r.status !== "open") return false;
    if (hids.length >= r.rgate) return false;
    if (!auth) return "please login to enter race";
    // console.log(r.paytoken, r.fee, balance, dezbalance);
    let bal = r.paytoken == "DEZ" ? dezbalance : balance;
    if (!nils(bal) && bal < r.fee) return `insufficient balance to enter`;
    return true;
  }, [r.status, hids.length, auth, balance]);

  const [watching, set_watching] = useState(false);
  const [showresults, set_showresults] = useState(false);
  useEffect(() => {
    // console.log(r.rid, rtstatus);
    if (rtstatus == "live") {
      set_watching(true);
    }
  }, [rtstatus, rem_st]);

  const r_innersection = (
    <ErrorBoundary>
      {watching ? (
        <RaceR2_Watching2D_Section
          {...{
            race: r,
            hids,
            watching,
            set_watching,
          }}
        />
      ) : nils(rtstatus) ? null : rtstatus == "open" ||
        rtstatus == "scheduled" ? (
        <>
          <RaceR2_HS_Section {...{ r, hids, hconfirmed }} />
          {r.format == "quest" ? (
            <>
              <div class="fc-cc resp-gap-2 font-digi text-acc0 resp-text-1 my-2">
                <p class="text-center">Trying to confirm your entry</p>
                <div class="fr-sc resp-gap-2 resp-text-2">
                  <Loader01c size="s" />
                  <p>Quest Starts soon</p>
                  <Loader01c size="s" />
                </div>
              </div>
            </>
          ) : null}
        </>
      ) : rtstatus == "cancelled" ? (
        <div class="fc-cc resp-gap-1 text-red-300 resp-text-0">
          <p className="text-center ">This race has been cancelled</p>

          {!nils(getv(r, "cancellation_msg")) && (
            <p className="text-center ">{getv(r, "cancellation_msg")}</p>
          )}
        </div>
      ) : rtstatus == "finished" ? (
        <RaceR2_FinishedSection
          {...{ race: r, showresults, set_showresults }}
        />
      ) : null}
    </ErrorBoundary>
  );

  const is_bulk_valid = useMemo(() => {
    if (!r) return false;
    if (!_.isEmpty(r.eventtags) && r.eventtags.includes("Trail Points"))
      return false;

    return [50, 60, 70, 80].includes(r.class) && [2, 3].includes(r.version);
  }, [jstr(r)]);

  const r_bottomaction_row = (
    <ErrorBoundary>
      <div class="xs:hidden lg:block resp-p-2">
        <div class="fr-sc resp-gap-4">
          {watching ? (
            <RaceBottomActionBtn
              text="Exit 2D"
              onClick={() => {
                set_watching(false);
              }}
            />
          ) : (
            <RaceBottomActionBtn
              text={
                <>
                  <div class="fr-sc resp-gap-0">
                    <div class="w-[2rem] aspect-square">
                      <img src={encodeURI("/r2_design/play_btn2.png")} alt="" />
                    </div>
                    <span>2D</span>
                  </div>
                </>
              }
              onClick={() => {
                set_watching(true);
              }}
            />
          )}
          <RaceBottomActionBtn
            onClick={() => {
              window.open(get_race3d_link(r));
            }}
            text={
              <>
                <div class="fr-sc resp-gap-0">
                  <div class="w-[2rem] aspect-square">
                    <img src={encodeURI("/r2_design/play_btn3.png")} alt="" />
                  </div>
                  <span>3D</span>
                </div>
              </>
            }
          />
          <div class="flex-1"></div>

          {r.status == "open" && show_enter_race && (
            <>
              {is_bulk_valid && (
                <Link
                  target="_self"
                  to={`/races-auto-filler?tab=enter&bulkid=${r.bulkid}`}
                >
                  <RaceBottomActionBtn text="Bulk Enter" />
                </Link>
              )}
              <RaceR2_EnterPopup
                {...{
                  race: r,
                  trigger_jsx: (
                    <RaceBottomActionBtn text="Enter Race" alltime={true} />
                  ),
                  qo_rginf: qo_rginf,
                  post_enterrace,
                }}
              />
            </>
          )}
        </div>
      </div>

      <div class="xs:block lg:hidden resp-p-2">
        <div class="fr-sc font-digi">
          {watching ? (
            <RaceBottomActionBtnSm
              className="bg-dark hover:bg-red-500/60"
              onClick={() => {
                set_watching(false);
              }}
            >
              {"Exit 2D"}
            </RaceBottomActionBtnSm>
          ) : (
            <RaceBottomActionBtnSm
              className="bg-dark hover:bg-acc0/60"
              onClick={() => {
                set_watching(true);
              }}
            >
              {"View 2D"}
            </RaceBottomActionBtnSm>
          )}

          <RaceBottomActionBtnSm
            className="bg-dark hover:bg-acc0/60"
            onClick={() => {
              window.open(get_race3d_link(r));
            }}
          >
            {"View 3D"}
          </RaceBottomActionBtnSm>

          <div class="flex-1"></div>

          {r.status == "open" && show_enter_race && (
            <>
              {is_bulk_valid && (
                <Link
                  target="_self"
                  to={`/races-auto-filler?tab=enter&bulkid=${r.bulkid}`}
                >
                  <RaceBottomActionBtnSm className="bg-dark hover:bg-acc0/60">
                    {"Bulk"}
                  </RaceBottomActionBtnSm>
                </Link>
              )}
              <RaceR2_EnterPopup
                {...{
                  race: r,
                  trigger_jsx: (
                    <RaceBottomActionBtnSm className="bg-dark hover:bg-acc0/60">
                      {"Enter Race"}
                    </RaceBottomActionBtnSm>
                  ),
                  qo_rginf: qo_rginf,
                  post_enterrace,
                }}
              />
            </>
          )}
        </div>
      </div>
    </ErrorBoundary>
  );

  const { hids: vhids = [], bikesob = {} } = useAccountContext();
  const inr_vhids = useMemo(() => {
    let hids = getv(r, "hids") || [];
    return _.intersection(hids, vhids);
  }, [jstr(vhids), jstr(r)]);
  const r_inr_vhids_list = _.isEmpty(inr_vhids) ? null : (
    <ErrorBoundary>
      <div class="resp-p-2 my-2 grid xs:grid-cols-3 lg:grid-cols-5 resp-gap-1">
        {inr_vhids.map((hid) => {
          let h = getv(bikesob, hid);
          if (!h) return null;
          return (
            <div class="fr-sc resp-gap-2 resp-text--1">
              <BikeSCircle color={h.color} />
              <span>{h.name}</span>
            </div>
          );
        })}
      </div>
    </ErrorBoundary>
  );

  const copy_jsx = (
    <>
      <Tag
        className="ov-copylink xs:px-1 lg:px-1 xs:mx-0 lg:mx-0"
        onClick={() => copy_clip(`https://fbike.dnaracing.run/race/${r.rid}`)}
      >
        <FontAwesomeIcon icon={faCopy} />
      </Tag>
    </>
  );

  const race = r;

  return (
    <>
      <div
        className={twMerge(
          `large-screen xs:hidden lg:block `,
          `race-card-full race-card-full-${r.rid}`,
        )}
      >
        <div
          className={twMerge(
            "bg-r2lig/20",
            "backdrop-blur-md",
            "rounded-md w-full resp-m-1 resp-my-2",
            "p-4",
            "resp-text--1",
            "border border-acc4",
          )}
        >
          <div class=" flex flex-row justify-start items-stretch resp-gap-2">
            <div class="flex-1">
              <div class="fc-ss resp-gap-1">
                <div class="fr-sc resp-gap-2">
                  <SheetRowChainIndicator {...{ r }} />
                  <span className={`font-digi text-white`}>
                    <span
                      className={twMerge("ov-class")}
                    >{`${class_text(r.class)} - `}</span>
                    <span className={twMerge("ov-cb", cb_cn(r.cb))}>
                      {cb_txt(r.cb, r.rvmode)}
                    </span>
                  </span>
                  <span className="resp-text--1 font-digi">{r.race_name}</span>
                  <Link to={`/race/${r.rid}`} className="ov-redirectlink px-2">
                    <FontAwesomeIcon icon={faLink} />
                  </Link>
                  {copy_jsx}
                </div>
                <div class="fr-sc resp-gap-1">
                  {r_format}
                  {r_events}
                </div>
                {rtstatus == "scheduled" ? (
                  <div className="fr-sc resp-gap-1 resp-text--1 my-1 px-4 text-yellow-400 font-digi">
                    <span>Starts in </span>
                    <span>{from_time_mini(r.start_time)}</span>
                  </div>
                ) : rtstatus == "live" ? (
                  <div className="fr-sc resp-gap-1 resp-text--1 my-1 px-4 text-yellow-400 font-digi">
                    <span>LIVE</span>
                  </div>
                ) : rtstatus == "finished" ? (
                  <div className="fr-sc resp-gap-1 resp-text--1 my-1 px-4 text-green-400 font-digi">
                    <span>Started </span>
                    <span>{iso_format(r.start_time, "DD,MMM hh:mm:ss")}</span>
                  </div>
                ) : null}
              </div>
            </div>
            <div class="fc-se p-4 resp-gap-1">
              {r_gates}
              {r_feesection}
            </div>
          </div>
          {r_inr_vhids_list}
          {r_innersection}

          {showresults && !_.isEmpty(race.reward_cards) && (
            <ErrorBoundary>
              {/* <p className="reps-text-1"> {race.giveeacards}-{race.giveeacardstype} </p> */}
              {race.giveeacardstype == "questcard" ? (
                <RacePage_QuestCard
                  {...{
                    cs: race.reward_cards,
                    racing_vaults: race.racing_vaults,
                    vmap: race.vaults_names,
                  }}
                />
              ) : race.giveeacardstype == "trailscard" ? (
                <RacePage_TrailsCard
                  {...{
                    cs: race.reward_cards,
                    racing_vaults: race.racing_vaults,
                    vmap: race.vaults_names,
                  }}
                />
              ) : null}
            </ErrorBoundary>
          )}
          {r_bottomaction_row}
        </div>
      </div>

      <div class="xs:block lg:hidden">
        <div
          className={twMerge(
            "bg-r2lig/20 backdrop-blur-md border border-acc4 rounded-sm w-full resp-m-1 resp-my-2",
            "",
            "resp-text--1",
            `border-c${r.class}`,
            "resp-p-2",
          )}
        >
          <div class="fr-sc resp-gap-2 resp-p-2 resp-my-2">
            <div class="fr-sc resp-gap-2">
              <span className={`font-digi text-white`}>
                {class_text(r.class)} - {cb_txt(r.cb, r.rvmode)}
              </span>
            </div>
            <div class="flex-1"></div>
            {r_gates}
          </div>
          <div class="block">
            <div class="fr-sc resp-gap-2 resp-px-4 resp-my-1">
              <SplitRaceNameView
                className="resp-text-1"
                {...{ format: r.format, race_name: r.race_name }}
              />
              <Link to={`/race/${r.rid}`} className="px-2">
                <FontAwesomeIcon icon={faLink} />
              </Link>
              {copy_jsx}
              <div class="flex-1"></div>
              <div class="fc-se">{r_feesection}</div>
            </div>
            <div class="fr-sc ">
              {r_format}
              {r_events}
            </div>
          </div>
          {r_inr_vhids_list}
          {r_innersection}
          {r_bottomaction_row}
        </div>
      </div>
    </>
  );
};

export const RaceCardR2_baseinfo = ({
  race: r,
  force_rtstatus,
  cont_props = {},
  post_enterrace,
}) => {
  const appcon = useAppContext();
  const { now } = useNowContext();
  const { tokmap, tok_to_usd_val } = appcon;
  const { paytoken = "DEZ" } = r;

  const [rtstatus, rem_st, rem_ed] = useMemo(() => {
    if (!nils(force_rtstatus)) return force_rtstatus;
    let e = get_race_rtstatus(r, now);
    return e;
  }, [now, jstr(r)]);

  const [fee, feeusd] = useMemo(() => {
    let fee = r.version == "cv2" ? r.fee_fixed[paytoken] : r.fee;
    let fee_usd = tok_to_usd_val(fee, paytoken);
    console.log("fee_usd", [fee, fee_usd]);
    return [fee, fee_usd];
  }, [
    jstr(tokmap),
    jstr(r),
    paytoken,
    jstr({ version: r.version, fee: r?.fee, fee_fixed: r?.fee_fixed }),
  ]);

  const r_feesection = (
    <>
      <div class="fr-sc resp-gap-4">
        {feeusd == 0 ? (
          <Tag className="bg-yellow-500/60 w-max -skew-x-12 text-white">
            <span class="resp-text-1">FREE</span>
          </Tag>
        ) : (
          <div class="fr-sc resp-gap-1">
            <TokenIcon token={r.paytoken} size="xs" />
            <span>Fee: </span>

            <div class="fr-sc resp-text-1 resp-gap-1">
              <FontAwesomeIcon icon={faUsd} />
              <span className="font-digi">{dec(feeusd, 2)}</span>
            </div>
          </div>
        )}
        <div class="w-max"></div>
      </div>
      <PrizePoolInfo r={r} />
    </>
  );

  const r_leftsidebar = (
    <>
      <div
        class={twMerge("font-digi", `bg-r2dark/60`, "fc-ss resp-p-4 w-[10rem]")}
      >
        <span>{cb_txt(r.cb, r.rvmode)}</span>
        <span className={twMerge(`text-acc4`)}>{class_text(r.class)}</span>

        {rtstatus == "open" ? (
          <div
            onClick={(e) => {
              e.preventDefault();
            }}
            class="fr-sc w-full"
          >
            <RaceR2_EnterPopup
              {...{
                race: r,
                trigger_jsx: (
                  <Tag
                    className={twMerge(`resp-text-2 bg-acc1 fr-sc resp-gap-1`)}
                  >
                    <span>Enter</span>
                    <FontAwesomeIcon icon={faSignInAlt} />
                  </Tag>
                ),
                qo_rginf: qo_rginf,
                post_enterrace,
              }}
            />
            <div class="flex-1"></div>
          </div>
        ) : rtstatus == "scheduled" ? (
          <div class="fc-ss">
            <span>Starts in </span>
            <span>{from_time_mini(r.start_time)}</span>
          </div>
        ) : rtstatus == "live" ? (
          <div class="fc-ss">
            <Tag className="bg-yellow-400 text-black">LIVE</Tag>
          </div>
        ) : rtstatus == "finished" ? (
          <div class="fc-ss">
            <span>Starts </span>
            <span>{iso_format(r.start_time, "DD,MMM hh:mm")}</span>
          </div>
        ) : null}
      </div>
    </>
  );

  const r_sm_topbar = (
    <>
      <div class="fr-sc w-max resp-gap-1 font-digi resp-text--1">
        <span className={twMerge(`text-white`)}>{class_text(r.class)}</span>
        <span>-</span>
        <span>{cb_txt(r.cb, r.rvmode)}</span>
      </div>
    </>
  );
  const r_format = (
    <div class="relative fr-sc resp-p-2 resp-gap-2 dark-round-btn-basic-bg rounded-full m-1">
      {r.format == "normal" ? (
        <Tag className={twMerge("text-acc0 uppercase")}>{r.format}</Tag>
      ) : r.format == "spin_n_go" ? null : [
          "rounds",
          "roundsp",
          "bounty",
        ].includes(r.format) ? (
        <RoundsInfo race={r} />
      ) : null}
      {["rounds", "bounty", "roundsp"].includes(r.payout) ? null : r.payout ==
        "spin_n_go" ? (
        <Tag className={twMerge("text-red-400")}>
          {get_payout_txt(r.payout)}
        </Tag>
      ) : (
        <Tag className={twMerge("text-white")}>{get_payout_txt(r.payout)}</Tag>
      )}
    </div>
  );
  const r_events = (
    <>
      {!_.isEmpty(r.eventtags) && (
        <div class="fr-sc resp-p-2 dark-round-btn-basic-bg rounded-full m-1">
          {r.eventtags.map((e) => {
            return (
              <EventTag tag={e} efil={getv(r, "r_form.entry_filt")} race={r} />
            );
          })}
        </div>
      )}
    </>
  );

  const rupddiff = useMemo(() => {
    if (nils(r.fetch_time)) return true;
    let diff = nano(r.fetch_time) - nano(now);
    return parseInt(diff / 1e3);
  }, [jstr(r), now]);

  const [qo_rginf] = useQueries([
    r.is_arcade
      ? q_arcade_open_hs_in({ rid: r.rid })
      : q_open_hs_in(
          { rid: r.rid },
          { enabled: r.status == "open" && rupddiff > 60 },
        ),
  ]);

  const hsin = getv(qo_rginf, "data.result.hs_in") ?? r.hs_in;
  const hids = getv(qo_rginf, "data.result.hids") ?? r.hids;

  const r_gates =
    rtstatus == "open" ? (
      <div class="fr-sc resp-gap-2 text-white">
        <div class="fr-sc resp-gap-1">
          <FontAwesomeIcon icon={faUser} />
          <span>{hsin}</span>
          <span>/</span>
          <span className="font-bold resp-text-1">{r.rgate}</span>
        </div>

        <div class="relative">
          <div class="xs:w-[4rem] lg:w-[8rem] bg-dark rounded-full xs:h-[0.4rem] lg:h-[0.8rem]"></div>

          <div
            style={{
              width: `${(hsin / r.rgate) * 100}%`,
            }}
            class={twMerge(
              "absolute  bg-white rounded-full ",
              "xs:h-[0.2rem] lg:h-[0.4rem]",
              "xs:top-[0.1rem] xs:left-[0.1rem]",
              "lg:top-[0.2rem] lg:left-[0.2rem]",
            )}
          ></div>
        </div>
      </div>
    ) : (
      <div class="fc-se">
        <div class="fc-se resp-gap-2 text-white">
          <div class="fr-sc resp-text--1 font-digi resp-gap-1">
            <RVImg rvmode={r.rvmode} hex_code={"FFFFFF"} />
            <span>{r.rgate} Gates</span>
          </div>

          {rtstatus == "scheduled" ? (
            <p class="text-yellow-300">
              Starting in {from_time_mini(r.start_time)}
            </p>
          ) : rtstatus == "finished" ? (
            <p class="text-green-300">
              Started at {iso_format(r.start_time, "DD,MMM hh:mm")}
            </p>
          ) : rtstatus == "live" ? (
            <Tag className="bg-yellow-400 text-black">LIVE</Tag>
          ) : rtstatus == "cancelled" ? (
            <p class="text-red-300"> Cancelled</p>
          ) : null}
        </div>
      </div>
    );

  return (
    <>
      <div className="xs:hidden lg:block">
        <div
          {...cont_props}
          className={twMerge(
            "w-full resp-m-1 resp-my-2",
            "resp-text--1",
            "rounded-md",
            cont_props.className,
          )}
        >
          <div class=" flex flex-row justify-start items-stretch resp-gap-2">
            {r_leftsidebar}
            <div class="fc-ss p-4 resp-gap-1 flex-1">
              <div class="fr-sc w-full">
                <span className="resp-text-1 flex-1">{r.race_name}</span>
                {r_gates}
              </div>
              <div class="fr-sc flex-nowrap w-full ">
                <div class="fr-sc flex-wrap">
                  {r_format}
                  {r_events}
                </div>
                <div class="flex-1"></div>
                {r_feesection}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="xs:block lg:hidden">
        <div
          {...cont_props}
          className={twMerge(
            "rounded-sm w-full resp-m-1 resp-my-2",
            "resp-text--2",
            "resp-p-1",
            cont_props.className,
          )}
        >
          <div>
            <div onClick={() => {}} class="fc-ss p-4 resp-gap-1 flex-1">
              <div class="fr-sc w-full ">
                {r_sm_topbar}
                <span className="resp-text-1 flex-1">{r.race_name}</span>
                {r_gates}
              </div>
              <div class="fr-sc flex-nowrap w-full ">
                <div class="fr-sc flex-wrap">
                  {r_format}
                  {r_events}
                </div>
                <div class="flex-1"></div>
                {r_feesection}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export const SheetRowChainIndicator = ({ r }) => {
  return (
    !nils(r.sheetrowid) &&
    r.is_chain == true && (
      <>
        <FontAwesomeIcon
          icon={faCircle}
          className={twMerge(
            "resp-text--2",
            r.chain_created == true ? "text-green-500" : "text-orange-500",
          )}
        />
      </>
    )
  );
};

export const RaceBottomActionBtn = ({
  text,
  alltime = false,
  className = "",
  style = {},
  onClick = () => {},
}) => {
  const [hover, set_hover] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => set_hover(true)}
      onMouseLeave={() => set_hover(false)}
      className="bg-acc0/20 border border-acc0 rounded-lg fc-cc min-h-[2rem] resp-px-2  cursor-pointer font-digi"
    >
      {alltime || hover == true ? (
        <>
          <div class="r2card-bottom-btn-before bg-white"></div>{" "}
          <div
            style={style}
            class={twMerge(
              `r2card-bottom-btn-after transition duration-500 font-digi`,
              className,
            )}
          >
            {text}
          </div>
        </>
      ) : (
        text
      )}
    </div>
  );
};

export const RaceBottomActionBtnSm = ({ ...props }) => {
  return (
    <div
      onClick={props.onClick}
      class={twMerge(
        "fc-cs relative xs:w-[5rem] lg:w-[6.5rem] aspect-[88/33] m-[0.5rem]",
        "transition duration-200 cursor-pointer",
        props.cont_cn,
      )}
    >
      <div
        class={twMerge(
          "absolute z-[1] top-0 left-0 w-full h-full",
          "transition duration-500",
        )}
      >
        <img
          className="w-full h-full object-stretch"
          src="/r2_design/btn-round.png"
          alt=""
        />
      </div>
      <div class="absolute left-[15%] z-[3] w-full">{props.children}</div>
    </div>
  );
};

export const RaceR2_EnterPopup = ({
  race,
  trigger_jsx = null,
  qo_rginf = null,
  post_enterrace = null,
}) => {
  const r = race;
  const history = useNavigate();

  const acc = useAccountContext();
  const {
    vault,
    hids: vhids,
    roadmap_post_enter_race,
    bikesob,
    qostaminamap,
  } = acc;
  const {
    acc_config = {},
    s_acc_config,
    g_acc_config,
    bikeslist_hids_show_fn,
  } = acc;
  const t3con = useThirdWebLoginContext();
  const { active_account } = t3con;

  const [enter, set_enter] = useState(false);
  const [refresh, set_refresh] = useState(0);
  const [just_created, set_just_created] = useState(false);

  const openpopup = () => {
    set_enter(true);
    set_refresh((c) => c + 1);
  };

  const closepopup = () => {
    set_enter(false);
  };

  const rid = race.rid;
  const cb = race.cb;
  const c = race.class;
  const payout = race.payout;

  const tocreate_elig =
    !_.isEmpty(r) &&
    r.is_chain === true &&
    r.chain_created !== true &&
    r.version > 1;
  const chain_create_fn = async () => {
    if (!tocreate_elig) return;
    console.log("tocreate_elig", r.is_chain, r.chain_created, r.version);
    let resp = await q_chain_create_race({ rid }).queryFn();
    console.log("tocreate_elig:resp", resp);
  };

  const [mode, set_mode] = useState(getv(acc_config, "last_mode"));
  const [bikelist_hids, hordmap] = useMemo(() => {
    let hs = bikeslist_hids_show_fn({
      hids: vhids,
      mode,
      c: getv(race, "class"),
      cb: getv(race, "cb"),
      rvmode: getv(race, "rvmode"),
    });
    hs = _.filter(hs, (h) => {
      if (h.stamina <= 0) return false;
      if (h.ageing <= 0) return false;
      return true;
    });
    hs = _.map(hs, "hid");
    // console.log("bikelist_hids:fin", hs);
    let ordmap = {};
    for (let i = 0; i < hs.length; i++) {
      ordmap[hs[i]] = i;
    }
    return [hs, ordmap];
  }, [mode, jstr(vhids), jstr(race)]);

  const uses_spstamina = race.uses_spstamina ?? false;
  const uses_stamina = uses_spstamina !== true && race.class != 90;
  // console.log({ rid, uses_spstamina, uses_stamina });

  const [fnloading, set_fnloading] = useState(false);
  const fn_get_loc_valids = async () => {
    // console.log("fn_get_loc_valids:fn");
    let hids = bikelist_hids;
    let staminamap = getv(qostaminamap, "data.result", {});
    // console.log("0.hids", hids);
    if (uses_stamina || uses_spstamina) {
      if (!qostaminamap.isLoading) {
        let diff = moment().diff(moment(qostaminamap.dataUpdatedAt), "seconds");
        if (diff > 30) await qostaminamap.refetch();
      }
      if (qissuccesss(qostaminamap)) {
        // if (_.isEmpty(staminamap)) return [];

        let k = uses_spstamina ? 1 : 0;
        hids = bikelist_hids.filter((hid) => {
          let s = getv(staminamap, `${hid}.${k}`);
          return s > 0;
        });
      }
    }
    if (_.isEmpty(hids)) return [];

    hids = hids.filter((hid) => {
      return !(race.hids || []).includes(hid);
    });
    if (_.isEmpty(hids)) return [];

    hids = _.filter(hids, (hid) => {
      let name = getv(bikesob, `${hid}.name`, null);
      if (nils(name) || name == "Unnamed DNA Splice") return false;
      return true;
    });
    if (_.isEmpty(hids)) return [];

    let ef = getv(race, "r_form.entry_filt");
    let eventtags = getv(race, "eventtags");
    if (!_.isEmpty(eventtags) && eventtags.includes("Trainer")) {
      if (emp(ef?.fno)) ef.fno = { mi: 22, mx: 1000 };
      // if (_.isEmpty(ef?.type)) ef.type = ["trainer"];
      // else ef.type.push("trainer");
    }

    let is_trial = !_.isEmpty(eventtags) && eventtags.includes("Trial");
    let is_free = race.class == 90 && parseFloat(race.fee) == 0;
    if (!is_free && !is_trial) {
      hids = hids.filter((hid) => {
        let is_trainer = getv(bikesob, `${hid}.type`, "") == "trainer";
        return !is_trainer;
      });
    }

    if (emp(ef)) return hids;

    if (!_.isEmpty(ef.fno)) {
      // console.log("ef_filt_fno", ef.fno);
      hids = hids.filter((hid) => {
        let h_fno = getv(bikesob, `${hid}.fno`, null);
        if (nils(h_fno)) return false;
        let mi = getv(ef, "fno.mi", 0);
        let mx = getv(ef, "fno.mx", 0) + 0.1;

        let mat = _.inRange(parseInt(h_fno) ?? null, mi, mx);
        return mat;
      });
    }
    for (let k of ["gender", "type", "element"]) {
      if (!_.isEmpty(ef[k])) {
        // console.log("ef_filt_", k, ef[k]);
        hids = hids.filter((hid) => {
          let h_element = getv(bikesob, `${hid}.${k}`, null);
          return ef[k].includes(h_element);
        });
      }
    }

    let is_me = ef.birthday == "me";
    if (is_me) {
      // console.log("ef_filt_birthday", ef.birthday);
      hids = hids.filter((hid) => {
        let is_maiden = getv(bikesob, `${hid}.is_maiden`, false);
        // console.log("ef_filt_birthday:is_maiden", hid, is_maiden);
        return is_maiden === true;
      });
    }

    let hassp = false;
    if (ef.claim_limit) {
      hassp = true;
    }
    if (hassp) {
      set_fnloading(true);
      let q = await q_open_vault_valid_hs({ vault, hids, rid }).queryFn();
      // console.log("q_open_vault_valid_hs", q);
      hids = _.map(getv(q, "result", []), 0);
      console.log("q_open_vault_valid_hs:valid", hids);
    }

    // console.log("fn_get_loc_valids:end", hids);
    set_fnloading(false);
    return hids;
  };

  // const valid_hids = useMemo(() => {
  const [valid_hids, set_valid_hids] = useState([]);
  useEffect(() => {
    if (!enter) return set_valid_hids([]);
    fn_get_loc_valids().then((resp) => set_valid_hids(resp));
  }, [enter, jstr(qostaminamap), qostaminamap.dataUpdatedAt]);

  const validhs = useMemo(() => {
    let hs = valid_hids.map((hid) => {
      let name = getv(bikesob, `${hid}.name`, `core#${hid}`);
      return [hid, name];
    });
    hs = hs.map((h, i) => ({ hid: h[0], name: h[1], idx: i }));
    hs = _.sortBy(hs, (h) => {
      return hordmap[h.hid];
    });
    return hs;
  }, [jstr(valid_hids), jstr(hordmap)]);
  // }, [qovalids.dataUpdatedAt, jstr(hordmap)]);

  const qvalidenter_err = null;
  // const qvalidenter_err = useMemo(() => {
  //   let err = getv(qovalids, "data.err") ?? null;
  //   return err;
  // }, [qovalids.dataUpdatedAt]);

  // const qshs = useStepQuery({
  //   q_: race.is_arcade == true ? q_arcade_race_hstats : q_hstats,
  //   par_ar: (validhs || []).map((h) => [{ rid, hid: h.hid, cb, class: c }]),
  //   lim: 3,
  // });

  const [enteringerr, set_enteringerr] = useState(null);
  const [entering, set_entering] = useState(null);
  const [entry_ticket, set_entry_ticket] = useState(null);
  const entertimer = useRef(null);

  const is_trial = useMemo(() => {
    let eventtags = getv(race, "eventtags");
    let is_trial = !_.isEmpty(eventtags) && eventtags.includes("Trial");
    return is_trial;
  }, [jstr(race)]);

  const [qotickets] = useQueries([
    q_roadmap_entry_tickets({ vault }, { enabled: !nils(vault) && is_trial }),
  ]);
  const [rem_tickets] = useMemo(() => {
    if (!is_trial) return [];
    let tickets = getv(qotickets, "data.result.tickets", []);
    let rem_tickets = tickets.filter((t) => t.used !== true);
    if (nils(entry_ticket) && !_.isEmpty(rem_tickets)) {
      let rem = _.shuffle(rem_tickets)[0];
      set_entry_ticket(rem);
    }
    return [rem_tickets];
  }, [is_trial, jstr(qotickets), jstr(qotickets.dataUpdatedAt)]);

  const enterbike = async (hid) => {
    if (entertimer.current) clearTimeout(entertimer.current);

    set_enteringerr(null);

    if (entering) return;
    set_entering(hid);

    let ischaincreatable =
      !nils(r.sheetrowid) && r.is_chain == true && !nils(r.chain_created);
    ischaincreatable_block: if (ischaincreatable) {
      console.log({ ischaincreatable });
      const get_rchaindoc = async () => {
        let rchaindoc = await q_chain_racedoc({ rid }).queryFn();
        console.log("get_rchaindoc", rchaindoc);
        return getv(rchaindoc, "result", {});
      };
      const validate_rchaindoc = async (r) => {
        let { chainfee, rfee, token } = r;
        let hasfee = rfee > 0;
        if (!hasfee) return true;
        let diff = chainfee - rfee;
        return diff < 5 && token == "DEZ";
      };
      let rchaindoc = await get_rchaindoc();
      if (!nils(rchaindoc.err) || _.isEmpty(rchaindoc)) {
        let rcreateresp = await q_chain_create_race({ rid }).queryFn();
        console.log("rcreateresp", rcreateresp);
      } else {
        if (validate_rchaindoc(rchaindoc)) break ischaincreatable_block;
      }
      do {
        let rchaindoc = await get_rchaindoc();
        if (validate_rchaindoc(rchaindoc)) break ischaincreatable_block;
        await cdelay(5 * 1e3);
      } while (true);
    }
    // throw new Error("Not implemented");

    const is_chain =
      parseFloat(race.fee) > 0 ||
      parseFloat(race.prize) > 0 ||
      (race.version == 4 && race.toburn == true);
    console.log({ rid, is_chain, version: race.version });

    const post_enter = async (ext = {}) => {
      await cdelay(2000);
      if (post_enterrace) post_enterrace({ rid, hid, date: iso(), ...ext });
      if (qo_rginf) await qo_rginf.refetch();
      if (qostaminamap) await qostaminamap.refetch();
      await cdelay(2000);
      set_entering(null);
      set_enter(false);

      if (entertimer.current) clearTimeout(entertimer.current);
      await roadmap_post_enter_race();
    };

    const fet_enter = async (ext = {}) => {
      try {
        console.log("fet_enter", { rid, hid });
        let resp;

        // if (race.is_chain == true && race.chain_created == false) {
        //   throw new Error("Please wait for the chain to be created");
        // }

        let roadmap_inf = await get_roadmap_status(vault);
        let currtaskid = getv(roadmap_inf, "currtask.id");
        resp = await q_open_enter({ hid, rid, currtaskid, ...ext }).queryFn();

        let done = getv(resp, "result.done");
        let err = getv(resp, "err");
        if (err) throw new Error(err);
        // console.log(resp, err);
        // console.log("q_open_enter", { err, done });
        return true;
      } catch (err) {
        console.log("fet_enter", { rid, hid }, err);
        set_enteringerr(err.message);
        set_entering(null);
        return false;
      }
    };

    try {
      let aumode = localStorage.getItem(tokenaumode_locpath);
      console.log("is_chain", { aumode }, { rid, is_chain });
      if (is_trial && !nils(entry_ticket)) {
        let ext = { entry_ticket: entry_ticket };
        let valid = await fet_enter(ext);
        if (!valid) return;
        await post_enter(ext);
        if (entry_ticket) qotickets.refetch();
      } else if (is_chain) {
        let racestake = null;
        if (aumode == "thirdweb") {
          racestake = { contractAddress: get_racestake_contractAddress(race) };
        } else {
          racestake = await get_racestake_contract({
            version: race.version,
          });
          if (!racestake) throw new Error("races version mismatch");
        }

        const paytokenaddr =
          race.paytoken == "WETH"
            ? contractAddress_list.weth
            : race.paytoken == "DEZ"
              ? contractAddress_list.dez
              : race.paytoken == "BGC"
                ? contractAddress_list.bgc
                : null;

        if (nils(paytokenaddr)) throw new Error("paytoken mismatch");

        const paytokencon =
          aumode == "thirdweb"
            ? await t3_asset_signer(race.paytoken)
            : await mm_asset_signer(null, 20, paytokenaddr);

        let bal = await paytokencon.balanceOf(vault);
        bal = parseFloat(tofeth(bal));
        console.log("bal", bal);

        if (bal < parseFloat(race.fee)) {
          throw new Error("insufficient balance to enter");
        }

        let alw = null;
        if (aumode == "thirdweb") {
          alw = await paytokencon.allowance(vault, racestake.contractAddress);
        } else {
          alw = await paytokencon.allowance(vault, racestake.contractAddress);
        }
        alw = parseFloat(tofeth(alw));
        console.log("alw", alw);

        if (parseFloat(alw) < parseFloat(race.fee)) {
          let approval = null;
          if (aumode == "thirdweb") {
            let toval = Math.max(
              parseFloat(race.fee) * 1.01,
              Math.min(bal * 0.95, parseFloat(race.fee) * 3),
            );
            approval = await t3_contract_call(
              race.paytoken,
              "approve",
              [racestake.contractAddress, toeth(toval)],
              "txn",
              true,
              { active_account },
            );
            console.log("approval", approval);
          } else {
            approval = await paytokencon.approve(
              racestake.contractAddress,
              ethers.parseEther(race.fee.toString()),
            );
            approval = await approval.wait();
            console.log("approval", approval);
          }
          await cdelay(2 * 1e3);
        }

        if (race.version == 1) {
          let befconstresp = await q_logtxnqueue({
            data: {
              type: "before_cont",
              rid,
              hid,
              vault,
              time: iso(),
              hash: null,
            },
          }).queryFn();
          // console.log("befconstresp", befconstresp);
          if (befconstresp.status == "error") {
            set_enteringerr(getv(befconstresp, "err"));
            set_entering(null);
            return;
          }
        }

        if (race.version == 4) {
          if (aumode == "thirdweb") {
            let fbikecon = await t3_asset_signer("core");
            let approved = await fbikecon.isApprovedForAll(
              vault,
              racestake.contractAddress,
            );
            if (!approved) {
              let approval = await t3_contract_call(
                "core",
                "setApprovalForAll",
                [racestake.contractAddress, true],
                "txn",
                true,
                { active_account },
              );
              await approval.wait();
              await cdelay(1000);
            }
          } else {
            let fbikecon = await mm_asset_signer("core");
            let approved = await fbikecon.isApprovedForAll(
              vault,
              racestake.contractAddress,
            );
            if (!approved) {
              let approval = await fbikecon.setApprovalForAll(
                racestake.contractAddress,
                true,
              );
              await approval.wait();
              await cdelay(1000);
            }
          }
        }

        let valid = await fet_enter();
        if (!valid) return;

        let tx = null;
        if (aumode == "thirdweb") {
          tx = await t3_contract_call(
            "racestakev03dez",
            "enterRace",
            [rid, hid],
            "txn",
            false,
            { active_account },
          );
        } else {
          tx = await racestake.enterRace(rid, hid);
        }
        // console.log("entry txn", tx);

        if (tx?.hash) {
          await q_logtxnqueue({
            data: {
              type: "after_cont",
              rid,
              hid,
              vault,
              time: iso(),
              hash: tx.hash,
            },
          }).queryFn();
          await post_enter();
        }
      } else {
        let valid = await fet_enter();
        if (!valid) return;
        await post_enter();
      }
    } catch (err) {
      console.log(err);
      if (err.reason) {
        set_enteringerr(err.reason);
      } else if (err.message) {
        set_enteringerr(err.message);
      } else {
        set_enteringerr(`Opps!! encountered a weird issue`);
      }
      set_entering(null);
      return;
    }
  };

  const rvmode = race.rvmode;
  const entertxt = `Select ${_.capitalize(rvmode)} To Enter ${cb_txt(cb, race.rvmode)} ${_.upperCase(payout)}`;
  const isburn = race.version == 4 && race.toburn == true;

  const [searchtxt, set_searchtxt] = useState(null);
  const filths = useMemo(() => {
    if (nils(searchtxt)) return validhs;
    let sech_hid = parseInt(searchtxt);
    if (nils(sech_hid)) sech_hid = null;
    let sear = _.lowerCase(searchtxt);

    let filt = _.chain(validhs)
      .map((h) => {
        let hname = _.lowerCase(h.name);
        if (!nils(sech_hid) && sech_hid == h.hid) return [h, 1];
        else if (
          !nils(sech_hid) &&
          h.hid.toString().startsWith(sech_hid.toString())
        )
          return [h, 2];
        else if (hname.startsWith(sear)) return [h, 3];
        else if (hname.includes(sear)) return [h, 4];
        else return null;
      })
      .compact()
      .sortBy((e) => e[1])
      .map(0)
      .value();
    console.log("enter filt", filt);
    return filt;
  }, [jstr(validhs), searchtxt]);

  const get_cac_hstats = (hid) => {
    const { class: c, cb } = race;
    let h = bikesob[hid];
    if (!h) return null;
    let keys =
      "hid,name,vault,vault_name,element,gender,type,hex_code,fno".split(",");
    let h0 = {};
    for (let k of keys) {
      h0[k] = h[k];
    }
    h0.hstat = {
      ov: getv(h, `hstats_${rvmode}.${"career"}`),
      cb: getv(h, `hstats_${rvmode}.${cb}`),
    };
    return h0;
  };

  const [st_type, set_st_type] = useState("cb");
  const [st_paid, set_st_paid] = useState("paid");

  const shorted_hs = useMemo(() => {
    let path = `hstat.${st_type}.${st_paid == "paid" ? "paid_" : ""}win_p`;
    let ar = _.chain(filths)
      .map((h0) => {
        let hid = h0.hid;
        let h = get_cac_hstats(hid);
        if (!h) return null;
        return h;
      })
      .compact()
      .sortBy((h) => {
        h.sortval = getv(h, path, 0);
        return -h.sortval;
      })
      .value();
    // console.log("shorted_hs", ar);
    return ar;
  }, [jstr(filths), st_type, st_paid, jstr(bikesob)]);

  const mode_switcher = (
    <CapsuleSwitch
      {...{
        nf: mode,
        set_nf: set_mode,
        options: ["all", "filtered"],
        txt_fn: (a) => _.capitalize(a),
        tag_cn: "xs:w-[5rem] lg:w-[6.5rem] resp-py-1",
      }}
    />
  );

  return (
    <>
      <div
        onClick={(e) => {
          e.preventDefault();
          openpopup();
        }}
        class="cursor-pointer "
      >
        {trigger_jsx}
      </div>

      <PopUp
        wrapcn={"top-[6rem]"}
        innercn={"translate-y-[0%]"}
        openstate={enter}
        overlayclose={false}
        custom_z="z-[2000]"
      >
        <Card
          className={twMerge(
            "bike-enter-selection-card",
            "relative w-[60rem] max-w-[90vw] bg-r2lig/10 border border-acc4",
          )}
        >
          <PopupCloseBtn {...{ closepopup }} />

          <div className="">
            {fnloading || qostaminamap.isLoading ? (
              <>
                <div className="fc-cc">
                  <p className="resp-my-2 resp-text--1 text-acc0">
                    Finding Eligible {_.capitalize(rvmode)} in your Vault....
                  </p>
                  <div class="fr-sc">
                    {mode_switcher}
                    <div class="flex-1"></div>
                  </div>
                  <Loader01c />
                </div>
              </>
            ) : (
              <>
                {!nils(qvalidenter_err) ? (
                  <>
                    <div class="fr-sc">
                      {mode_switcher}
                      <div class="flex-1"></div>
                    </div>
                    <p className="text-center text-red-400">
                      {qvalidenter_err}
                    </p>
                  </>
                ) : _.isEmpty(validhs) ? (
                  <>
                    <div class="fr-sc">
                      {mode_switcher}
                      <div class="flex-1"></div>
                    </div>
                    <p className="text-center text-red-400">
                      No Eligible bikes for this race
                    </p>
                  </>
                ) : (
                  <>
                    <div className="fc-cc">
                      <p className="text-acc0 italic  resp-text-1 resp-my-1">
                        {entertxt}
                      </p>
                      {isburn ? (
                        <p className="text-acc0 italic  resp-text-1 resp-my-1">
                          you are entering a race that{" "}
                          <span class="text-orange-500">BURNS your CORE</span>
                        </p>
                      ) : null}
                    </div>
                    <div class="fr-sc resp-gap-2 resp-text-1">
                      {mode_switcher}
                      <div class="flex-1"></div>
                      <Tag
                        className={
                          "fr-sc resp-gap-1 text-acc0  underline-acc0 underline-offset-2"
                        }
                        onClick={() =>
                          set_st_type((a) => (a !== "cb" ? "cb" : "ov"))
                        }
                      >
                        <FontAwesomeIcon icon={faArrowsUpDown} />
                        <span>
                          {st_type == "ov"
                            ? "Overall"
                            : st_type == "cb"
                              ? `CB${cb}00`
                              : ""}
                        </span>
                      </Tag>

                      <Tag
                        className={
                          "fr-sc resp-gap-1 text-acc0 underline-acc0 underline-offset-2"
                        }
                        onClick={() =>
                          set_st_paid((a) => (a !== "paid" ? "paid" : "all"))
                        }
                      >
                        <FontAwesomeIcon icon={faArrowsUpDown} />
                        <span>{st_paid == "paid" ? "Paid" : "All"}</span>
                      </Tag>
                    </div>
                    {enteringerr && (
                      <p className="resp-my-2 resp-p-2 text-red-400 border border-red-400 rounded-md resp-text--1">
                        {enteringerr}
                      </p>
                    )}

                    <Card className={"resp-p-2 bg-r2dark/20 w-full"}>
                      <div className="fr-cc resp-gap-1 resp-px-1 resp-my-1">
                        <div className="flex-1">
                          <InpText
                            {...{
                              id: `entry-search-race-${rid}`,
                              placeholder: "Search Core",
                              inpprops: {
                                className:
                                  "resp-text-1 font-digi bg-tranparent text-acc0 w-full",
                              },
                              contprops: {
                                className:
                                  "resp-text-1 font-digi bg-r2dark/20 text-acc0 w-full",
                              },
                              setter: (v) => {
                                console.log("setter", v);
                                if (nils(v)) v = null;
                                set_searchtxt(v);
                              },
                            }}
                          />
                        </div>
                      </div>
                      {is_trial == true && !_.isEmpty(rem_tickets) && (
                        <>
                          <div class="fr-sc resp-gap-1">
                            <div class="flex-1"></div>
                            <Tag
                              onClick={() => {
                                if (entry_ticket) {
                                  set_entry_ticket(null);
                                } else {
                                  let rem = _.shuffle(rem_tickets)[0];
                                  set_entry_ticket(rem);
                                }
                              }}
                              className="fr-sc resp-gap-2"
                            >
                              {!nils(entry_ticket) ? (
                                <FontAwesomeIcon
                                  className="resp-text-0 text-green-400"
                                  icon={faCheck}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  className="resp-text-0 text-slate-400"
                                  icon={faSquare}
                                />
                              )}
                              <span class="resp-text-0 font-digi">
                                {`Use Ticket for Free Entry `}
                                <span className="text-acc0">
                                  [remaining: {rem_tickets.length}]
                                </span>
                              </span>
                            </Tag>
                          </div>
                        </>
                      )}
                      <div className="bikes-enter-list w-full xs:h-[60vh] lg:h-[30vh] overflow-auto resp-px-1">
                        {shorted_hs.map((h, idx) => {
                          if (nils(h)) return;
                          let hid = h.hid;
                          let h0 = h;

                          const entertbtn = (
                            <Tag
                              onClick={() => {
                                if (entering == null) enterbike(hid);
                              }}
                              className={twMerge(
                                "bike-enter-btn",
                                "resp-px-4 fr-cc resp-gap-2",
                                nils(entering)
                                  ? "bg-r2lig text-white"
                                  : entering == hid
                                    ? "bg-r2dark text-acc4 shadow-lg shadow-acc4 cursor-wait"
                                    : "bg-r2reg text-lig cursor-not-allowed",
                              )}
                            >
                              {entering == hid && (
                                <>
                                  <Loader01c size="s" />
                                  <span>Entering...</span>
                                </>
                              )}
                              {(nils(entering) || entering !== hid) && (
                                <span>
                                  {`Enter ${_.capitalize(race?.rvmode ?? "bike")}`}
                                </span>
                              )}
                            </Tag>
                          );

                          const msg = g_acc_config(
                            `vaulthconfs.${rvmode}.${hid}.msg`,
                          );
                          const hrow = (
                            <div className="relative">
                              <div class="absolute right-[40%] top-[25%]">
                                <p class="resp-text-1 font-digi">{msg}</p>
                              </div>
                              {!nils(h) ? (
                                <RaceR2_HRow
                                  {...{
                                    r: race,
                                    h,
                                    st_type,
                                    st_paid,
                                    show_entry_confirmation: false,
                                    right_flex_jsx: entertbtn,
                                    cont_props: {
                                      className: "bg-tranparent resp-text--2",
                                      style: {
                                        borderLeft: undefined,
                                        borderRight: undefined,
                                      },
                                    },
                                    arrow_link: true,
                                  }}
                                />
                              ) : (
                                <div className="fr-sc w-full rep-gap-2 resp-p-2">
                                  <Loader01c size="s" />
                                  <div className="fc-ss w-full resp-gap-2">
                                    <span className="font-digi resp-text--3">
                                      {hid}
                                    </span>
                                    <span className="font-digi resp-text-1">
                                      {h0?.name}
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          );

                          const is_trainer = h?.type == "trainer";

                          return (
                            <div
                              key={jstr(h0)}
                              className={twMerge(
                                "bike-row",
                                "bg-r2lig/20 border border-acc4 rounded-md resp-my-2",
                                is_trainer ? "trainer-0" : "",
                              )}
                            >
                              <div className="large-screen xs:hidden lg:block">
                                <div className="fr-cc">
                                  <div className="flex-1">{hrow}</div>
                                </div>
                              </div>
                              <div className="small-screen xs:block lg:hidden">
                                <div className="fc-cc w-full">
                                  <div className="w-full">{hrow}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </Card>
                  </>
                )}
              </>
            )}
          </div>
        </Card>
      </PopUp>
    </>
  );
};

export const RaceR2_FinishedSection = ({
  race: race,
  showresults = false,
  set_showresults,
}) => {
  const { now } = useNowContext();

  const { psearch } = useAppContext();
  const { hids: vhids } = useAccountContext();

  const is_arcade = psearch.is_arcade == "true";

  const r = race;
  const { rid } = r;

  const [rtstatus] = useMemo(() => {
    return get_race_rtstatus(r, now);
  }, [now, jstr(r)]);
  const [qo_result] = useQueries([
    {
      queryKey: ["q_race_result", jstr({ rid, is_arcade })],
      queryFn: async () => {
        if (!_.isEmpty(r.result)) {
          return {
            status: "success",
            result: {
              rid,
              result: r.result,
            },
          };
        } else if (is_arcade) {
          return { status: "success", result: { results: [] } };
        } else {
          let api = `${btbk}/fbike/races/race_result`;
          let resp = await fpost(api, { rid });
          // console.log("fet", resp);
          return resp;
        }
      },
      enabled: ["live", "finished"].includes(rtstatus),
    },
  ]);

  const pos_hs_order = useMemo(() => {
    let resp = getv(qo_result, "data.result");
    // console.log("got result", resp);
    return resp?.result || [];
  }, [r.rid, qo_result.dataUpdatedAt]);

  const rvob = r.racing_vaults;
  const cvob = r.current_vaults;
  const vnob = r.vaults_names;

  const vault_bike_bgcn = "bg-r2lig/20 shadow-md shadow-acc4 border-r2lig";
  const bike_over_cmap = useMemo(() => {
    let o = {};
    let hteam_info_cnmap = {};
    if (r.payout == "tag" && !_.isEmpty(r.teams_ar)) {
      for (let [teamk, [h1, h2]] of r.teams_ar) {
        let cn = `bg-${teamk}-500/20 border-2 border-${teamk}-500`;
        let inf = {
          cn,
          top_inf_jsx: (
            <span className={`italic resp-text--1`}>
              {`Team ${_.capitalize(teamk)}`}
            </span>
          ),
        };
        hteam_info_cnmap[h1] = inf;
        hteam_info_cnmap[h2] = inf;
      }
    }

    if (r.is_team == true) {
      let team_ob = _.keyBy(r.teamsmap, "k");
      for (let [k, v] of Object.entries(team_ob)) {
        let inf = {
          cn: `bg-${v.color}-500/40`,
          top_inf_jsx: (
            <span className={`italic resp-text--1`}>
              {`Team ${_.capitalize(v.k)}`}
            </span>
          ),
        };
        team_ob[k].inf = inf;
      }
      for (let hid of r.hids) {
        let k = getv(r, `hteammap.${hid}`);
        hteam_info_cnmap[hid] = team_ob[k]?.inf;
      }
    }

    for (let hid of r.hids) {
      let is_vhid = vhids.includes(hid);
      if (hteam_info_cnmap[hid]) {
        o[hid] = hteam_info_cnmap[hid];
      } else if (is_vhid) {
        o[hid] = { cn: vault_bike_bgcn };
      } else {
        o[hid] = { cn: "" };
      }
    }
    return o;
  }, [jstr(r), jstr(vhids)]);

  if (nils(race)) return <></>;
  return (
    <ErrorBoundary>
      <div key={race.rid} class="p-2 rounded-md card-dark-bg">
        <div className="relative">
          <div
            className={twMerge(
              "absolute w-full h-full z-20 box-border",
              showresults == false
                ? "bg-gradient-to-b from-r2dark/20 to-r2lig/20"
                : "bg-tranparent z-0",
            )}
          >
            {showresults == false && (
              <div className="fr-cc w-full h-full">
                <div className="aboluste bottom-[1rem]">
                  <Tag
                    onClick={() => {
                      set_showresults(true);
                    }}
                    className="bg-dark text-r2lig border border-r2lig resp-px-4 font-digi resp-text-1"
                  >
                    Show Results
                  </Tag>
                </div>
              </div>
            )}
          </div>

          {/*
          <p className="resp-text--1 font-mon">
            {_.chain(r.result)
              .map((h) => `${h.pos}: #${h.hid}- ${getv(hsob, `${h.hid}.name`)}`)
              .join(", ")
              .value()}
          </p>
           */}

          <div className="resp-p-4 relative">
            <div
              className={twMerge(
                "grid resp-gap-2 z-10 xs:grid-cols-1",
                r.rgate >= 6 ? "lg:grid-cols-3" : "",
                r.rgate >= 2 ? "lg:grid-cols-2" : "",
              )}
            >
              {qo_result.isLoading ? (
                <div class="w-max mx-auto">
                  <Loader01c />
                </div>
              ) : (
                (pos_hs_order ?? []).map((hp) => {
                  let hid = hp.hid;
                  let is_vhhid = vhids.includes(hid);

                  // let h = hsob[hid];
                  let h = hp;
                  if (nils(h)) return <></>;

                  hp.star =
                    ((r.bluestars || []).includes(hid) ? 2 : 0) +
                    ((r.yellowstars || []).includes(hid) ? 3 : 0);

                  const c_vau = getv(cvob, hid) ?? null;
                  const c_vauname = nils(c_vau) ? "" : getv(vnob, c_vau);
                  const r_vau = getv(rvob, hid) ?? null;
                  const r_vauname = nils(r_vau) ? "" : getv(vnob, r_vau);

                  return (
                    <ErrorBoundary>
                      <div
                        className={twMerge(
                          "bg-r2dark/60 resp-p-2 rounded-md border-2 border-r2lig",
                          showresults !== true
                            ? ""
                            : (getv(bike_over_cmap, `${hid}.cn`) ?? ""),

                          showresults && !nils(h.bg_card) ? h.bg_card : "",
                        )}
                      >
                        <div className="fr-sc resp-gap-2 resp-my-1">
                          <PosTag className={"font-digi"} pos={hp.pos} />
                          <div className="flex-1"></div>
                          <Tag
                            className={twMerge(
                              showresults ? "opacity-100" : "opacity-0",
                              "font-digi",
                              hp.pos == 1 ? "text-green-300" : "",
                            )}
                          >
                            {dec(hp.time, 2)}sec
                          </Tag>
                        </div>

                        <ErrorBoundary>
                          <div className="fr-sc resp-gap-2 resp-my-1 w-full">
                            <Link to={`/bike/${hid}`}>
                              <RVImg
                                rvmode={r.rvmode}
                                hex_code={showresults ? h.hex_code : "FFFFFF"}
                              />
                            </Link>
                            <div className="fc-ss flex-1 resp-gap-1">
                              <Link className="w-full" to={`/bike/${hid}`}>
                                <div
                                  styleName={twMerge("fr-ss resp-gap-1 w-full")}
                                >
                                  <span
                                    className={twMerge(
                                      showresults
                                        ? "text-white "
                                        : "text-transparent bg-dark rounded-sm",
                                      "transition duration-300 resp-text--1 font-digi",
                                    )}
                                  >
                                    {h.replaced == true ? (
                                      <span className="">
                                        {`#${h.type}-${h.hid}`}
                                      </span>
                                    ) : (
                                      <span>#{h.hid}</span>
                                    )}
                                  </span>
                                  <div className="flex-1"></div>
                                </div>
                              </Link>
                              <Link className="w-full" to={`/bike/${hid}`}>
                                <div
                                  styleName={twMerge("fr-ss resp-gap-1 w-full")}
                                >
                                  <span
                                    className={twMerge(
                                      showresults
                                        ? "text-white "
                                        : "text-transparent bg-dark rounded-sm",
                                      "transition duration-300 resp-text-1 font-digi",
                                    )}
                                  >
                                    {h.name}
                                  </span>
                                  <div className="flex-1"></div>
                                </div>
                              </Link>
                              <div
                                className={twMerge(
                                  "fr-ss resp-gap-2 w-full",
                                  showresults
                                    ? "text-acc4 "
                                    : "text-transparent bg-dark rounded-sm",
                                )}
                              >
                                <ErrorBoundary>
                                  <div className="flex-1 fc-ss">
                                    {r_vauname == c_vauname ? (
                                      <FinishCardVaultName
                                        {...{
                                          vault: r_vau,
                                          vault_name: r_vauname,
                                          show: showresults,
                                          cn: "text-acc0",
                                        }}
                                      />
                                    ) : (
                                      <>
                                        <FinishCardVaultName
                                          {...{
                                            vault: r_vau,
                                            vault_name: `Racing: ${r_vauname}`,
                                            show: showresults,
                                            cn: "text-acc0",
                                          }}
                                        />
                                        <FinishCardVaultName
                                          {...{
                                            vault: c_vau,
                                            vault_name: `LiveOwner: ${c_vauname}`,
                                            show: showresults,
                                            cn: "text-slate-400",
                                          }}
                                        />
                                      </>
                                    )}
                                  </div>
                                </ErrorBoundary>
                              </div>
                            </div>

                            <div className="flex flex-col justify-start items-end">
                              <div class="fr-sc resp-gap-2">
                                {showresults &&
                                  !nils(h.agid) &&
                                  !nils(h.faction) && (
                                    <ToolTip
                                      message={
                                        <p class="min-w-[10rem] resp-text--2">{`#${h.agid}-${h.agent_name}`}</p>
                                      }
                                    >
                                      <div class="aspect-[2/1] xs:w-[0.8rem] lg:w-[1.6rem]">
                                        <Img img={faction_img(h.faction)} />
                                      </div>
                                    </ToolTip>
                                  )}
                                {showresults && <BY_Star star={hp.star} />}
                              </div>
                              <div
                                className={twMerge(
                                  "fr-cc",
                                  showresults
                                    ? "text-acc4 "
                                    : "text-transparent bg-dark rounded-sm",
                                )}
                              >
                                <span className="resp-text--1">F{h.fno}</span>
                                <span className="resp-text--1">/</span>
                                <span className="resp-text--1">
                                  {_.capitalize(h.type)}
                                </span>
                              </div>
                              {showresults &&
                                getv(bike_over_cmap, `${hid}.top_inf_jsx`)}
                            </div>
                          </div>
                        </ErrorBoundary>

                        <ErrorBoundary>
                          <div
                            className={twMerge(
                              "fr-sc resp-gap-2 mt-1 resp-text-0",
                              showresults ? "" : "opacity-0",
                            )}
                          >
                            <div className="flex-1"></div>
                            <div class="fc-ss">
                              {hp.prize_eth > 0 && (
                                <>
                                  <div class="fr-sc resp-gap-2">
                                    <span className="font-bold">Prize:</span>
                                    <div className="fr-sc resp-gap-1 text-green-300">
                                      <FontAwesomeIcon icon={faUsd} />
                                      <span>{dec(hp.prize_usd, 2)}</span>
                                    </div>
                                    <div className="fr-sc resp-gap-1 text-white">
                                      <TokenIcon
                                        token={r.paytoken ?? "WETH"}
                                        size="xs"
                                      />
                                      <span>
                                        {dec(
                                          hp.prize_eth,
                                          tokdecn(r.paytoken ?? "WETH"),
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )}
                              {parseFloat(hp.prize_tp) > 0 &&
                                !nils(parseFloat(hp.prize_tp)) && (
                                  <>
                                    <div class="fr-sc resp-gap-2">
                                      <span className="font-bold">Pts:</span>
                                      <div className="fr-sc resp-gap-1 text-white">
                                        <TokenIcon token={"TP"} size="xs" />
                                        <span className="text-purple-300">
                                          {hp.prize_tp.toString()}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                )}
                            </div>
                          </div>

                          <div
                            className={twMerge(
                              "fr-sc resp-gap-2 mt-1 resp-text-0",
                              showresults ? "" : "opacity-0",
                            )}
                          >
                            <div className="flex-1"></div>
                            {hp.adv_points > 0 && (
                              <div className="fr-sc resp-gap-1 text-white">
                                <span className="font-bold">Advance:</span>
                                <span className="text-acc4">{`+${dec(hp.adv_points, 2)} pts`}</span>
                              </div>
                            )}
                          </div>
                        </ErrorBoundary>
                      </div>
                    </ErrorBoundary>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export const EventTag = ({ tag = null, efil = {}, race }) => {
  let jsx = useMemo(() => {
    // console.log("tag", tag);
    if (tag == "Progressive") {
      return (
        <Tag className="transform -skew-x-12 fr-sc resp-gap-2 text-acc0">
          <FontAwesomeIcon
            icon={faArrowUp}
            className="pulse-anim text-orange-500 resp-text-2"
          />
          <span className="text-orange-500 resp-text-1">Progressive</span>
        </Tag>
      );
    }
    if (tag == "Burn") {
      return (
        <Tag className="transform -skew-x-12 fr-sc resp-gap-2 text-acc0">
          <FontAwesomeIcon
            icon={faFire}
            className="pulse-anim text-orange-500 resp-text-2"
          />
          <span className="text-orange-500 resp-text-1">BURN</span>
        </Tag>
      );
    } else if (
      /((F[\d]+-[\d]+)|(F[\d]+\+))/i.exec(tag) &&
      !_.isEmpty(efil?.fno)
    ) {
      return (
        <Tag className="transform  fr-sc resp-gap-2 bg-transparent text-acc0">
          {!_.isEmpty(efil.fno) && _.isObject(efil.fno) && (
            <span className="">
              {!nils(efil.fno.mi) && !nils(efil.fno.mx)
                ? `F${efil.fno.mi}-${efil.fno.mx}`
                : !nils(efil.fno.mi) && nils(efil.fno.mx)
                  ? `F${efil.fno.mi}+`
                  : !nils(efil.fno.mx) && nils(efil.fno.mi)
                    ? `F${efil.fno.mx}-`
                    : ""}
            </span>
          )}
          {!_.isEmpty(efil.fno) &&
            _.isArray(efil.fno) &&
            efil.fno.map((f) => <span className="resp-text-1">{`F${f}`}</span>)}
        </Tag>
      );
    } else if (["male", "female"].includes(tag.toLowerCase())) {
      let el = tag.toLowerCase();
      return (
        <Tag
          className={twMerge(
            "transform  fr-sc resp-gap-1",
            gendermap[el]?.text,
          )}
        >
          <FontAwesomeIcon icon={gendermap[el]?.icon} />
          <span>{_.capitalize(tag)}</span>
        </Tag>
      );
    } else if (
      ["earth", "water", "fire", "metal"].includes(tag.toLowerCase())
    ) {
      let el = tag.toLowerCase();
      return (
        <Tag
          className={twMerge(
            "transform  fr-sc resp-gap-1",
            elementmap[el]?.text,
          )}
        >
          <FontAwesomeIcon icon={elementmap[el]?.icon} />
          <span>{_.capitalize(tag)}</span>
        </Tag>
      );
    } else if (
      ["genesis", "morphed", "freak", "xclass"].includes(tag.toLowerCase())
    ) {
      let ty = tag.toLowerCase();
      return (
        <Tag
          className={twMerge("transform  fr-sc resp-gap-1", "text-slate-300")}
        >
          <span>{_.capitalize(ty)}</span>
        </Tag>
      );
    } else if (tag == "Birthday") {
      return (
        <>
          <span>Birthday</span>
          <span>{efil.birthday.mi}</span>
          <span>{efil.birthday.mx ?? ""}</span>
        </>
      );
    } else if (tag.startsWith("Skin") && !nils(efil.skin)) {
      return (
        <>
          {efil.skin.by == "any" && (
            <Tag className="bg-orange-500 text-white">{"SKIN: Any"}</Tag>
          )}
          {["rarity", "name", "pack"].includes(efil.skin?.by) && (
            <>
              <Tag className="bg-orange-500 text-white">
                {"SKIN:"}
                {_.capitalize(efil.skin?.by)}
              </Tag>
              {efil.skin?.ar?.map((e) => {
                return (
                  <span className="text-orange-500 underline underline-orange-500 underline-offset-2 italic px-1 resp-text--2">
                    {e}
                  </span>
                );
              })}
            </>
          )}
        </>
      );
    } else if (tag.startsWith("CLM")) {
      return <Tag className="fr-sc text-blue-300 ">{tag}</Tag>;
      return (
        <>
          <Tag className="text-blue-300 resp-text--1 underline underline-blye-300 underline-offset-4">{`Claim Limit: ${parseFloat(
            efil.claim_limit,
          ).toFixed(4)}WETH`}</Tag>
        </>
      );
    } else if (tag == "Trainer") {
      return <Tag className="fr-sc text-yellow-400 ">{tag}</Tag>;
    } else if (tag == "ME") {
      return <Tag className="fr-sc text-orange-400 ">{tag}</Tag>;
    } else if (tag == "Trail Points" || tag == "TP Points") {
      // console.log("race", race);
      const pcardcn = "bg-r2dark/60 backdrop-blur-md";
      return (
        <Dropdown
          wrapcn=""
          trigger={
            <div className=" text-slate-200 resp-text--2 font-digi fr-cc resp-gap-2">
              <span>Trail Points</span>
            </div>
          }
          dropcn={"w-max top-[2rem] right-0"}
        >
          {!_.isEmpty(race?.pts_prize_map) && (
            <Card className={twMerge(pcardcn, " w-full")}>
              <div className="grid grid-cols-2 resp-gap-2 resp-text--2">
                {_.entries(race.pts_prize_map).map((e) => {
                  return (
                    <>
                      <PosTag
                        pos={e[0]}
                        className="resp-text--2 m-0 resp-py-1"
                      />
                      <div className="flex flex-row justify-end items-center text-white resp-gap-1">
                        <span>{e[1].toString()}</span>
                        <TokenIcon token={"TP"} size="xs" />
                      </div>
                    </>
                  );
                })}
              </div>
            </Card>
          )}
        </Dropdown>
      );
    } else {
      return <Tag className="fr-sc text-acc0/70 ">{tag}</Tag>;
    }
  }, [tag, jstr(efil), jstr(race)]);
  return <div className="fr-sc resp-gap-0">{jsx}</div>;
};
export const R2_EventTag = EventTag;

export const RaceR2_Watching2D_Section = ({
  race,
  hids,
  set_watching,
  watching,
}) => {
  const { now } = useNowContext();

  const r = race;
  const { rid, cb, class: c } = r;
  const is_arcade = r.is_arcade == true;

  const [watching_st, set_watching_st] = useState(null);

  const [rtstatus, rem_st, rem_ed] = useMemo(() => {
    let e = get_race_rtstatus(r, now);
    return e;
  }, [now, jstr(r)]);

  const is_roundraces = useMemo(() => {
    if (nils(race)) return null;
    if (
      ["sit_n_go", "rounds"].includes(race.format) &&
      ["live", "scheduled", "finished"].includes(race.status)
    )
      return true;
    return false;
  }, [jstr(race)]);

  useEffect(() => {
    if (nils(r)) return;
    if (is_roundraces !== false) return;
    if (rtstatus == "live") {
      set_watching(true);
      set_watching_st(nano(r.start_time));
    }
  }, [rtstatus, is_roundraces]);

  const qs_hs_enabled = !nils(c) && !nils(cb) && rtstatus !== "open";
  const qs_hs = useStepQuery({
    q_: is_arcade ? q_arcade_race_hstats : q_hstats,
    par_ar: (hids || []).map((hid) => [
      { rid, hid, cb, class: c, rvmode: r?.rvmode },
      { enabled: qs_hs_enabled },
    ]),
    lim: 3,
  });
  const hsob = useMemo(() => {
    const hsob = {};
    if (!qs_hs_enabled) return {};
    for (let i = 0; i < r?.hids.length; i++) {
      let q = qs_hs.qs[i];
      let hid = r.hids[i];
      let d = getv(q, "data.result");
      if (nils(d)) continue;

      if (race.is_team == true && r.teamsmap) {
        let team = _.find(r?.teamsmap || [], (t) => t.hids.includes(hid));
        if (nils(team)) continue;
        d.team = team;
        // d.color = team.k == "A" ? "rvage-red" : "race-blue";
        d.bg_card = team.k == "A" ? "bg-blue-600/40" : "bg-red-600/40";
        d.dot_hex = team.k == "A" ? "0000FF" : "FF0000";
      }

      if (race.is_half_team == true && r.teamsmap) {
        let team = _.find(r?.teamsmap || [], (t) => t.hids.includes(hid));
        if (nils(team)) continue;
        d.team = team;
        // d.color = team.k == "A" ? "rvage-red" : "race-blue";
        d.bg_card = team.k == "A" ? "bg-blue-600/40" : "bg-red-600/40";
        d.dot_hex = team.k == "A" ? "0000FF" : "FF0000";
      }

      hsob[hid] = d;
    }
    // console.log("hsob", hsob);
    return hsob;
  }, [jstr(_.map(qs_hs.qs, "dataUpdatedAt")), jstr(r)]);

  const [qo_racerun] = useQueries([
    is_arcade
      ? q_arcade_racerun({ rid })
      : q_racerun(
          { rid },
          {
            enabled:
              rtstatus == "live" ||
              // rtstatus == "finished" ||
              (["live", "finished"].includes(rtstatus) && watching == true),
          },
        ),
  ]);
  const racerun = useMemo(() => {
    let d = getv(qo_racerun, "data.result");
    if (nils(d)) return null;
    d = base64_to_json(d);
    // console.log("racerun data", d);
    return d;
  }, [qo_racerun.dataUpdatedAt]);

  useEffect(() => {
    if (nils(r)) return;

    if (qissuccesss(qo_racerun)) {
      if (nils(watching_st) && now > nano(r.start_time)) {
        let sttime = nano(moment().add(5, "seconds").toISOString());
        set_watching_st(sttime);
      }
    }

    if (watching == false) {
      set_watching_st(null);
    }
  }, [watching, jstr(r), qo_racerun.dataUpdatedAt, watching_st]);

  const is_subround = useMemo(() => {
    if (nils(race)) return false;
    if (["sit_n_go_subround", "sub_rounds"].includes(race.format)) return true;
    return false;
  }, [jstr(race)]);

  const { hids: vhids } = useAccountContext();

  return (
    <div>
      {qo_racerun.isLoading && <Loader01c size="s" />}
      {
        <RacePage_Run
          {...{
            race: race,
            racerun,
            hids,
            vhids,
            hsdetsob: hsob,

            set_watching: watching,
            set_watching2d: set_watching,

            watching2d_st: watching_st,
            set_watching2d_st: set_watching_st,

            showrun: qissuccesss(qo_racerun),
          }}
        />
      }
    </div>
  );
};

export const RectBtn = (props) => {
  return (
    <div
      {...props}
      class={twMerge(
        "fc-cs relative w-[10rem] aspect-[278/33]",
        props.cont_cn,
        "transition duration-200 cursor-pointer",
        // props.active ? "scale-x-[1.1]" : "scale-x-[0]",
      )}
    >
      <div
        class={twMerge(
          "absolute z-1 top-0 left-0 w-full h-full",
          "transition duration-500",
        )}
      >
        <img
          className="w-full h-full object-stretch"
          src="/r2_design/rect-btn-sm-long.png"
          alt=""
        />
      </div>
      <div class="absolute left-[0%]  z-2 w-full">{props.children}</div>
    </div>
  );
};

export const RectBtn_SMLong = (props) => {
  return (
    <div
      {...props}
      class={twMerge(
        "fc-cs relative w-[10rem] aspect-[278/33]",
        props.cont_cn,
        "transition duration-200 cursor-pointer",
        // props.active ? "scale-x-[1.1]" : "scale-x-[0]",
      )}
    >
      <div
        class={twMerge(
          "absolute z-1 top-0 left-0 w-full h-full",
          "transition duration-500",
        )}
      >
        <img
          className="w-full h-full object-stretch"
          src="/r2_design/rect-btn-sm-long.png"
          alt=""
        />
      </div>
      <div class="absolute left-[0%]  z-2 w-full">
        <div class="fr-cc w-full">
          <span
            className={twMerge(
              "resp-text-1 font-bold",
              props.active ? "italic" : "",
            )}
          >
            {props.text}
          </span>
        </div>
      </div>
    </div>
  );
};

export const active_cn_map = {
  default: (active, op) => {
    if (!active) return "bg-r2dark/60 border border-acc4";
    return `shadow shadow-white transform text-white bg-r2lig/40 -skew-x-12`;
  },
  element: (active, op) => {
    if (!active) return "bg-r2dark/60 border border-acc4";
    return `shadow shadow-white transform text-white ${elementmap[op]?.bg} -skew-x-12`;
  },
  gender: (active, op) => {
    if (!active) return "bg-r2dark/60 border border-acc4";
    return `shadow shadow-white transform text-white ${gendermap[op]?.bg} -skew-x-12`;
  },
};

export const ContactTag2 = ({ redirect, img, txt = "" }) => {
  return (
    <Link to={redirect} target="_blank">
      <div class="resp-my-2 fr-sc resp-gap-2 ">
        <div class="img-obey-cont xs:w-[0.8rem] lg:w-[2rem] aspect-[1/1]">
          <img src={img} alt="" />
        </div>
        <div className="resp-text--1">{txt}</div>
      </div>
    </Link>
  );
};

export const SplitRaceNameView = ({
  format,
  race_name: rn,
  n = 25,
  className = "",
}) => {
  const is_roundtype = [
    "sub_rounds",
    "rounds",
    "bounty",
    "sub_bounty",
  ].includes(format);
  const rn2 = useMemo(() => {
    // console.log("rn", format, rn);
    if (!is_roundtype) return null;
    let mat = null;
    let reg = /(.*)\s(Finals|Semi-Finals|FINALS|Round-[\d])\s?(\[Set-[\w]\])?/;
    if ((mat = reg.exec(rn))) {
      let [a, b, c] = mat.slice(1);
      // console.log("mat", [a, b, c]);
      return [a, b, c];
    }
    return null;
  }, [rn, is_roundtype]);
  return (
    <div className={twMerge("fc-ss resp-text-1 font-digi", className)}>
      {is_roundtype && rn2 ? (
        <>
          <span>{trim_n(rn2[0], n)}</span>
          <div class="fr-sc resp-gap-2">
            <span className="text-acc4">{rn2[1]}</span>
            <span className="text-white">{rn2[2]}</span>
          </div>
        </>
      ) : (
        <>
          <span>{trim_n(rn, n)}</span>
        </>
      )}
    </div>
  );
};

export const season_cbs = [9, 12, 16, 20, 23];

export const StatType_Switches = ({
  st_type,
  set_st_type,
  st_paid,
  set_st_paid,
  cb,
}) => {
  return (
    <div class="fr-sc resp-gap-2 resp-text-1">
      <div class="flex-1"></div>
      <Tag
        className={
          "fr-sc resp-gap-1 text-acc0  underline-acc0 underline-offset-2"
        }
        onClick={() => set_st_type((a) => (a !== "cb" ? "cb" : "ov"))}
      >
        <FontAwesomeIcon icon={faArrowsUpDown} />
        <span>
          {st_type == "ov" ? "Overall" : st_type == "cb" ? `CB${cb}00` : ""}
        </span>
      </Tag>

      <Tag
        className={
          "fr-sc resp-gap-1 text-acc0 underline-acc0 underline-offset-2"
        }
        onClick={() => set_st_paid((a) => (a !== "paid" ? "paid" : "all"))}
      >
        <FontAwesomeIcon icon={faArrowsUpDown} />
        <span>{st_paid == "paid" ? "Paid" : "All"}</span>
      </Tag>
    </div>
  );
};

export const FinishCardVaultName = ({ vault, vault_name, cn, show }) => {
  return (
    <Link to={`/vault/${vault}`}>
      <p
        className={twMerge(
          "transition duration-300 resp-text--3 font-digit",
          show
            ? cn
            : "text-transparent w-[10rem] xs:min-h-[0.6rem] lg:min-h-[1rem]",
        )}
      >
        {vault_name}
      </p>
    </Link>
  );
};

export const get_racestake_contractAddress = ({ version }) => {
  const conaddr =
    version == 1
      ? contractAddress_list.racestake
      : version == 2
        ? contractAddress_list.racestakev02
        : version == 3
          ? contractAddress_list.racestakev03dez
          : version == 4
            ? contractAddress_list.racestakev04bgc
            : null;
  return conaddr;
};

export const get_racestake_contract = async ({ version, ...ext }) => {
  const racestake =
    version == 1
      ? await RaceStake.get_contract(ext)
      : version == 2
        ? await RaceStakeV02.get_contract(ext)
        : version == 3
          ? await RaceStakeV03_DEZ.get_contract(ext)
          : version == 4
            ? await RaceStakeV04_BGC.get_contract(ext)
            : null;
  return racestake;
};

export const get_racestake_key = ({ version }) => {
  const k =
    version == 1
      ? "racestake"
      : version == 2
        ? "racestakev02"
        : version == 3
          ? "racestakev03dez"
          : version == 4
            ? "racestakev04bgc"
            : null;
  return k;
};
